export default {
    brandSeo: {
        pageTitle: '{title} عبر Miral AI',
        toolDescription: 'على Miral AI، {description}',
        sectionTitle: '{title} باستخدام Miral AI',
        faqTitle: '{title} على Miral AI',
        toolFreeTrialCta: 'جرّب هذه الأداة مجاناً على Miral AI',
        toolProcessCta: '{action} مجاناً',
        imageFaqs: [
            { q: 'هل يمكنني تجربة إنشاء الصور مجاناً على Miral؟', a: 'نعم. سجّل في Miral AI لتحصل على أرصدة مجانية وتجرب إنشاء الصور. تستهلك كل نتيجة الأرصدة المطلوبة للنموذج الذي تختاره.' },
            { q: 'لماذا أنشئ الصور باستخدام Miral AI؟', a: 'يجمع Miral AI نماذج الصور الرائدة في مكان واحد لتتمكن من مقارنة القدرات ومواصلة الإبداع دون التنقل بين منصات متعددة.' }
        ],
        toolFaqs: [
            { q: 'هل يمكنني تجربة أداة Miral AI هذه مجاناً؟', a: 'نعم. سجّل الدخول إلى Miral AI لبدء تجربة مجانية. يعتمد الاستخدام على حدود الحساب ولا تعني التجربة استخداماً مجانياً غير محدود.' },
            { q: 'لماذا أستخدم أدوات الإبداع في Miral AI؟', a: 'يجمع Miral AI إنشاء الصور وأدوات التحرير العملية في منصة واحدة لتتمكن من الإنشاء والمعالجة وتنزيل النتائج ضمن سير عمل واحد.' }
        ]
    },
    common: {
        loading: 'جاري التحميل...',
        error: 'حدث خطأ',
        success: 'تم بنجاح',
        confirm: 'موافق',
        prev: 'السابق',
        next: 'التالي',
        optional: 'اختياري',
        remove: 'إزالة',
        generate: 'توليد',
        generating: 'جاري التوليد...',
        required: 'مطلوب',
        generateFailedContactSupport: 'فشل التوليد. يرجى المحاولة مرة أخرى أو الاتصال بالدعم!',
        localMediaTransferFailed:
            'عدم استقرار الشبكة أدى إلى مقاطعة نقل الخدمة أو التفاعل. تم إيقاف التوليد. يرجى المحاولة مرة أخرى أو الاتصال بالدعم.',
        errorDetails: 'تفاصيل الخطأ',
        tryAgainOrContactSupportTail: ' يرجى المحاولة مرة أخرى أو الاتصال بالدعم!',
        errorCategoryImageSizeInvalid: 'حجم الصورة لا يلبي المتطلبات. يرجى رفع صورة صالحة',
        errorCategoryOutputEmptyOrSensitive: 'تم حظر التوليد بواسطة قواعد السلامة أو لم ينتج أي مخرجات. يرجى تعديل الوصف/الصورة المرجعية',
        errorCategoryUpstreamBusy: 'الخدمة مشغولة حالياً',
        errorCategoryAiNetworkError: 'خطأ في اتصال الشبكة. يرجى التحقق من شبكتك',
        errorCategoryAiTimeout: 'انتهت مهلة طلب الذكاء الاصطناعي. قد تكون الشبكة غير مستقرة',
        close: 'إغلاق',
        leaveConfirmTitle: 'تذكير ودي',
        leaveConfirmMessage: 'عمل الذكاء الاصطناعي لا يزال قيد التوليد. لن يؤثر تبديل الصفحات على التقدم. يمكنك التحقق من الأعمال قيد المعالجة أو المكتملة في [حسابي - أعمالي].\nهل أنت متأكد أنك تريد المغادرة؟',
        leaveConfirmConfirm: 'مغادرة الصفحة',
        leaveConfirmCancel: 'البقاء هنا',
        genDotIdle: 'لا توجد مهمة توليد',
        genDotActive: 'التوليد قيد التقدم، يرجى عدم إغلاق المتصفح',
        genRecoveryTimeout: 'انتهت مهلة التوليد أو تم إغلاق الصفحة',
        genRecoveryInterrupted: 'تم مقاطعة التوليد بتحديث الصفحة'
    },
    api: {
        errors: {
            requestFailed: 'فشل الطلب',
            badRequest: 'طلب غير صالح',
            unauthorized: 'غير مصرح، يرجى تسجيل الدخول مرة أخرى',
            forbidden: 'محظور',
            notFound: 'المورد غير موجود',
            serverError: 'خطأ داخلي في الخادم',
            timeout: 'انتهت مهلة الطلب، يرجى المحاولة مرة أخرى',
            networkError: 'خطأ في الشبكة، يرجى التحقق من اتصالك',
            sessionExpired: 'انتهت الجلسة، يرجى تسجيل الدخول مرة أخرى',
            operationFailed: 'فشلت العملية!'
        }
    },
    nav: {
        home: 'الرئيسية',
        models: 'نماذج الذكاء الاصطناعي',
        pricing: 'الأسعار',
        faq: 'الأسئلة الشائعة',
        login: 'تسجيل الدخول',
        signup: 'ترقية',
        register: 'تسجيل',
        email: 'البريد الإلكتروني',
        logout: 'تسجيل الخروج',
        help: 'المساعدة',
        profile: 'الملف الشخصي',
        myWorks: 'أعمالي',
        username: 'اسم المستخدم',
        password: 'كلمة المرور',
        confirmPassword: 'تأكيد كلمة المرور',
        processing: 'جاري المعالجة...',
        haveAccount: 'لديك حساب بالفعل؟',
        noAccount: "ليس لديك حساب؟",
        orContinueWith: 'أو المتابعة باستخدام',
        loginFailed: 'فشل تسجيل الدخول، يرجى المحاولة مرة أخرى',
        registerFailed: 'فشل التسجيل، يرجى المحاولة مرة أخرى',
        fillRequired: 'يرجى ملء جميع الحقول المطلوبة',
        passwordMismatch: 'كلمات المرور غير متطابقة',
        passwordTooShort: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل',
        googleNotLoaded: 'لم يتم تحميل خدمة تسجيل الدخول عبر Google، يرجى تحديث الصفحة',
        googleInitFailed: 'فشل تهيئة تسجيل الدخول عبر Google',
        googleUserInfoFailed: 'تعذر الحصول على معلومات المستخدم',
        googleCancelled: 'تم إلغاء تسجيل الدخول عبر Google',
        codeLoginHint: 'أدخل بريدك الإلكتروني، سنرسل لك رمز تحقق',
        verificationCode: 'رمز التحقق',
        sendCode: 'إرسال الرمز',
        resendCode: 'إعادة الإرسال',
        verifyAndLogin: 'تحقق وتسجيل الدخول',
        enterEmail: 'يرجى إدخال عنوان بريدك الإلكتروني',
        invalidEmail: 'يرجى إدخال عنوان بريد إلكتروني صالح',
        sendCodeFailed: 'فشل إرسال رمز التحقق، يرجى المحاولة مرة أخرى',
        checkSpamFolder: 'لم تجد البريد الإلكتروني؟ تحقق من مجلد الرسائل غير المرغوب فيها',
        enterValidCode: 'يرجى إدخال رمز تحقق من 6 أرقام',
        verifyCodeFailed: 'رمز التحقق غير صالح أو منتهي الصلاحية',
        googleLoginFailed: 'فشل تسجيل الدخول عبر Google، يرجى المحاولة مرة أخرى',
        registerHint: 'بالتسجيل، أنت توافق على',
        and: 'و',
        freeCreditsLabel: 'أرصدة مجانية:',
        freeCreditsDesc: 'احصل على أرصدة مجانية بمجرد تسجيل الدخول — لا حاجة للدفع!',
        sidebar: {
            navigation: 'التنقل',
            home: 'الرئيسية',
            inspiration: 'الإلهام',
            allModels: 'جميع النماذج',
            videoAI: 'فيديو AI',
            videoGenerator: 'مولد الفيديو',
            newModels: 'نماذج جديدة',
            otherModels: 'نماذج أخرى',
            videoEnhance: 'تحسين الفيديو',
            musicAI: 'موسيقى AI',
            musicGenerator: 'موسيقى AI',
            imageAI: 'صور AI',
            imageGenerator: 'مولد الصور',
            hotModels: 'نماذج رائجة',
            hotTools: 'أدوات رائجة',
            history: 'السجل',
            upgrade: 'ترقية'
        }
    },
    footer: {
        brand: 'Miral',
        siteTitle: 'Miral - منصة إنشاء الصور والفيديو والموسيقى بالذكاء الاصطناعي',
        desc: 'منصة AI شاملة لإنشاء الصور والفيديو والموسيقى.',
        fluxModels: 'نماذج FLUX',
        aiImages: 'صور AI',
        aiVideos: 'فيديو AI',
        aiMusic: 'موسيقى AI',
        product: 'المنتج',
        videoModels: 'نماذج فيديو الذكاء الاصطناعي',
        imageModels: 'نماذج صور الذكاء الاصطناعي',
        musicModels: 'نماذج موسيقى الذكاء الاصطناعي',
        apps: 'التطبيقات',
        company: 'الشركة',
        about: 'من نحن',
        contact: 'اتصل بنا',
        blog: 'المدونة',
        tools: 'الأدوات',
        resources: 'الموارد',
        allModels: 'جميع نماذج AI',
        pricing: 'الأسعار',
        trustSafety: 'الثقة والسلامة',
        terms: 'شروط الخدمة',
        privacy: 'سياسة الخصوصية',
        faq: 'الأسئلة الشائعة',
        musicGenerator: 'مولد موسيقى AI',
        copyright: '© 2025 Miral. جميع الحقوق محفوظة.',
        langZh: '简体中文',
        langEn: 'English'
    },
    about: {
        tag: 'About Miral',
        title: 'About Us',
        subtitle: 'Create images, videos, and music with leading AI models in one place.',
        paragraphs: ['Miral is an AI creation platform for creators, designers, and businesses. Generate images and videos, compose AI music, and use practical tools such as watermark removal and document cleanup.', 'We continuously integrate leading models and reliable channels so you can go from idea to finished content in the browser.', 'Learn more about our data practices on Trust & Safety, or contact support when you need help.']
    },
    contact: {
        tag: 'Support',
        title: 'Contact Us',
        subtitle: 'We will get back to your questions and feedback as soon as we can.',
        emailLabel: 'Support email',
        hint: 'Email us about billing, credits, or generation issues. We usually reply on business days.',
        cta: 'Send Email'
    },
    models: {
        image: {
            'nano-banana': {name: 'Nano Banana Pro', desc: 'واقعية سينمائية بتفاصيل بشرة وملمس وإضاءة طبيعية'},
            'nano-banana-31': {name: 'Nano Banana 3.1', desc: 'توليد صور متعددة الدقة مع أوضاع v2.5 و v3.1'},
            'seedream-4': {name: 'Seedream 4', desc: 'نمط فني'},
            'seedream-5': {name: 'Seedream 5', desc: 'نمط فني'},
            'midjourney': {name: 'Midjourney', desc: 'نمط فني'},
            'gpt-image-1': {name: 'GPT-Image-1', desc: 'متعدد الأغراض'},
            'gpt-image-1-5': {name: 'GPT-Image-1-5', desc: 'متعدد الأغراض'},
            'flux-pro-1-1-ultra': {name: 'Flux Pro 1.1 Ultra', desc: 'نص إلى صورة عالي الجودة'},
            'flux-schnell': {name: 'Flux Schnell', desc: 'نص إلى صورة سريع'},
            'flux-kontext': {name: 'Flux Kontext', desc: 'نص إلى صورة عالي الجودة والتحرير'},
            'flux-2': {name: 'FLUX.2', desc: 'نص إلى صورة من الجيل التالي'},
            'qwen-image-2-0-pro': {name: 'Qwen Image 2.0 Pro', desc: 'نص إلى صورة عالي الدقة بتفاصيل دقيقة'},
            'z-image-turbo': {name: 'Z Image Turbo', desc: 'توليد صور عالي الدقة من النص'},
            'sd-3-5': {name: 'Stable Diffusion 3.5', desc: 'توليد صور من النص باستخدام Stable Diffusion 3.5'}
        },
        video: {
            'pollodance': {name: 'Pollo Dance', desc: 'تحكم بالحركة، مراجع وأنماط سينمائية'},
            'seegen': {name: 'SeeGen', desc: 'نص وصورة إلى فيديو، دقة متعددة'},
            'seedance': {name: 'Seedance AI', desc: 'مزامنة صوتية بصرية أصلية'},
            'wan-2-5': {name: 'Wan 2.5', desc: 'نمط الرسوم المتحركة'},
            'wan-2-6': {name: 'Wan 2.6', desc: 'جودة محسّنة'},
            'veo-3-1': {name: 'Veo 3.1', desc: 'مرجع متعدد الصور'},
            'veo-3-1-fast': {name: 'Veo 3.1 Fast', desc: 'سريع، يدعم الإطار النهائي'},
            'kling-2-6': {name: 'Kling 2.6', desc: 'مزامنة الشفاه'},
            'kling-3': {name: 'Kling 3', desc: 'مزامنة الشفاه'},
            'sora-2': {name: 'Sora 2', desc: '4 / 8 / 12 ثانية'},
            'kling-2-5': {name: 'Kling 2.5', desc: 'قياسي'},
            'wan-2-2': {name: 'Wan 2.2', desc: 'كلاسيكي'},
            'vidu-q3-pro': {name: 'Vidu Q3 Pro', desc: 'نص وصورة إلى فيديو، دقة متعددة'},
            'veo-3-0': {name: 'Veo 3.0', desc: 'نص/صورة إلى فيديو'},
            'hailuo-2-3': {name: 'Hailuo 2.3', desc: 'فيديو إبداعي'},
            'runway': {name: 'Runway', desc: 'منصة العمل'},
            'wan-animate': {name: 'Wan Animate', desc: 'رسوم شخصيات متحركة'}
        }
    },
    tools: {
        demoTitle: 'عرض تجريبي',
        page: {
            tag: 'أدوات AI',
            title: 'أدوات AI احترافية',
            subtitle: 'إزالة العلامات المائية، استعادة الصور، تحسين الدقة، تحسين الفيديو وأدوات احترافية أخرى لجميع احتياجات المعالجة اللاحقة.',
            allTools: 'جميع الأدوات'
        },
        detail: {
            useNow: 'استخدم الآن',
            clickUpload: 'انقر أو اسحب للرفع ',
            support: 'يدعم',
            reupload: 'إعادة الرفع',
            scale: 'التكبير',
            process: 'معالجة',
            processing: 'جاري المعالجة...',
            before: 'قبل',
            after: 'بعد',
            download: 'تحميل النتيجة',
            processNew: 'معالجة ملف جديد',
            howToUse: 'كيفية الاستخدام',
            moreTools: 'المزيد من الأدوات',
            notFound: 'الأداة غير موجودة',
            backToList: 'العودة إلى الأدوات',
            loginRequired: 'تسجيل الدخول مطلوب',
            loginRequiredDesc: 'يرجى تسجيل الدخول لاستخدام هذه الأداة',
            loginNow: 'تسجيل الدخول الآن',
            demo: 'عرض تجريبي',
            uploadOriginalFailed: 'فشل رفع الصورة الأصلية، يرجى المحاولة مرة أخرى'
        },
        steps: {
            upload: {
                title: 'رفع الملف',
                desc: 'اختر أو اسحب وأفلت ملف الصورة أو الفيديو الذي تريد معالجته'
            },
            adjust: {
                title: 'تعديل الإعدادات',
                desc: 'تكوين معلمات المعالجة مثل عامل التكبير وتنسيق الإخراج'
            },
            process: {
                title: 'معالجة بنقرة واحدة',
                desc: 'يقوم الذكاء الاصطناعي بالمعالجة تلقائياً، عادة يتم الإنجاز خلال ثوانٍ إلى دقائق'
            },
            download: {title: 'تحميل النتيجة', desc: 'معاينة النتيجة وتحميل الإخراج عالي الجودة.'}
        },
        fileTypes: {
            image: 'صورة',
            video: 'فيديو'
        },
        imageEnhancer: {
            name: 'محسّن الصور',
            desc: 'تحسين الصور إلى دقة 4K مع تفاصيل محسّنة',
            fullDesc: 'تحسين الصور إلى دقة 4K مع تفاصيل محسّنة. يستخدم خوارزميات AI متقدمة لتحسين التفاصيل، وجعل الصور الضبابية حادة وواضحة.'
        },
        'doc-crop-enhance': {
            name: 'قص وتقويم الصور',
            desc: 'قص الحواف وتصحيح تشوه المستندات بالذكاء الاصطناعي',
            fullDesc: 'قص الصور، تقويمها وتحسينها. إزالة خلفية الحواف، تصحيح التشوه، والتحسين بأوضاع متعددة تشمل الإضاءة، الشحذ، الأبيض والأسود، التدرج الرمادي، وإزالة الظلال.',
            enhanceMode: 'وضع التحسين',
            enhanceModes: {
                disabled: 'معطّل',
                brighten: 'إضاءة',
                sharpen: 'تحسين وشحذ',
                blackWhite: 'أبيض وأسود',
                grayscale: 'تدرج رمادي',
                deshadow: 'إزالة الظلال',
                bitmap: 'صورة نقطية'
            },
            cropImage: 'قص الحواف',
            dewarpImage: 'تقويم',
            notImageFile: 'يرجى رفع ملف صورة صالح',
            fileTooLarge: 'الصورة كبيرة جداً، يرجى اختيار صورة أقل من 15 ميغابايت',
            noImageInResponse: 'فشلت المعالجة، يرجى المحاولة مرة أخرى',
            downloadName: 'doc-crop-enhanced.png',
      "featuresKicker": "تحسين مسح المستندات",
      "featuresTitle": "تحويل صور المستندات إلى عمليات مسح ضوئي نظيفة ومحاذاة بشكل صحيح",
      "featuresIntro": "تعامل مع حواف المستندات، والانحراف، والمنظور، والصفحات المنحنية، والظلال، ووضوح النص لتلبية احتياجات التقاط الصور المحمولة وتعزيز المسح الضوئي الشائعة.",
      "features": [
        {
          "title": "اكتشاف حواف المستند واقتصاصها تلقائيًا",
          "desc": "ابحث عن الحد الفاصل بين الورقة وخلفيتها، ثم قم بإزالة الأسطح وظلال الحواف والمناطق غير المرتبطة للحصول على صفحة أكثر وضوحًا.",
          "cta": "قص مستند مجانًا"
        },
        {
          "title": "تصويب المستندات المنحرفة والمنظور الصحيح",
          "desc": "إصلاح التشوه شبه المنحرف والصفحات المائلة والنسب الناتجة عن صور الهاتف ذات الزوايا للعقود والنماذج وأوراق الاختبار.",
          "cta": "تصحيح صورة المستند"
        },
        {
          "title": "تشويه الصفحات المنحنية والمستندات الممسوحة ضوئيًا",
          "desc": "قم بتصحيح التشوه بالقرب من أغلفة الكتب والورق المجعد والصفحات المطوية لتسهيل قراءة الكتب المدرسية وصور الكتب.",
          "cta": "تشويه مستند منحني"
        },
        {
          "title": "إزالة الظلال من عمليات مسح المستندات",
          "desc": "قلل الظلال التي تسببها الهواتف والأصابع وأشواك الكتب والإضاءة غير المتساوية للحصول على إيصالات وأوراق عمل وصفحات ممسوحة ضوئيًا بشكل أكثر وضوحًا.",
          "cta": "إزالة ظلال الوثيقة"
        },
        {
          "title": "سطع المستندات وشحذ النص",
          "desc": "قم بتحسين السطوع وحواف النص المطبوع في المستندات منخفضة التباين لتسهيل القراءة والطباعة والتنظيم.",
          "cta": "شحذ النص الممسوح ضوئيًا"
        },
        {
          "title": "قم بإنشاء عمليات مسح بالأبيض والأسود أو بتدرج الرمادي أو الصور النقطية",
          "desc": "قم بتحويل صور المستندات الملونة إلى صور بالأبيض والأسود أو بتدرج رمادي أو صور نقطية محسنة للطباعة والأرشفة.",
          "cta": "تحسين صورة المستند"
        }
      ],
      "useCasesKicker": "حالات الاستخدام الشائعة",
      "useCasesTitle": "ما هي صور المستندات التي يمكن اقتصاصها وتحسينها؟",
      "useCasesIntro": "مصمم لصور المستندات الفردية الملتقطة بالهاتف أو الماسح الضوئي ذات الإطارات غير المتساوية أو الظلال أو التشوه أو النص غير الواضح.",
      "useCases": [
        {
          "title": "صورة الهاتف للمسح الضوئي",
          "desc": "قم بإزالة خلفيات المكتب وتصحيح زوايا الكاميرا لجعل صور الهاتف تبدو وكأنها صور ممسوحة ضوئيًا."
        },
        {
          "title": "العقود والنماذج",
          "desc": "عقود المحاصيل والتطبيقات والنماذج لاستعادة الحواف النظيفة ونسب الصفحة."
        },
        {
          "title": "الإيصالات والفواتير",
          "desc": "قم بتقليل الظلال وزيادة حدة النص المطبوع الباهت للحصول على عرض وأرشفة أكثر وضوحًا."
        },
        {
          "title": "صفحات الكتب المنحنية",
          "desc": "تصحيح الانحناء بالقرب من تجليد الكتب المدرسية والكتب والمصنفات."
        },
        {
          "title": "أوراق الاختبار وأوراق العمل",
          "desc": "قم بتسوية أوراق الاختبار وإزالة الظلال وشحذ النص المطبوع لإعادة استخدامه أو طباعته."
        },
        {
          "title": "أرشيف أبيض وأسود",
          "desc": "قم بتحويل صور المستندات إلى أنماط مسح ضوئي متسقة بالأبيض والأسود أو بتدرج الرمادي."
        }
      ],
      "faqTitle": "الأسئلة الشائعة حول قص المستندات وتصحيحها باستخدام الذكاء الاصطناعي",
      "faqs": [
        {
          "q": "ما هو اقتصاص وتصحيح مستندات الذكاء الاصطناعي؟",
          "a": "فهو يكتشف منطقة المستند ويزيل الخلفية المحيطة ويمكنه تصحيح الانحراف أو المنظور أو تشوه الصفحة المنحنية بناءً على إعداداتك."
        },
        {
          "q": "كيف يمكنني قص صور المستندات الممسوحة ضوئيًا تلقائيًا عبر الإنترنت؟",
          "a": "قم بتمكين اقتصاص الحواف، ثم قم بتحميل صورة المستند الممسوحة ضوئيًا. تحاول الأداة الكشف عن حدود الورق وإزالة المنطقة خارج المستند."
        },
        {
          "q": "هل يمكنني تعديل مستند ممسوح ضوئيًا عبر الإنترنت؟",
          "a": "نعم. استخدم التسوية لإجراء مسح مائل وتصحيح المنظور لصورة هاتف بزاوية. استخدم dewarping فقط عندما تكون الصفحة نفسها منحنية."
        },
        {
          "q": "ما هو الفرق بين وضعي deshadow وشحذ؟",
          "a": "تعمل تقنية Deshadow على تحسين الإضاءة غير المتساوية للصفحة، بينما تعمل ميزة Sharpen على تقوية حواف النص والخطوط. اختر الوضع الذي يطابق مشكلة المصدر."
        },
        {
          "q": "ما الأداة التي يمكنني استخدامها لتحسين أوراق الاختبار والعقود والإيصالات الممسوحة ضوئيًا؟",
          "a": "استخدم أداة قص المستندات وتحسينها مع إزالة الظل للإضاءة غير المتساوية، وزيادة الوضوح للنص الباهت، والأبيض والأسود أو التدرج الرمادي عند إعداد المستندات للطباعة."
        },
        {
          "q": "هل يمكن تحويل صورة الهاتف إلى مستند ممسوح ضوئيًا؟",
          "a": "يمكن أن يؤدي الاقتصاص والتصحيح والتحسين إلى إنتاج صورة تشبه المسح الضوئي، لكن الأداة لا تقوم بإنشاء ملفات PDF أو استخراج نص التعرف الضوئي على الحروف."
        },
        {
          "q": "ما هي تنسيقات الصور وأحجام الملفات المدعومة؟",
          "a": "يتم دعم صور JPG وPNG وWebP، ويبلغ الحد الأقصى لحجم الملف 15 ميجابايت."
        },
        {
          "q": "هل تؤدي المعالجة إلى تغيير محتوى المستند الأصلي؟",
          "a": "تقوم الأداة بضبط الإطارات والهندسة والسطوع والوضوح. لا يقوم بتحرير النص أو استخراج محتوى المستند."
        }
      ],
      "education": {
        "kicker": "وثائق التعليم",
        "title": "تحويل أوراق الاختبار والواجبات المنزلية وصور الكتب المدرسية إلى مسح ضوئي واضح",
        "intro": "اكتشف حواف المستندات التعليمية تلقائيًا وقم بتصحيح الانحراف والمنظور والصفحات المنحنية والظلال للحصول على طباعة وأرشفة واستخدام أكثر نظافة في الفصل الدراسي.",
        "items": [
          {
            "title": "صور ورق اختبار المحاصيل",
            "desc": "اكتشف حواف ورق الاختبار وقم بإزالة خلفية المكتب لإنشاء صفحة نظيفة ومؤطرة بشكل صحيح."
          },
          {
            "title": "صور الواجبات المنزلية الصحيحة",
            "desc": "قم بإصلاح الانحراف والمنظور في صور الواجب المنزلي بحيث يسهل مراجعتها وإرسالها وطباعتها."
          },
          {
            "title": "صفحات الكتاب المدرسي Dewarp",
            "desc": "قم بتصحيح الصفحات المنحنية بالقرب من أغلفة الكتب وتقليل الظلال التي تجعل قراءة المحتوى المطبوع أكثر صعوبة."
          },
          {
            "title": "شحذ أوراق العمل الصفية",
            "desc": "قم بإضفاء السطوع على أوراق العمل أو المواد الدراسية وشحذها باستخدام تأثيرات المسح الضوئي بالأبيض والأسود أو بتدرج الرمادي."
          }
        ],
        "relatedTitle": "هل تحتاج إلى إزالة الإجابات المكتوبة بخط اليد من ورقة الاختبار؟",
        "relatedDesc": "تتعامل هذه الأداة مع الاقتصاص والتصحيح الهندسي وتحسين الصورة. استخدم ممحاة الكتابة اليدوية لإزالة إجابات الطلاب أو العمليات الحسابية أو تعليقات المعلم.",
        "relatedCta": "افتح ممحاة الكتابة اليدوية"
      }
        },
        'watermark-remover': {
            name: 'أداة إزالة العلامة المائية بالذكاء الاصطناعي',
            desc: 'إزالة العلامات المائية من الصور بالذكاء الاصطناعي',
            fullDesc: 'استخدام الذكاء الاصطناعي لاكتشاف وإزالة العلامات المائية من الصور مع الحفاظ على المحتوى الأصلي والتفاصيل والجودة البصرية.',
            audienceLabels: ['بائعو التجارة الإلكترونية', 'فرق التسويق', 'المصممون وصنّاع المحتوى', 'متاجر الأزياء والملابس'],
            audienceCases: [
                { title: 'حضّر صور المنتجات بسرعة أكبر 3 مرات', desc: 'قبل إنشاء صور احترافية لقوائم المنتجات، نظّف صور المنتجات أو صور الموردين أو المسودات المصرح لك باستخدامها. أزل العلامات المشتتة ليبقى تركيز المشترين على المنتج نفسه.' },
                { title: 'قلّل التنظيف اليدوي بنسبة 60% وأنشئ مواد الحملات أسرع', desc: 'قبل تحويل المواد المرئية المملوكة أو المرخصة إلى إعلانات ولافتات ورسومات للعلامة التجارية، أزل العلامات المائية غير المطلوبة. يمكن استخدام المواد النظيفة بسرعة أكبر في الحملات وإطلاق المنتجات وملصقاتها.' },
                { title: 'حوّل الصور النظيفة إلى أفكار إبداعية جديدة بشكل أسرع', desc: 'استكشف اتجاهات تصميم جديدة انطلاقاً من صور مصدر نظيفة من دون إعادة البناء من الصفر. استخدم المسودات الخالية من العلامات المائية كمرجع لرسومات الذكاء الاصطناعي أو الفن التصوري أو تصاميم الملصقات.' },
                { title: 'جدّد صور الكتالوج من دون إعادة التصوير', desc: 'قبل إعداد تحديثات الكتالوج أو الإطلاقات الموسمية أو صور القياس الافتراضي بالذكاء الاصطناعي، نظّف صور الملابس المصرح بها لإبراز القصة والنسيج وتفاصيل المنتج.' }
            ],
            fileTooLarge: 'الصورة كبيرة جداً. يرجى استخدام ملف أقل من 15 ميغابايت (JPG أو PNG أو WebP).',
            notImageFile: 'يرجى رفع ملف صورة.',
            noImageInResponse: 'لم يتم إرجاع صورة نتيجة. يرجى المحاولة مرة أخرى لاحقاً.',
            downloadName: 'watermark-removed.png',
      "aiRepair": "إزالة العلامة المائية",
      "uploadLabel": "تحميل الصورة",
      "uploadHint": "يدعم صور JPG أو PNG أو WebP بحجم يصل إلى 15 ميجابايت.",
      "featuresKicker": "سريع ودقيق",
      "featuresTitle": "إزالة العلامات المائية المختلفة من الصور عبر الإنترنت",
      "featuresIntro": "قم بتحميل صورة JPG أو PNG أو WebP ودع الذكاء الاصطناعي يكتشف مناطق العلامات المائية ويعيد بناء الخلفية بدون تنظيف يدوي.",
      "features": [
        {
          "title": "مسح العلامات المائية للصورة الكاملة",
          "desc": "قم بإزالة النص الشفاف المتكرر أو العلامات المائية النمطية التي تغطي الصورة بأكملها للحصول على نتيجة أوضح.",
          "cta": "جرب مزيل العلامات المائية بالذكاء الاصطناعي مجانًا"
        },
        {
          "title": "إزالة الطوابع الزمنية وعلامات التاريخ",
          "desc": "قم بتنظيف التواريخ والطوابع الزمنية وعلامات الكاميرا من زوايا الصورة أثناء إعادة بناء الخلفية خلفها.",
          "cta": "مسح العلامات المائية للصورة عبر الإنترنت"
        },
        {
          "title": "محو شعارات العلامة التجارية",
          "desc": "قم بإزالة شعارات العلامة التجارية وشارات الزوايا والعلامات الترويجية من الصور التي لديك إذن بتحريرها.",
          "cta": "قم بإزالة العلامات المائية للصور الآن"
        },
        {
          "title": "تنظيف النص وعلامات المسودة",
          "desc": "قم بإزالة تراكبات النص من المعاينات ومسودات التصميم والصور لإنشاء محتوى مرئي أكثر وضوحًا.",
          "cta": "جرب مزيل العلامة المائية الآن"
        }
      ],
      "useCasesKicker": "حالات الاستخدام",
      "useCasesTitle": "ما الذي يمكن لبرنامج AI Image Watermark Remover تنظيفه؟",
      "useCases": [
        {
          "title": "إزالة العلامة المائية لصور المنتج",
          "desc": "قم بتنظيف النص والشعارات والعلامات الترويجية من صور المنتج قبل نقل الأصول الخاصة بك."
        },
        {
          "title": "إزالة العلامة المائية للصور الاجتماعية",
          "desc": "قم بإزالة علامات النظام الأساسي أو الطوابع الزمنية من صورك الخاصة للحصول على نسخة نشر أكثر وضوحًا."
        },
        {
          "title": "تنظيف العلامات المائية المتعددة",
          "desc": "عندما تحتوي صورة واحدة على عدة علامات مائية، يمكن للذكاء الاصطناعي اكتشاف عدة مناطق مغطاة وتنظيفها."
        }
      ],
      "howToKicker": "ثلاث خطوات بسيطة",
      "howToTitle": "كيفية إزالة العلامات المائية من الصور عبر الإنترنت مجانًا",
      "howToIntro": "ليست هناك حاجة لتثبيت البرامج. قم بتحميل صورة، وقم بتشغيل مزيل العلامات المائية بالذكاء الاصطناعي، وقم بتنزيل النتيجة التي تم تنظيفها.",
      "howToCta": "قم بإزالة العلامات المائية عبر الإنترنت الآن",
      "steps": {
        "upload": {
          "title": "قم بتحميل صورة تحمل علامة مائية",
          "desc": "اختر صورة JPG أو PNG أو WebP بحجم أقل من 15 ميجابايت. تأكد من أن لديك الحق في تعديله واستخدامه."
        },
        "remove": {
          "title": "قم بإزالة العلامة المائية باستخدام الذكاء الاصطناعي",
          "desc": "ابدأ المعالجة وسوف يكتشف الذكاء الاصطناعي الشعارات أو النصوص أو الطوابع الزمنية أو العلامات المائية للصورة الكاملة ويعيد بناء الخلفية."
        },
        "download": {
          "title": "المعاينة والتنزيل",
          "desc": "قارن النتائج قبل وبعد، ثم قم بتنزيل الصورة المنظفة أو قم بتحميل صورة أخرى."
        }
      },
      "faqTitle": "الأسئلة الشائعة حول مزيل العلامات المائية بالذكاء الاصطناعي",
      "faqs": [
        {
          "q": "ما هو مزيل العلامات المائية بالذكاء الاصطناعي؟",
          "a": "يكتشف مزيل العلامات المائية بتقنية الذكاء الاصطناعي مناطق العلامات المائية ويعيد بناء الخلفيات المغطاة باستخدام الألوان والأنسجة ومحتوى الصورة القريبة."
        },
        {
          "q": "كيفية إزالة العلامات المائية من الصور عبر الإنترنت مجانًا؟",
          "a": "قم بالتسجيل وتحميل صورة إلى مزيل العلامات المائية Miral AI، وابدأ المعالجة لمعاينة النتيجة التي تم تنظيفها."
        },
        {
          "q": "ما هي تنسيقات الصور المدعومة؟",
          "a": "تدعم الأداة حاليًا صور JPG وPNG وWebP التي يقل حجمها عن 15 ميجابايت. لا تقوم هذه الصفحة بإزالة العلامات المائية من مقاطع الفيديو."
        },
        {
          "q": "هل يمكنه إزالة العلامات المائية والشعارات والطوابع الزمنية كاملة الصورة؟",
          "a": "نعم. يستطيع الذكاء الاصطناعي معالجة العلامات المائية المتكررة ذات الصورة الكاملة وشعارات العلامة التجارية وطوابع التاريخ والنصوص وعلامات المسودة. تعتمد النتائج على العتامة والمساحة المغطاة وتعقيد الخلفية."
        },
        {
          "q": "ما الأداة التي يمكنني استخدامها لإزالة شعارات أو طوابع زمنية متعددة من صورة واحدة؟",
          "a": "يمكن لمزيل العلامات المائية Miral AI معالجة مناطق متعددة للعلامات المائية، بما في ذلك الشعارات والطوابع الزمنية. تحقق من المعاينة عندما تغطي العلامات الكبيرة الأشخاص أو الأنسجة المعقدة."
        },
        {
          "q": "هل إزالة العلامة المائية من الصورة قانوني؟",
          "a": "معالجة الصور التي تملكها فقط، أو المرخص لها بتحريرها، أو التي يجوز استخدامها بشكل قانوني. قد تؤدي إزالة العلامات المائية لحقوق الطبع والنشر دون إذن إلى انتهاك حقوق المالك."
        },
        {
          "q": "كيفية إصلاح المناطق الباهتة بعد إزالة العلامة المائية؟",
          "a": "ابدأ بالصورة المصدرية الأعلى جودة المتاحة وتحقق من المعاينة قبل التنزيل. يحاول الذكاء الاصطناعي الحفاظ على التركيبة والدقة والتفاصيل الأصلية، ولكن يجب إعادة بناء المحتوى المخفي بواسطة علامات مائية كبيرة، لذلك قد تختلف النتائج المحلية عن النتائج الأصلية."
        }
      ]
        },
        'full-watermark-remover': {
            name: 'أداة إزالة العلامة المائية بالذكاء الاصطناعي',
            desc: 'إزالة العلامات المائية من الصور بالذكاء الاصطناعي',
            fullDesc: 'استخدام الذكاء الاصطناعي لاكتشاف وإزالة العلامات المائية من الصور مع الحفاظ على المحتوى الأصلي والتفاصيل والجودة البصرية.',
            notImageFile: 'يرجى رفع ملف صورة صالح.',
            fileTooLarge: 'الصورة كبيرة جداً، يرجى اختيار صورة أقل من 15 ميغابايت.',
            downloadName: 'full-watermark-removed.png'
        },
        'ai-text-remover': {
            name: 'أداة إزالة النصوص بالذكاء الاصطناعي',
            desc: 'إزالة النصوص غير المرغوب فيها من الصور بالذكاء الاصطناعي',
            fullDesc: 'إزالة النصوص غير المرغوب فيها من الصور بالذكاء الاصطناعي مع الحفاظ على الخلفية والملمس والتفاصيل البصرية الطبيعية.',
            notImageFile: 'يرجى رفع ملف صورة صالح.',
            fileTooLarge: 'الصورة كبيرة جداً، يرجى اختيار صورة أقل من 15 ميغابايت.',
            downloadName: 'text-removed.png'
        },
        'ai-logo-remover': {
            name: 'أداة إزالة الشعارات بالذكاء الاصطناعي',
            desc: 'إزالة الشعارات غير المرغوب فيها من الصور بالذكاء الاصطناعي',
            fullDesc: 'إزالة الشعارات غير المرغوب فيها من الصور بالذكاء الاصطناعي مع الحفاظ على الخلفية والملمس والتفاصيل البصرية الطبيعية.',
            notImageFile: 'يرجى رفع ملف صورة صالح.',
            fileTooLarge: 'الصورة كبيرة جداً، يرجى اختيار صورة أقل من 15 ميغابايت.',
            downloadName: 'logo-removed.png'
        },
        'ai-passersby-remover': {
            name: 'أداة إزالة المارة بالذكاء الاصطناعي',
            desc: 'إزالة المارة من الصور بالذكاء الاصطناعي',
            fullDesc: 'استخدام الذكاء الاصطناعي لاكتشاف وإزالة المارة من الصور مع الحفاظ على الموضوع وملمس الخلفية والتفاصيل البصرية الطبيعية.',
            notImageFile: 'يرجى رفع ملف صورة صالح.',
            fileTooLarge: 'الصورة كبيرة جداً، يرجى اختيار صورة أقل من 15 ميغابايت.',
            downloadName: 'passersby-removed.png'
        },
        'background-remover': {
            name: 'أداة إزالة الخلفية',
            desc: 'إزالة خلفيات الصور بنقرة واحدة بالذكاء الاصطناعي',
            heroTitle: 'إزالة خلفية الصور مجاناً بالذكاء الاصطناعي وإنشاء PNG شفاف',
            fullDesc: 'ارفع صورة JPG أو PNG أو WebP ودع الذكاء الاصطناعي يكتشف الأشخاص والمنتجات والحواف تلقائياً، مع الحفاظ على الشعر والتفاصيل الدقيقة وتنزيل PNG شفاف دون Photoshop.',
            uploadLabel: 'ارفع صورة لإزالة خلفيتها',
            uploadHint: 'انقر أو اسحب صورة إلى هنا',
            uploadSpec: 'يدعم JPG وPNG وWebP حتى 15 ميغابايت. يتم تنزيل النتيجة بصيغة PNG شفافة.',
            processButton: 'إزالة خلفية الصورة',
            previewAlt: 'معاينة الصورة قبل إزالة الخلفية بالذكاء الاصطناعي',
            demoBeforeAlt: 'صورة شخصية قبل إزالة الخلفية',
            demoAfterAlt: 'صورة شخصية بعد إزالة الخلفية بالذكاء الاصطناعي',
            processingAlt: 'الذكاء الاصطناعي يزيل خلفية الصورة',
            processingLabel: 'جارٍ قص العنصر',
            resultLabel: 'الخلفية الشفافة جاهزة',
            resultBeforeAlt: 'الصورة الأصلية قبل إزالة الخلفية',
            resultAfterAlt: 'PNG شفاف بعد إزالة الخلفية بالذكاء الاصطناعي',
            productBeforeAlt: 'صورة منتج قبل إزالة الخلفية',
            productAfterAlt: 'منتج مقصوص على خلفية شفافة',
            featuresKicker: 'اكتشاف دقيق للعنصر',
            featuresTitle: 'إزالة الخلفية بالذكاء الاصطناعي للصور الشخصية والمنتجات',
            featuresIntro: 'من حواف الصور الشخصية المعقدة إلى صور المتاجر، يفصل الذكاء الاصطناعي العنصر عن الخلفية دون فرش أو مسارات أو أقنعة يدوية.',
            features: [
                { title: 'إزالة خلفية الصور الشخصية مع الحفاظ على الشعر', desc: 'اكتشاف الأشخاص والملابس وخصلات الشعر الدقيقة لإنشاء صور شخصية ومهنية وملصقات وتصاميم اجتماعية نظيفة.', cta: 'إزالة خلفية الصورة الشخصية مجاناً' },
                { title: 'قص صور المنتجات بنقرة واحدة', desc: 'إزالة الطاولات والجدران ومشهد التصوير لاستخدام المنتج الشفاف في المتاجر والخلفيات البيضاء والإعلانات.', cta: 'إزالة خلفية المنتج' },
                { title: 'تنزيل PNG بخلفية شفافة', desc: 'احتفظ بالشفافية لوضع العنصر على خلفية جديدة أو لافتة أو عرض تقديمي أو صورة مصغرة أو تصميم.', cta: 'جعل الخلفية شفافة' }
            ],
            featureAlts: { portraitBefore: 'صورة شخصية قبل القص', portraitAfter: 'صورة شخصية مقصوصة مع الحفاظ على الشعر', productBefore: 'منتج قبل إزالة الخلفية', productAfter: 'منتج على خلفية شفافة', ecommerceBefore: 'صورة متجر قبل القص', ecommerceAfter: 'PNG شفاف لمنتج متجر' },
            useCasesKicker: 'استخدامات شائعة',
            useCasesTitle: 'ما الصور المناسبة للقص بالذكاء الاصطناعي؟',
            useCasesIntro: 'استخدم الأداة لعزل عنصر بسرعة أو إنشاء أصل شفاف للأعمال الإبداعية والتجارية.',
            useCases: [
                { title: 'صور منتجات المتاجر', desc: 'جهز منتجات شفافة للكتالوجات والمتاجر والحملات.' },
                { title: 'الصور الشخصية وصور الملف', desc: 'أزل البيئة مع الحفاظ على الشعر والملابس والحواف.' },
                { title: 'تصاميم وسائل التواصل', desc: 'ضع الأشخاص أو المنتجات في الأغلفة والمنشورات والصور المصغرة.' },
                { title: 'الصور المهنية وصور الهوية', desc: 'اعزل الشخص ثم أضف لون الخلفية المطلوب.' },
                { title: 'الشعارات والعناصر الرسومية', desc: 'أزل الخلفية غير المرغوبة قبل إعادة استخدام التصميم.' },
                { title: 'الإعلانات والتصميم', desc: 'أنشئ ملفات PNG شفافة دون قص يدوي متكرر.' }
            ],
            howToKicker: 'ثلاث خطوات بسيطة',
            howToTitle: 'كيفية إزالة خلفية صورة مجاناً عبر الإنترنت',
            howToIntro: 'ارفع الصورة وشغّل القص التلقائي بالذكاء الاصطناعي ثم نزّل PNG الشفاف.',
            steps: [
                { title: 'ارفع JPG أو PNG أو WebP', desc: 'اختر صورة شخصية أو منتجاً أو تصميماً واضحاً بحجم أقل من 15 ميغابايت.' },
                { title: 'أزل الخلفية بالذكاء الاصطناعي', desc: 'يفصل الذكاء الاصطناعي العنصر مع الحفاظ على الحواف المهمة.' },
                { title: 'عاين ونزّل PNG', desc: 'قارن النتيجة واحفظ الصورة الشفافة.' }
            ],
            faqTitle: 'الأسئلة الشائعة عن إزالة الخلفية بالذكاء الاصطناعي',
            faqs: [
                { q: 'كيف أزيل خلفية صورة مجاناً عبر الإنترنت؟', a: 'ارفع JPG أو PNG أو WebP وابدأ المعالجة. يكتشف الذكاء الاصطناعي العنصر وينشئ PNG شفافاً.' },
                { q: 'هل يحافظ الذكاء الاصطناعي على الشعر والحواف الدقيقة؟', a: 'تحاول الأداة الحفاظ على الشعر والملابس والتفاصيل الصغيرة. يساعد التباين الواضح على نتيجة أفضل.' },
                { q: 'هل يمكن إزالة خلفية صورة منتج؟', a: 'نعم. المنتجات الواضحة مناسبة لإنشاء أصول شفافة للمتاجر والإعلانات.' },
                { q: 'ما صيغة الملف بعد المعالجة؟', a: 'يتم تنزيل النتيجة بصيغة PNG تدعم الشفافية.' },
                { q: 'ما الصيغ والأحجام المدعومة؟', a: 'يتم دعم JPG وPNG وWebP حتى 15 ميغابايت.' },
                { q: 'هل أحتاج إلى تثبيت Photoshop؟', a: 'لا. يزيل الذكاء الاصطناعي الخلفية مباشرة في المتصفح.' }
            ],
            fileTooLarge: 'الصورة كبيرة جداً. يرجى استخدام ملف أقل من 15 ميغابايت (JPG أو PNG أو WebP).',
            notImageFile: 'يرجى رفع ملف صورة.',
            noImageInResponse: 'لم يتم إرجاع صورة نتيجة. يرجى المحاولة مرة أخرى لاحقاً.',
            downloadName: 'background-removed.png'
        },
        'image-eraser': {
            name: 'أداة مسح الصور',
            desc: 'امسح أي عنصر أو شخص أو علامة مائية من الصور بالذكاء الاصطناعي',
            fullDesc: 'أداة مسح الصور بالذكاء الاصطناعي. مرر الفرشاة فوق أي عنصر أو شخص أو علامة مائية أو نص غير مرغوب فيه في صورتك وستقوم الذكاء الاصطناعي بإزالته بسلاسة وملء المنطقة بمحتوى طبيعي. مثالي لتنظيف الصور وإزالة العناصر المشتتة.',
            fileTooLarge: 'الصورة كبيرة جداً. يرجى استخدام ملف أقل من 15 ميغابايت (JPG أو PNG أو WebP).',
            notImageFile: 'يرجى رفع ملف صورة.',
            noImageInResponse: 'لم يتم إرجاع صورة نتيجة. يرجى المحاولة مرة أخرى لاحقاً.',
            downloadName: 'image-erased.png'
        },
        'object-remover': {
            name: 'إزالة العناصر',
            desc: 'أزل العناصر غير المرغوب فيها من صورك بالذكاء الاصطناعي',
            fullDesc: 'أداة إزالة العناصر بالذكاء الاصطناعي. مرر الفرشاة فوق أي عنصر غير مرغوب فيه في صورتك وستقوم الذكاء الاصطناعي بإزالته بسلاسة وملء المنطقة بمحتوى طبيعي. مثالي لتنظيف الصور وإزالة العناصر المشتتة.',
            fileTooLarge: 'الصورة كبيرة جداً. يرجى استخدام ملف أقل من 15 ميغابايت (JPG أو PNG أو WebP).',
            notImageFile: 'يرجى رفع ملف صورة.',
            noImageInResponse: 'لم يتم إرجاع صورة نتيجة. يرجى المحاولة مرة أخرى لاحقاً.',
            downloadName: 'object-removed.png',
      "uploadLabel": "تحميل الصورة",
      "uploadHint": "انقر أو اسحب لتحميل صورة",
      "uploadSpec": "يدعم صور JPG، PNG، أو WebP.",
      "maskHint": "قم بالفرشاة فوق كل جزء من الكائن الذي تريد من الذكاء الاصطناعي إزالته.",
      "processButton": "إزالة الكائن",
      "demoBeforeAlt": "الصورة قبل إزالة الكائن غير المرغوب فيه",
      "demoAfterAlt": "الصورة بعد إزالة الكائن غير المرغوب فيه",
      "processingAlt": "يقوم الذكاء الاصطناعي بمعالجة الصورة المميزة",
      "resultBeforeAlt": "الصورة الأصلية قبل إزالة الكائن",
      "resultAfterAlt": "صورة نظيفة بعد إزالة الكائن",
      "featureImageLabels": {
        "object": "مثال على إزالة الكائنات غير المرغوب فيها",
        "person": "مثال لإزالة شخص",
        "distraction": "مثال على إزالة تشتيت الخلفية"
      },
      "featuresKicker": "تنظيف الصور بدقة",
      "featuresTitle": "إزالة الكائنات غير المرغوب فيها من الصور عبر الإنترنت",
      "featuresIntro": "قم بتحديد المنطقة المحددة التي تريد تنظيفها واستخدم إزالة الكائنات بالذكاء الاصطناعي لتشتيت انتباه الصور اليومية دون إعادة بناء الخلفية يدويًا.",
      "features": [
        {
          "title": "قم بتنظيف الأشياء غير المرغوب فيها",
          "desc": "استخدم فرشاة قابلة للتعديل لوضع علامة على الفوضى أو اللافتات أو الدعائم أو الأشياء الأخرى. يقوم الذكاء الاصطناعي بإزالة المنطقة المحددة ويملأها بتفاصيل الصورة المحيطة.",
          "cta": "إزالة الكائنات مجانًا"
        },
        {
          "title": "إزالة الأشخاص من خلفيات الصور",
          "desc": "قم بتنظيف مفجري الصور أو السائحين أو المارة من لقطات السفر والصور الشخصية عندما يصرفون انتباههم عن الموضوع الرئيسي.",
          "cta": "تنظيف خلفيات الصور مجانا"
        },
        {
          "title": "محو الانحرافات الصغيرة في الخلفية",
          "desc": "قم بإزالة الأسلاك أو الصناديق أو فوضى الشوارع أو العلامات أو عناصر التشتيت البصري المعزولة لإنشاء تركيبة أنظف.",
          "cta": "مسح الانحرافات الصورة مجانا"
        }
      ],
      "useCasesKicker": "حالات الاستخدام الشعبية",
      "useCasesTitle": "ما الذي يمكنك إزالته باستخدام AI Object Remover؟",
      "useCasesIntro": "تم تصميمه لإجراء تعديلات مركزة حيث يمكنك مسح المنطقة غير المرغوب فيها بوضوح والحفاظ على بقية الصورة دون تغيير.",
      "useCases": [
        {
          "title": "تنظيف صور السفر",
          "desc": "قم بإزالة المارة أو اللافتات أو الصناديق أو فوضى الشوارع من صور العطلات."
        },
        {
          "title": "تنظيف صور المنتج",
          "desc": "قم بمسح الدعائم والملصقات والكابلات والعناصر المشتتة للانتباه حول المنتج."
        },
        {
          "title": "تنظيف الخلفية الشخصية",
          "desc": "قم بإزالة الأشخاص الموجودين في الخلفية والأشياء الصغيرة التي تجذب الانتباه عن الموضوع."
        },
        {
          "title": "صور العقارات",
          "desc": "تنظيف الفوضى المؤقتة والأشياء المعزولة من صور الغرفة أو الممتلكات."
        },
        {
          "title": "صور وسائل التواصل الاجتماعي",
          "desc": "قم بتلميع الصور قبل النشر عن طريق إزالة التشتيتات المرئية من الإطار."
        },
        {
          "title": "تحرير الصور الإبداعية",
          "desc": "قم بمسح المناطق المحددة قبل إعادة استخدام الصورة في تخطيط أو مشروع مرئي."
        }
      ],
      "howToKicker": "ثلاث خطوات بسيطة",
      "howToTitle": "كيفية إزالة كائن من صورة عبر الإنترنت",
      "howToIntro": "قم بتحميل صورة، ثم قم بالفرشاة فوق الكائن غير المرغوب فيه، ثم قم بتنزيل النتيجة التي تم تنظيفها بواسطة الذكاء الاصطناعي.",
      "steps": [
        {
          "title": "قم بتحميل صورتك",
          "desc": "اختر الصورة التي تحتوي على الشخص أو العنصر أو مصدر التشتيت الذي تريد مسحه."
        },
        {
          "title": "فرشاة فوق الكائن",
          "desc": "اضبط الفرشاة وقم بتغطية المنطقة غير المرغوب فيها بالكامل. استخدم التراجع أو الممحاة لتحسين القناع."
        },
        {
          "title": "إزالة وتنزيل",
          "desc": "ابدأ معالجة الذكاء الاصطناعي، وقارن الصور قبل وبعد، ثم قم بتنزيل الصورة المنظفة."
        }
      ],
      "faqTitle": "الأسئلة الشائعة حول مزيل كائنات الذكاء الاصطناعي",
      "faqs": [
        {
          "q": "كيفية إزالة الأشياء غير المرغوب فيها من الصور عبر الإنترنت؟",
          "a": "قم بتحميل صورة، ثم قم بالفرشاة فوق الكائن غير المرغوب فيه بالكامل، وابدأ في المعالجة. يقوم الذكاء الاصطناعي بإعادة بناء المنطقة المحددة باستخدام الألوان والأنسجة وتفاصيل المشهد القريبة."
        },
        {
          "q": "ما الأداة التي يمكنني استخدامها لإزالة شخص من خلفية الصورة؟",
          "a": "استخدم الفرشاة لتغطية الشخص وتضمين تفاصيل مثل الظلال أو العناصر المحمولة. عادة ما تكون النتائج أفضل عندما تكون الخلفية المحيطة مرئية."
        },
        {
          "q": "هل يستطيع الذكاء الاصطناعي إزالة اللافتات والأسلاك وصناديق القمامة وفوضى الشوارع؟",
          "a": "نعم. حدد المنطقة غير المرغوب فيها بوضوح وتجنب تغطية الأهداف القريبة التي تريد الاحتفاظ بها. من الأسهل عمومًا إعادة بناء عناصر التشتيت الصغيرة والمعزولة."
        },
        {
          "q": "كيف يمكنني الحصول على نتيجة أكثر طبيعية لإزالة الأشياء؟",
          "a": "استخدم صورة مصدر واضحة وعالية الجودة وقم بالفرشاة قليلاً خارج حواف الكائن. قم بمعالجة المناطق الصعبة بشكل منفصل عندما تتداخل عدة كائنات."
        },
        {
          "q": "هل يغير مزيل الكائن الصورة بأكملها؟",
          "a": "يعتمد طلب الإزالة على القناع المصقول. تركز الأداة على المنطقة المحددة، على الرغم من أن الذكاء الاصطناعي يجب أن يعيد بناء وحدات البكسل حول حوافها."
        },
        {
          "q": "ما هي تنسيقات الصور التي يمكنني تحميلها؟",
          "a": "يقبل التحكم في التحميل تنسيقات الصور الشائعة بما في ذلك JPG وPNG وWebP."
        }
      ]
        },
        'ai-person-remover': {
            name: 'إزالة الأشخاص بالذكاء الاصطناعي',
            desc: 'أزل الأشخاص من صورك بالذكاء الاصطناعي',
            fullDesc: 'أداة إزالة الأشخاص بالذكاء الاصطناعي. مرر الفرشاة فوق أي شخص في صورتك وستقوم الذكاء الاصطناعي بإزالته بسلاسة وملء المنطقة بمحتوى طبيعي. مثالي لإزالة المارة والسياح والأشخاص غير المعروفين من صورك.',
            fileTooLarge: 'الصورة كبيرة جداً. يرجى استخدام ملف أقل من 15 ميغابايت (JPG أو PNG أو WebP).',
            notImageFile: 'يرجى رفع ملف صورة.',
            noImageInResponse: 'لم يتم إرجاع صورة نتيجة. يرجى المحاولة مرة أخرى لاحقاً.',
            downloadName: 'person-removed.png'
        },
        'background-blur': {
            name: 'تمويه الخلفية',
            desc: 'موي خلفية الصورة بالذكاء الاصطناعي بنقرة واحدة لإبراز الموضوع',
            fullDesc: 'يكتشف الذكاء الاصطناعي تلقائياً موضوع المقدمة (شخص/شيء)، ويبقي الموضوع حاداً ويطبق تمويه غاوسي على الخلفية للحصول على تأثير وضع البورتريه. مثالي للبورتريهات ولقطات المنتجات المقربة.',
            fileTooLarge: 'الصورة كبيرة جداً. يرجى استخدام ملف أقل من 15 ميغابايت (JPG أو PNG أو WebP).',
            notImageFile: 'يرجى رفع ملف صورة.',
            noImageInResponse: 'لم يتم إرجاع صورة نتيجة. يرجى المحاولة مرة أخرى لاحقاً.',
            downloadName: 'background-blur.png'
        },
        'white-background': {
            name: 'خلفية بيضاء',
            desc: 'استبدال خلفية الصورة باللون الأبيض باستخدام الذكاء الاصطناعي',
            fullDesc: 'استبدال الخلفية باللون الأبيض بالذكاء الاصطناعي بنقرة واحدة. يكتشف حدود الموضوع بدقة، يحافظ على التفاصيل الدقيقة كالشعر، وينتج صورة بخلفية بيضاء نظيفة. مثالي لصور المنتجات وصور الهوية.',
            fileTooLarge: 'الصورة كبيرة جداً. يرجى استخدام ملف أقل من 15 ميغابايت (JPG أو PNG أو WebP).',
            notImageFile: 'يرجى رفع ملف صورة.',
            noImageInResponse: 'لم يتم إرجاع صورة نتيجة. يرجى المحاولة مرة أخرى لاحقاً.',
            downloadName: 'white-background.png'
        },
        'blue-background': {
            name: 'خلفية زرقاء',
            desc: 'استبدال خلفية الصورة باللون الأزرق باستخدام الذكاء الاصطناعي',
            fullDesc: 'استبدال الخلفية باللون الأزرق بالذكاء الاصطناعي بنقرة واحدة. يكتشف حدود الموضوع بدقة، يحافظ على التفاصيل الدقيقة كالشعر، وينتج صورة بخلفية زرقاء نظيفة. مثالي لصور جوازات السفر وصور الهوية.',
            fileTooLarge: 'الصورة كبيرة جداً. يرجى استخدام ملف أقل من 15 ميغابايت (JPG أو PNG أو WebP).',
            notImageFile: 'يرجى رفع ملف صورة.',
            noImageInResponse: 'لم يتم إرجاع صورة نتيجة. يرجى المحاولة مرة أخرى لاحقاً.',
            downloadName: 'blue-background.png'
        },
        'face-swap': {
            name: 'تبديل الوجوه في الصور',
            desc: 'تبديل الوجوه في الصور بالذكاء الاصطناعي بنقرة واحدة',
            fullDesc: 'تبديل الوجوه بالذكاء الاصطناعي. ارفع صورة مستهدفة وصورة وجه مصدر لدمج الوجه بسلاسة في الصورة المستهدفة. يدعم مشاهد متعددة الأشخاص مع نتائج واقعية.',
            fileTooLarge: 'الصورة كبيرة جداً. يرجى استخدام ملف أقل من 15 ميغابايت (JPG أو PNG أو WebP).',
            notImageFile: 'يرجى رفع ملف صورة.',
            targetImage: 'الصورة المستهدفة',
            sourceImage: 'الوجه المصدر',
            effectImageLabel: 'النتيجة',
            downloadName: 'face-swap-result.png',
            step1Title: 'رفع الصور',
            step1Desc: 'ارفع الصورة المستهدفة وصورة الوجه المصدر',
            step2Title: 'تبديل الوجه بالذكاء الاصطناعي',
            step2Desc: 'انقر معالجة، سيقوم الذكاء الاصطناعي بتبديل الوجه تلقائياً',
            step3Title: 'التحميل',
            step3Desc: 'معاينة وتحميل النتيجة',
      "processButton": "مبادلة الوجه",
      "targetPreviewAlt": "معاينة الصورة المستهدفة لتبديل الوجه بالذكاء الاصطناعي",
      "sourcePreviewAlt": "معاينة الوجه المصدر لمبادلة الوجه بالذكاء الاصطناعي",
      "processingAlt": "معاينة معالجة مبادلة الوجه بالذكاء الاصطناعي",
      "resultBeforeAlt": "الصورة المستهدفة قبل تبديل الوجه",
      "resultAfterAlt": "الصورة بعد تبديل الوجه بالذكاء الاصطناعي",
      "featuresKicker": "استبدال الوجه الطبيعي",
      "featuresTitle": "تبديل الوجوه بين الصور باستخدام الذكاء الاصطناعي",
      "featuresIntro": "استخدم صورة مستهدفة للوضعية والتكوين، ثم قم بتوفير وجه مصدر واضح لتبديل وجه الصورة المركزة.",
      "features": [
        {
          "title": "قم بإنشاء مبادلة وجه ذات مظهر طبيعي",
          "desc": "يمزج الذكاء الاصطناعي هوية المصدر في الصورة المستهدفة مع متابعة وضعها وتأطيرها وإضاءةها وأسلوبها البصري العام.",
          "cta": "إنشاء صورة تبديل الوجه مجانًا"
        },
        {
          "title": "حافظ على تكوين الصورة المستهدفة",
          "desc": "استخدم صورة شخصية أو صورة شخصية أو صورة شخصية أو مشهدًا إبداعيًا كهدف مع الحفاظ على خلفيتها وتكوينها.",
          "cta": "جرب تبديل صور الوجه مجانًا"
        },
        {
          "title": "استخدم وجهًا واضح المصدر",
          "desc": "قم بتحميل صورة مصدر أمامية جيدة الإضاءة مع تفاصيل مرئية للوجه لمساعدة النموذج في إنشاء بديل أكثر اتساقًا.",
          "cta": "تحميل ومبادلة مجانية"
        }
      ],
      "useCasesKicker": "أفكار الصور الإبداعية",
      "useCasesTitle": "الاستخدامات الشائعة لتبديل الصور عبر الإنترنت",
      "useCasesIntro": "قم بإنشاء تعديلات صور مرحة ومبتكرة باستخدام صورة مستهدفة واحدة وصورة وجه مصدر واحدة.",
      "useCases": [
        {
          "title": "مقايضات الوجه لصور السيلفي والملف الشخصي",
          "desc": "استبدل وجهًا في صورة شخصية أو صورة شخصية مع الحفاظ على الوضع المستهدف والخلفية والإطار. استكشف مفاهيم صور الملف الشخصي وأفكار الصور الشخصية مع وجه مصدر واضح.",
          "cta": "قم بإنشاء صورة شخصية للوجه مجانًا",
          "imageAlt": "مثال على تبديل الوجه باستخدام الذكاء الاصطناعي للصور الشخصية وصور الملف الشخصي"
        },
        {
          "title": "الميمات وصور التفاعل الاجتماعي",
          "desc": "قم بتحويل الصور المألوفة إلى صور مضحكة مخصصة وصور تفاعلية مرحة ومحتوى اجتماعي قابل للمشاركة. يساعد التعبير المستهدف الواضح في تسهيل التعرف على الصورة النهائية.",
          "cta": "جعل ميمي الوجه مبادلة مجانا",
          "imageAlt": "حالة استخدام صورة الميم الإبداعي وصورة التفاعل الاجتماعي"
        },
        {
          "title": "الكوسبلاي والشخصيات والقصص الإبداعية",
          "desc": "جرّب وجهًا يرتدي زيًا أو صورة خيالية أو شخصية مصورة أو مشهدًا خاصًا. استخدم تبديل الوجه لاستكشاف مفاهيم الشخصيات وإنشاء قصص مرئية من الصور التي يمكنك تحريرها.",
          "cta": "جرب تبديل وجه الشخصية مجانًا",
          "imageAlt": "حالة استخدام الكوسبلاي ومبادلة وجه الشخصية"
        }
      ],
      "howToKicker": "ثلاث خطوات بسيطة",
      "howToTitle": "كيفية تبديل الوجوه في الصور عبر الإنترنت باستخدام الذكاء الاصطناعي",
      "howToIntro": "اختر صورة مستهدفة، وأضف وجهًا واضحًا للمصدر، ودع الذكاء الاصطناعي ينشئ نتيجة تبديل الوجه.",
      "faqTitle": "الأسئلة الشائعة حول تبديل وجه الصورة",
      "faqs": [
        {
          "q": "كيفية تبديل الوجه بين صورتين عبر الإنترنت؟",
          "a": "قم بتحميل الصورة التي تريد الاحتفاظ بوضعيتها وتكوينها كهدف، ثم قم بتحميل الهوية التي تريد استخدامها كوجه المصدر وابدأ المعالجة."
        },
        {
          "q": "ما الفرق بين الصورة المستهدفة والوجه المصدر؟",
          "a": "توفر الصورة المستهدفة الوضع والخلفية والتكوين. يوفر وجه المصدر هوية الوجه المستخدمة للاستبدال."
        },
        {
          "q": "كيف أختار صورة مصدر جيدة لتبديل الوجه؟",
          "a": "استخدم صورة واضحة ومضاءة جيدًا مع وجه خالٍ من العوائق. يمكن لزاوية المصدر والتعبير المشابهين للهدف أن ينتجا نتيجة أكثر اتساقًا."
        },
        {
          "q": "هل يمكنني استخدام خاصية تبديل الوجه بالذكاء الاصطناعي لالتقاط صور شخصية أو صور مضحكة أو صور تنكرية؟",
          "a": "نعم. هذه هي الاستخدامات الإبداعية الشائعة عندما تمتلك الصور التي تم تحميلها أو يكون لديك إذن بتحريرها."
        },
        {
          "q": "لماذا يبدو تبديل الوجه في بعض الأحيان أقل واقعية؟",
          "a": "يمكن أن تؤدي الاختلافات الكبيرة في زاوية الوجه أو الإضاءة أو التعبير أو الدقة أو الإطباق الشديد إلى جعل المزج أكثر صعوبة. حاول الحصول على صور مصدر أكثر وضوحًا وتوافقًا."
        },
        {
          "q": "ما هي تنسيقات الصور وأحجام الملفات المدعومة؟",
          "a": "يتم دعم صور JPG وPNG وWebP، بحد أقصى لحجم الملف يبلغ 15 ميجابايت لكل صورة."
        },
        {
          "q": "هل يمكنني تبديل وجه في مقطع فيديو على هذه الصفحة؟",
          "a": "لا، تقوم هذه الصفحة بمعالجة الصور الثابتة وإرجاع نتيجة الصورة."
        }
      ]
        },
        'image-enhancer': {
            name: 'محسّن الصور',
            desc: 'تحسين وضوح الصور بنقرة واحدة بالذكاء الاصطناعي',
            fullDesc: 'تحسين الصور إلى دقة 4K مع تفاصيل محسّنة. يستخدم خوارزميات AI متقدمة لتحسين التفاصيل، وجعل الصور الضبابية حادة وواضحة.',
            fileTooLarge: 'الصورة كبيرة جداً. يرجى استخدام ملف أقل من 15 ميغابايت (JPG أو PNG أو WebP).',
            notImageFile: 'يرجى رفع ملف صورة.',
            downloadName: 'image-enhanced.png',
            targetResolution: 'الدقة المستهدفة',
            outputFormat: 'تنسيق الإخراج',
            resolutions: {
                '2k': '2K',
                '4k': '4K',
                '8k': '8K'
            },
            formats: {
                JPEG: 'JPEG',
                PNG: 'PNG',
                WEBP: 'WEBP'
            },
            processFailed: 'فشلت المعالجة. جرب صورة أخرى أو تنسيق إخراج مختلف.'
        },
        'video-enhancer': {
            name: 'محسّن الفيديو',
            desc: 'تحسين جودة الفيديو بالتكبير بالذكاء الاصطناعي',
            fullDesc: 'تحسين جودة الفيديو إلى HD/4K باستخدام إدراج الإطارات والشحذ بالذكاء الاصطناعي.',
            notVideoFile: 'يرجى رفع ملف فيديو (مثلاً MP4، MOV، AVI).',
            fileTooLarge: 'الفيديو كبير جداً. يرجى استخدام ملف أقل من 100 ميغابايت.'
        },
        'cartoon-video-style-converter': {
            name: 'محول نمط الكرتون',
            desc: 'تحويل الفيديوهات إلى نمط كرتوني',
            fullDesc: 'ارفع فيديو وسيقوم الذكاء الاصطناعي بتحويله إلى نمط كرتوني مع الحفاظ على الحركة الرئيسية والتكوين والإيقاع.',
            notVideoFile: 'يرجى رفع ملف فيديو صالح.',
            fileTooLarge: 'الفيديو كبير جداً. يرجى اختيار فيديو أقل من 100 ميغابايت.',
            downloadName: 'cartoon-style-video.mp4'
        },
        'anime-video-style-converter': {
            name: 'محول نمط الأنمي',
            desc: 'تحويل الفيديوهات إلى نمط أنمي',
            fullDesc: 'ارفع فيديو وسيقوم الذكاء الاصطناعي بتحويله إلى نمط أنمي مع الحفاظ على حركة العنصر وإيقاع المشهد.',
            notVideoFile: 'يرجى رفع ملف فيديو صالح.',
            fileTooLarge: 'الفيديو كبير جداً. يرجى اختيار فيديو أقل من 100 ميغابايت.',
            downloadName: 'anime-style-video.mp4'
        },
        'oil-painting-video-style-converter': {
            name: 'محول نمط الرسم الزيتي',
            desc: 'تحويل الفيديوهات إلى نمط الرسم الزيتي',
            fullDesc: 'ارفع فيديو وسيقوم الذكاء الاصطناعي بتحويله إلى نمط الرسم الزيتي بألوان غنية وملمس فني.',
            notVideoFile: 'يرجى رفع ملف فيديو صالح.',
            fileTooLarge: 'الفيديو كبير جداً. يرجى اختيار فيديو أقل من 100 ميغابايت.',
            downloadName: 'oil-painting-style-video.mp4'
        },
        'cyberpunk-video-style-converter': {
            name: 'محول نمط السايبربانك',
            desc: 'تحويل الفيديوهات إلى نمط سايبربانك',
            fullDesc: 'ارفع فيديو وسيقوم الذكاء الاصطناعي بتحويله إلى نمط سايبربانك مستقبلي عالي التباين بإضاءة نيون.',
            notVideoFile: 'يرجى رفع ملف فيديو صالح.',
            fileTooLarge: 'الفيديو كبير جداً. يرجى اختيار فيديو أقل من 100 ميغابايت.',
            downloadName: 'cyberpunk-style-video.mp4'
        },
        'photo-restore': {
            name: 'استعادة الصور',
            desc: 'استعادة الصور القديمة أو الضبابية أو التالفة بتقنية الذكاء الاصطناعي',
            fullDesc: 'استعادة الصور القديمة أو الضبابية أو التالفة بتقنية الذكاء الاصطناعي. يدعم إزالة الضوضاء والشحذ وملء الأجزاء المفقودة لإحياء الذكريات الثمينة.',
            notImageFile: 'يرجى رفع ملف صورة صالح.',
            fileTooLarge: 'الصورة كبيرة جداً، يرجى اختيار صورة أقل من 15 ميغابايت.',
            downloadName: 'photo-restored.png'
        },
        'blurry-photo-repair': {
            name: 'إصلاح الصور الضبابية',
            desc: 'إصلاح الصور الضبابية واستعادة التفاصيل الأوضح بالذكاء الاصطناعي',
            fullDesc: 'إصلاح الصور الضبابية بالذكاء الاصطناعي. تحسين الحدة، استعادة تفاصيل الوجوه والملمس، وجعل الصور الناعمة أكثر وضوحاً للمشاركة أو الأرشفة.',
            notImageFile: 'يرجى رفع ملف صورة صالح.',
            fileTooLarge: 'الصورة كبيرة جداً، يرجى اختيار صورة أقل من 15 ميغابايت.',
            downloadName: 'blurry-image-fixed.png'
        },
        'cartoon-digital-human': {
            name: 'مولّد شخصيات كرتونية بالذكاء الاصطناعي',
            desc: 'تحويل صورة شخصية إلى نمط كرتوني',
            fullDesc: 'إنشاء شخصية رقمية كرتونية بأسلوب الأنمي من صورة شخصية. الحفاظ على الملامح المميزة للشخص مع إنشاء أفاتار مصقول بخطوط نظيفة وألوان حيوية.',
            notImageFile: 'يرجى رفع ملف صورة صالح.',
            fileTooLarge: 'الصورة كبيرة جداً، يرجى اختيار صورة أقل من 15 ميغابايت.',
            downloadName: 'cartoon-digital-human.png'
        },
        'manga-digital-human': {
            name: 'مولّد شخصيات مانغا بالذكاء الاصطناعي',
            desc: 'تحويل صورة شخصية إلى نمط مانغا',
            fullDesc: 'إنشاء شخصية رقمية بأسلوب المانغا من صورة شخصية. الحفاظ على الملامح المميزة للشخص مع إنشاء مظهر كوميكي نظيف بخطوط معبرة وتظليل مصقول.',
            notImageFile: 'يرجى رفع ملف صورة صالح.',
            fileTooLarge: 'الصورة كبيرة جداً، يرجى اختيار صورة أقل من 15 ميغابايت.',
            downloadName: 'manga-digital-human.png'
        },
        'oil-painting-digital-human': {
            name: 'مولّد بورتريه زيتي بالذكاء الاصطناعي',
            desc: 'تحويل صورة شخصية إلى نمط الرسم الزيتي',
            fullDesc: 'إنشاء شخصية رقمية بأسلوب الرسم الزيتي من صورة شخصية. الحفاظ على الملامح المميزة مع إنشاء لوحة شخصية مصقولة بألوان غنية وملمس فرشاة.',
            notImageFile: 'يرجى رفع ملف صورة صالح.',
            fileTooLarge: 'الصورة كبيرة جداً، يرجى اختيار صورة أقل من 15 ميغابايت.',
            downloadName: 'oil-painting-digital-human.png'
        },
        'id-photo-generator': {
            name: 'مولّد صور الهوية',
            desc: 'إنشاء صورة هوية قياسية من صورة شخصية',
            fullDesc: 'إنشاء صورة هوية نظيفة واحترافية من صورة شخصية. يقوم الذكاء الاصطناعي بتعديل الموضوع ليظهر بشكل مناسب لصور الملفات الشخصية والهوية.',
            notImageFile: 'يرجى رفع ملف صورة صالح.',
            fileTooLarge: 'الصورة كبيرة جداً، يرجى اختيار صورة أقل من 15 ميغابايت.',
            downloadName: 'id-photo.png'
        },
        'ai-change-clothes': {
            name: 'تغيير الملابس بالذكاء الاصطناعي',
            desc: 'ارفع صور الملابس والشخص، تغيير الملابس بنقرة واحدة',
            fullDesc: 'ارفع صورة الملابس أولاً، ثم ارفع صورة الشخص. يقوم الذكاء الاصطناعي بنقل الملابس المختارة على الصورة الشخصية مع الحفاظ على الشخص والوضعية وتفاصيل الصورة الطبيعية.',
            demoTitle: 'عرض تجريبي',
            notImageFile: 'يرجى رفع ملف صورة صالح.',
            fileTooLarge: 'الصورة كبيرة جداً، يرجى اختيار صورة أقل من 15 ميغابايت.',
            firstImageLabel: 'صورة الملابس',
            uploadFirstImage: 'رفع صورة الملابس',
            changeFirstImage: 'تغيير صورة الملابس',
            secondImageLabel: 'صورة الشخص',
            uploadSecondImage: 'رفع صورة الشخص',
            changeSecondImage: 'تغيير صورة الشخص',
            uploadingSecondImage: 'جاري رفع صورة الشخص...',
            downloadName: 'ai-outfit-changed.png'
        },
        'handwritten-erase': {
            name: 'ممحاة الكتابة اليدوية',
            desc: 'مسح النص المكتوب يدوياً من المستندات بالذكاء الاصطناعي',
            fullDesc: 'اكتشاف ومسح النص المكتوب يدوياً من المستندات تلقائياً مع الحفاظ على المحتوى المطبوع. مثالي للامتحانات والملاحظات والعقود والمزيد. يدعم القص والتقويم والتدوير.',
            docDirection: 'التدوير',
            docDirections: {
                none: 'بدون تدوير',
                rotate90: '90° مع عقارب الساعة',
                rotate180: '180° مع عقارب الساعة',
                rotate270: '270° مع عقارب الساعة',
                auto: 'اكتشاف تلقائي'
            },
            crop: 'قص الحواف',
            dewarp: 'تقويم',
            notImageFile: 'يرجى رفع ملف صورة صالح',
            fileTooLarge: 'الصورة كبيرة جداً، يرجى اختيار صورة أقل من 15 ميغابايت',
            noImageInResponse: 'فشلت المعالجة، يرجى المحاولة مرة أخرى',
            downloadName: 'handwriting-erased.png',
      "featuresKicker": "إزالة خط اليد من الوثيقة",
      "featuresTitle": "إزالة الكتابة اليدوية واستعادة المستندات النظيفة",
      "featuresIntro": "قم بتنظيف الإجابات المكتوبة بخط اليد ومراجعات العقود وملاحظات المراجعة وعلامات المستندات الممسوحة ضوئيًا مع الحفاظ على النص المطبوع والتخطيط الأصلي.",
      "features": [
        {
          "title": "إزالة إجابات الطلاب من أوراق الاختبار",
          "desc": "اكتشف الإجابات المكتوبة بخط اليد والحسابات والشروح على أوراق الاختبار المكتملة تلقائيًا.",
          "cta": "إجابات ورقة الاختبار النظيفة مجانًا"
        },
        {
          "title": "محو الكتابة اليدوية من العقود",
          "desc": "قم بتنظيف الإضافات المكتوبة بخط اليد والدوائر والمبالغ المتغيرة والأسهم وملاحظات المراجعة مع الحفاظ على الجمل المطبوعة والجداول والتخطيط.",
          "cta": "الكتابة اليدوية للعقد النظيف عبر الإنترنت"
        },
        {
          "title": "إعداد وطباعة الاختبارات للتدريس",
          "desc": "إجابات واضحة للطلاب وتعليقات المعلم للدروس، وإعداد الاختبار، وأرشفة المستندات.",
          "cta": "جرب منظف ورق اختبار المعلم"
        },
        {
          "title": "تنظيف العلامات المكتوبة بخط اليد من المستندات الممسوحة ضوئيًا",
          "desc": "قم بإزالة علامات التجزئة والأسهم والدوائر والملاحظات الهامشية وعلامات المراجعة من النماذج الممسوحة ضوئيًا وتقارير الفحص والمستندات المكتبية.",
          "cta": "تنظيف علامات المستندات الممسوحة ضوئيًا"
        }
      ],
      "useCasesKicker": "للطلاب والمعلمين",
      "useCasesTitle": "حالات الاستخدام التعليمي لإزالة الكتابة اليدوية باستخدام الذكاء الاصطناعي",
      "useCases": [
        {
          "title": "إزالة إجابة الاختبار",
          "desc": "مسح إجابات الطلاب وحساباتهم من أوراق الاختبار."
        },
        {
          "title": "مراجعة الخطأ",
          "desc": "قم باستعادة الأوراق المكتملة لجولة أخرى من التدريب."
        },
        {
          "title": "تنظيف المصنف",
          "desc": "إزالة المحتوى المكتوب بخط اليد من الواجبات المنزلية وأوراق العمل."
        },
        {
          "title": "التدريس والتحضير للاختبارات",
          "desc": "إنشاء أوراق نظيفة للدروس وإعادة الطباعة والأرشفة."
        },
        {
          "title": "تصحيح الورق الممسوح ضوئيًا",
          "desc": "قم بتدوير صور المستندات المنحرفة أو المنحنية واقتصاصها وإزالة تشويهها."
        },
        {
          "title": "تنظيف العقد والمذكرات",
          "desc": "إزالة الكتابة اليدوية والشروح من المستندات العامة."
        }
      ],
      "howToKicker": "ثلاث خطوات بسيطة",
      "howToTitle": "كيفية إزالة الإجابات المكتوبة بخط اليد من أوراق الاختبار عبر الإنترنت",
      "howToIntro": "قم بتحميل ورقة اختبار أو مستند، وقم بتعيين خيارات التدوير والقص وإزالة التشوه، ثم قم بتنزيل النتيجة التي تم تنظيفها.",
      "steps": {
        "upload": {
          "title": "قم بتحميل ورقة أو مستند اختبار",
          "desc": "قم بتحميل ورقة اختبار JPG أو PNG أو WebP أو ورقة واجب منزلي أو مستند ممسوح ضوئيًا بحجم أقل من 15 ميجابايت."
        },
        "process": {
          "title": "تكوين وإزالة الكتابة اليدوية",
          "desc": "اختر اتجاه المستند وقم بتمكين الاقتصاص أو إزالة التشوه حسب الحاجة، ثم ابدأ المعالجة."
        },
        "download": {
          "title": "المراجعة والتنزيل",
          "desc": "قارن بين الصور قبل وبعد، أو قم بتنزيل المستند النظيف، أو قم بمعالجة صورة أخرى."
        }
      },
      "faqTitle": "الأسئلة الشائعة حول مزيل إجابات ورق الاختبار بالذكاء الاصطناعي",
      "faqs": [
        {
          "q": "ما الأداة التي يمكنني استخدامها لإزالة الإجابات المكتوبة بخط اليد من أوراق الاختبار؟",
          "a": "يكتشف مزيل الكتابة اليدوية Miral AI الإجابات والحسابات والشروح المكتوبة بخط اليد مع الحفاظ على الأسئلة المطبوعة والتخطيط الأصلي حيثما أمكن ذلك."
        },
        {
          "q": "هل يمكن للذكاء الاصطناعي إزالة الكتابة اليدوية مع الحفاظ على النص المطبوع؟",
          "a": "يمكنه استعادة الورق النظيف مع الحفاظ على النص المطبوع عندما لا تتداخل الكتابة اليدوية بشكل كبير مع المحتوى المطبوع."
        },
        {
          "q": "هل يستطيع المعلمون تنظيف أوراق الاختبار وإعادة طباعتها؟",
          "a": "نعم. إنها مناسبة لإعداد الدروس، وشرح الفصول الدراسية، وإنشاء الاختبارات، وأرشفة المستندات."
        },
        {
          "q": "هل يمكن للطلاب إعادة أوراق الإجابة للمراجعة؟",
          "a": "نعم. يمكن إعادة استخدام أوراق الاختبار وأوراق العمل التي تم تنظيفها لمراجعة الأخطاء ومزيد من التدريب."
        },
        {
          "q": "كيف يمكنني مسح الملاحظات المكتوبة بخط اليد وعلامات القلم والتعليقات التوضيحية بالحبر الأحمر؟",
          "a": "قم بتحميل صورة المستند وتشغيل مزيل الكتابة اليدوية. ويمكنه معالجة ألوان الكتابة اليدوية وأدوات الكتابة المختلفة، على الرغم من أن النتائج تعتمد على الوضوح والتداخل مع النص المطبوع."
        },
        {
          "q": "كيف أقوم بإصلاح المسح الضوئي المنحرف أو المنحني قبل إزالة الكتابة اليدوية؟",
          "a": "قم بتحريك المسح المائل أو تدويره أولاً. استخدم الاقتصاص للخلفية الزائدة وإزالة الانحراف فقط للصفحات المنحنية بشكل حقيقي قبل معالجة الكتابة اليدوية."
        },
        {
          "q": "ما هي تنسيقات الصور المدعومة؟",
          "a": "يتم دعم صور JPG وPNG وWebP التي يقل حجمها عن 15 ميجابايت. ملفات PDF غير مدعومة على هذه الصفحة."
        }
      ]
        },
        category: {
            image: 'أدوات الصور',
            video: 'أدوات الفيديو',
            document: 'أدوات المستندات'
        },
        categoryModal: {
            title: 'اختر فئة الأداة'
        },
        convert: {
            success: 'اكتمل التحويل!',
            zipHint: 'النتيجة معبأة كملف ZIP يحتوي على صور متعددة',
            fileTooLarge: 'الملف كبير جداً، يرجى اختيار ملف أقل من 50 ميغابايت',
            multiImageHint: 'يدعم رفع صور متعددة ودمجها في ملف PDF واحد',
            addMore: 'إضافة المزيد',
            demoTitle: 'معاينة التحويل',
            sourceLabel: 'المصدر',
            targetLabel: 'الإخراج'
        },
        'pdf-to-word': {
            name: 'PDF إلى Word',
            desc: 'تحويل ملفات PDF إلى مستندات Word قابلة للتعديل',
            fullDesc: 'تحويل ملفات PDF ذكياً إلى مستندات Word قابلة للتعديل، مع الحفاظ الدقيق على التخطيط والجداول والصور والمزيد. يدعم النصوص الصينية والإنجليزية المختلطة.'
        },
        'image-to-word': {
            name: 'صورة إلى Word',
            desc: 'تحويل النصوص في الصور إلى مستندات Word',
            fullDesc: 'التعرف ذكياً على النصوص والجداول والمحتويات الأخرى في الصور وتحويلها إلى مستندات Word، مع الحفاظ على تنسيق التخطيط الأصلي. يدعم استخراج الأختام والتعرف على الكتابة اليدوية.'
        },
        'pdf-to-excel': {
            name: 'PDF إلى Excel',
            desc: 'تحويل جداول PDF إلى ملفات Excel قابلة للتعديل',
            fullDesc: 'التعرف ذكياً على محتوى الجداول في ملفات PDF وتحويلها إلى ملفات Excel قابلة للتعديل، مع الحفاظ الدقيق على بنية الجداول والبيانات.'
        },
        'pdf-to-ppt': {
            name: 'PDF إلى PPT',
            desc: 'تحويل ملفات PDF إلى عروض PPT تقديمية قابلة للتعديل',
            fullDesc: 'تحويل ملفات PDF ذكياً إلى عروض PPT تقديمية قابلة للتعديل، مع الحفاظ على التخطيط الأصلي والصور ومحتوى النص.'
        },
        'pdf-to-image': {
            name: 'PDF إلى صورة',
            desc: 'تحويل كل صفحة PDF إلى صور عالية الجودة',
            fullDesc: 'تحويل كل صفحة من ملف PDF إلى صور عالية الجودة. يدعم التحويل الدفعي لملفات PDF متعددة الصفحات، مع تعبئة النتائج كملف ZIP للتحميل.'
        },
        'word-to-pdf': {
            name: 'Word إلى PDF',
            desc: 'تحويل مستندات Word إلى ملفات PDF',
            fullDesc: 'تحويل مستندات Word بسرعة إلى ملفات PDF، مع الحفاظ على التخطيط الأصلي والخطوط والصور لضمان تناسق التنسيق.'
        },
        'excel-to-pdf': {
            name: 'Excel إلى PDF',
            desc: 'تحويل جداول Excel إلى ملفات PDF',
            fullDesc: 'تحويل جداول Excel إلى ملفات PDF، مع الحفاظ على بنية الجداول وتخطيط البيانات لسهولة المشاركة والطباعة.'
        },
        'image-to-pdf': {
            name: 'صورة إلى PDF',
            desc: 'دمج صور متعددة في ملف PDF واحد',
            fullDesc: 'دمج صور متعددة في ملف PDF واحد. يدعم تنسيقات الصور الشائعة مثل JPG و PNG و BMP للإدارة والمشاركة الموحدة.'
        },
        'word-to-image': {
            name: 'Word إلى صورة',
            desc: 'تحويل كل صفحة من مستند Word إلى صورة',
            fullDesc: 'تحويل كل صفحة من مستند Word إلى صور عالية الجودة. يدعم التحويل الدفعي للمستندات متعددة الصفحات، مع تعبئة النتائج كملف ZIP للتحميل.'
        }
    },
    plans: {
        basic: {
            name: 'أساسي',
            features: [
                'جميع الأرصدة تُسلّم دفعة واحدة',
                'توليد ما يصل إلى 2,600 صورة AI',
                'توليد 520 فيديو AI',
                'توليد ما يصل إلى 480 مقطوعة موسيقية AI',
                'بدون علامات مائية',
                'ترخيص تجاري'
            ]
        },
        pro: {
            name: 'احترافي',
            features: [
                'جميع الأرصدة تُسلّم دفعة واحدة',
                'توليد ما يصل إلى 10,600 صورة AI',
                'توليد ما يصل إلى 2,120 فيديو AI',
                'توليد ما يصل إلى 1,920 مقطوعة موسيقية AI',
                'جميع النماذج المميزة',
                'طابور أولوية',
                'دعم ذو أولوية',
                'وضع الخصوصية والتوافق مع DPA'
            ]
        },
        ultimate: {
            name: 'متقدم',
            features: [
                'جميع الأرصدة تُسلّم دفعة واحدة',
                'توليد ما يصل إلى 36,600 صورة AI',
                'توليد ما يصل إلى 7,320 فيديو AI',
                'توليد ما يصل إلى 6,720 مقطوعة موسيقية AI',
                'جميع النماذج المميزة',
                'دعم مخصص',
                'وضع الخصوصية والتوافق مع DPA'
            ]
        }
    },
    faq: {
        categories: {
            all: 'الكل',
            general: 'عام',
            pricing: 'الأسعار',
            models: 'النماذج',
            features: 'الميزات'
        },
        items: [
            {
                q: 'ما هو Miral؟',
                a: 'Miral هو منصة إنشاء بالذكاء الاصطناعي شاملة تدمج أكثر من 29 نموذج AI رائد، وتدعم إنشاء الصور والفيديو والموسيقى وأدوات التحرير الاحترافية. لا حاجة للتبديل بين المنصات - حساب واحد يمنحك الوصول إلى جميع النماذج الرئيسية بما في ذلك FLUX و Midjourney و Sora و Veo و Kling والمزيد.'
            },
            {
                q: 'ما هي نماذج الذكاء الاصطناعي المدعومة؟',
                a: 'ندعم أكثر من 29 نموذج AI رائد، بما في ذلك نماذج الصور (FLUX 2 Max، Midjourney، Seedream، GPT-Image-1، Nano Banana، إلخ)، ونماذج الفيديو (Veo 3.1، Sora 2، Kling 2.6، Seedance، Wan 2.5، إلخ)، ونماذج إنشاء الموسيقى بالذكاء الاصطناعي. يتم تحديث جميع النماذج باستمرار.'
            },
            {
                q: 'كيف يعمل نظام الأرصدة؟',
                a: 'نستخدم نظام أرصدة موحد. يبدأ إنشاء الصور من 2 أرصدة، وإنشاء الفيديو من 10 أرصدة، والموسيقى من 10 أرصدة لكل مقطوعة. قد تستهلك النماذج المميزة أرصدة أكثر. يستمتع المشتركون بأسعار أرصدة أقل ويمكنهم أيضاً شراء حزم أرصدة بشكل منفصل.'
            },
            {
                q: 'هل يمكنني إنشاء صور وفيديوهات وموسيقى؟',
                a: 'نعم! يدعم Miral تحويل النص إلى صورة، وتحرير الصور، ونقل الأنماط، وتحويل النص إلى فيديو، وتحويل الصورة إلى فيديو، وإنشاء الموسيقى بالذكاء الاصطناعي، والمزيد - لتلبية جميع الاحتياجات الإبداعية من المشاريع الشخصية إلى الأعمال التجارية.'
            },
            {
                q: 'ما مدى سرعة التوليد؟',
                a: 'يتم إنجاز معظم إنشاء الصور خلال 30 ثانية، ويستغرق إنشاء الفيديو حوالي 1-6 دقائق. نقوم بتحسين بنيتنا التحتية باستمرار لضمان إنشاء سريع ومستقر.'
            },
            {
                q: 'هل يمكنني استخدام Miral لأغراض تجارية؟',
                a: 'نعم. جميع الخطط المدفوعة تتضمن تراخيص تجارية، تتيح لك استخدام المحتوى المُنشأ للمشاريع التجارية ومواد التسويق ووسائل التواصل الاجتماعي والمزيد.'
            },
            {
                q: 'هل يتوفر الوصول عبر API؟',
                a: 'نعم، تتضمن الخطة المتقدمة الوصول عبر API. من خلال واجهة برمجة التطبيقات الشاملة لدينا، يمكنك دمج إنشاء الصور والفيديو والموسيقى بالذكاء الاصطناعي مباشرة في تطبيقاتك.'
            },
            {
                q: 'هل يمكنني إنشاء موسيقى بالذكاء الاصطناعي؟',
                a: 'بالتأكيد! يدعم مولّد الموسيقى بالذكاء الاصطناعي لدينا أنماطاً موسيقية متنوعة. ما عليك سوى وصف ما تريده لإنشاء موسيقى أصلية، مثالية للمؤثرات الصوتية للفيديو وموسيقى الخلفية للبودكاست والمزيد.'
            },
            {
                q: 'كيف تتعاملون مع خصوصية البيانات والأمان؟',
                a: 'نلتزم بشكل صارم بمعايير التوافق مع GDPR. جميع البيانات مشفرة ولا تُستخدم لتدريب الذكاء الاصطناعي. يمكن للمستخدمين حذف حساباتهم وجميع بياناتهم في أي وقت.'
            },
            {
                q: 'هل يمكن للآخرين رؤية أعمالي؟',
                a: 'بشكل افتراضي، أعمالك مرئية لك فقط. يمكن لمستخدمي الخطتين الاحترافية والمتقدمة تفعيل وضع الخصوصية لضمان خصوصية كاملة.'
            },
            {
                q: 'كيف يمكنني حذف حسابي وبياناتي؟',
                a: 'يمكنك طلب حذف حسابك من إعدادات حسابك في أي وقت. سنحذف جميع بياناتك ومحتواك المُنشأ خلال 30 يوماً.'
            },
            {
                q: 'هل يمكنني الحصول على دعم إذا واجهت مشاكل؟',
                a: 'بالطبع! يمكنك التواصل مع فريق الدعم لدينا على miral_support@miralvis.com. يحصل مستخدمو الخطة الاحترافية على دعم ذي أولوية، ويحصل مستخدمو الخطة المتقدمة على دعم مخصص.'
            }
        ]
    },
    testimonials: {
        items: [
            {
                name: 'Alex Chen',
                role: 'مدير التسويق الرقمي',
                tag: 'توفير 90% من الوقت',
                content: 'أصبح Miral مركز المحتوى المرئي لدينا. إنشاء صور المنتجات باستخدام Midjourney، وإنشاء فيديوهات ترويجية باستخدام Veo، ثم تحرير كل شيء في Miral - كل ذلك دون تبديل المنصات.'
            },
            {
                name: 'Sarah Rodriguez',
                role: 'صاحبة متجر إلكتروني',
                tag: 'تحويل أعلى بنسبة 40%',
                content: 'الوصول إلى أكثر من 29 نموذج في مكان واحد أمر مذهل. أستخدم Seedream لصور المنتجات، و Seedance لإعلانات الفيديو، وأدوات تحسين الدقة للكتالوجات. ارتفع التحويل بنسبة 40%!'
            },
            {
                name: 'David Kim',
                role: 'صانع محتوى',
                tag: 'أكثر من 500 ألف متابع',
                content: 'أقوم بإنشاء صور باستخدام FLUX و Nano Banana، ثم أحولها إلى فيديوهات فيروسية باستخدام Kling و Sora. نظام الأرصدة عادل - ادفع حسب الاستخدام. متابعي يحبون المحتوى المتنوع!'
            },
            {
                name: 'Emma Thompson',
                role: 'مصممة جرافيك',
                tag: 'مستوى احترافي',
                content: 'كمصممة، كنت متشككة حول منصات الذكاء الاصطناعي. لكن مكتبة النماذج الغنية في Miral وأدوات التحرير الدقيقة مثيرة للإعجاب حقاً - من الرسوم المفاهيمية إلى المنتجات النهائية، كل شيء سهل.'
            },
            {
                name: 'James Wilson',
                role: 'منتج فيديو',
                tag: 'سير عمل أسرع 10 مرات',
                content: 'نماذج الفيديو هنا مذهلة - Veo سينمائي، و Seedance سريع، ورسوم Wan المتحركة طبيعية. جميع النماذج تشترك في نظام أرصدة واحد - يوفر الوقت والمال.'
            },
            {
                name: 'Lisa Park',
                role: 'صاحبة وكالة إبداعية',
                tag: 'الخيار الأول للفريق',
                content: 'فريقنا بالكامل انتقل إلى Miral. تكامل API سلس، وتنوع النماذج يعني أننا دائماً نجد الأداة المناسبة. هذه أفضل منصة ذكاء اصطناعي متاحة.'
            }
        ]
    },
    langModal: {
        title: 'اختر اللغة'
    },
    home: {
        searchModel: 'بحث عن نموذج...',
        newModels: 'نماذج جديدة',
        otherModels: 'نماذج أخرى',
        selectModel: 'اختر نموذجاً',
        promptPlaceholderImage: 'صِف الصورة التي تريد إنشاءها...',
        promptPlaceholderVideo: 'صِف الفيديو الذي تريد إنشاءه...',
        generate: 'توليد',
        chatDisabledGenerateHint: 'يرجى إدخال وصف',
        compactChatPlaceholder: 'أدخل وصفك لإنشاء صور وفيديوهات مذهلة بالذكاء الاصطناعي وموسيقى أصلية',
        hero: {
            title: 'Miral – منصة ذكاء اصطناعي شاملة لإنشاء الصور والفيديو والموسيقى',
            subtitle: 'بفضل نماذج الذكاء الاصطناعي المتنوعة، يجمع Miral بين تحرير الصور وإنشاء الفيديو وصناعة الموسيقى بالذكاء الاصطناعي. عدّل الصور وأنشئ فيديوهات بورتريه سينمائية وموسيقى خلفية مخصصة للمشاريع الشخصية والتجارية.',
            createVideo: 'إنشاء فيديو',
            createImage: 'إنشاء صورة'
        },
        stats: {
            models: 'نماذج AI رائدة',
            works: 'أعمال تم إنشاؤها',
            tools: 'أدوات احترافية',
            platforms: 'منصات شريكة'
        },
        generatorNew: {
            promptPlaceholder: 'صِف الفيديو الذي تريد إنشاءه...',
            promptPlaceholderImage: 'صِف الصورة التي تريد إنشاءها...',
            generating: 'جاري التوليد...',
            noHistory: 'ستظهر النتائج هنا بعد التوليد',
            generationFailed: 'فشل التوليد',
            historyTitle: 'السجل',
            myAssets: 'أصولي'
        },
        quickTools: {
            title: 'أدوات ذكاء اصطناعي سريعة'
        },
        exploreMore: {
            title: 'استكشف المزيد من ميزات الذكاء الاصطناعي'
        },
        musicPresets: [
            { label: 'نشيد بوب حماسي', value: 'Upbeat Pop Anthem' },
            { label: 'إيقاع لو-فاي هادئ', value: 'Chill Lo-fi Beat' },
            { label: 'موسيقى سينمائية ملحمية', value: 'Cinematic Epic Score' },
            { label: 'أغنية فوك أكوستيك', value: 'Acoustic Folk Song' },
            { label: 'مقطوعة رقص إلكترونية', value: 'Electronic Dance Track' },
            { label: 'أجواء جاز استرخائية', value: 'Jazz Lounge Vibe' },
            { label: 'روك بالاد قوي', value: 'Rock Power Ballad' },
            { label: 'تأمل محيطي', value: 'Ambient Meditation' }
        ],
        musicPresetsPlaceholder: 'اختر نمط موسيقي مسبق',
        platform: {
            tag: 'المنصة',
            title: 'أدوات AI تجعل الإنشاء بسيطاً',
            subtitle: 'إنشاء صور وفيديو وموسيقى وأدوات احترافية مدعومة بنماذج ذكاء اصطناعي رائدة في الصناعة.',
            tabs: {
                image: 'صور AI',
                video: 'فيديو AI',
                music: 'موسيقى AI',
                tools: 'أدوات AI'
            },
            image: {
                title: 'إنشاء وتحرير صور مذهلة بأفضل نماذج الذكاء الاصطناعي العالمية',
                desc: 'تحويل النص إلى صورة، تحرير دقيق، نقل الأنماط، وتحسين الدقة. مدعوم بـ FLUX و Midjourney و Seedream و GPT-Image-1 و Nano Banana.',
                explore: 'استكشاف نماذج الصور ←'
            },
            video: {
                title: 'إنشاء فيديوهات سينمائية بالذكاء الاصطناعي',
                desc: 'من تحويل النص إلى فيديو إلى تحريك الصور، مدعوم بنماذج Veo و Sora و Kling و Seedance و Wan. إنشاء فيديوهات مع صوت متزامن وتصوير سينمائي احترافي.',
                explore: 'استكشاف نماذج الفيديو ←'
            },
            music: {
                title: 'إنشاء موسيقى أصلية بالذكاء الاصطناعي',
                desc: 'إنشاء موسيقى أصلية من الأوصاف، مع دعم أنماط ومدد متنوعة. مثالية للمؤثرات الصوتية للفيديو وموسيقى خلفية البودكاست والمزيد.',
                explore: 'استكشاف موسيقى AI ←'
            },
            tools: {
                title: 'أدوات AI احترافية',
                desc: 'إزالة العلامات المائية، استعادة الصور، تحسين الدقة، تحسين الفيديو وأدوات احترافية أخرى لجميع احتياجات المعالجة اللاحقة.',
                explore: 'عرض جميع الأدوات ←'
            }
        },
        models: {
            tag: 'النماذج',
            title: 'تكامل شامل لأفضل نماذج الذكاء الاصطناعي العالمية',
            subtitle: 'منصة واحدة تدمج جميع نماذج AI السائدة. لا مزيد من التبديل بين حسابات واشتراكات متعددة.',
            imageModels: 'نماذج الصور',
            videoModels: 'نماذج الفيديو',
            musicModels: 'موسيقى AI',
            musicDesc: 'إنشاء موسيقى أصلية من الأوصاف',
            filterAll: 'الكل',
            credits: 'الأرصدة',
            viewAll: 'عرض الكل ←'
        },
        features: {
            tag: 'الميزات الأساسية',
            title: 'إنشاء صور وفيديوهات وموسيقى مذهلة',
            subtitle: 'من تحويل النص إلى صورة وفيديو إلى إنشاء الموسيقى بالذكاء الاصطناعي، بالإضافة إلى التحرير الدقيق وتحسين الدقة — إنشاء شامل.',
            items: {
                textToImage: {
                    tag: 'نص إلى صورة',
                    title: 'نص إلى صورة',
                    desc: 'أدخل وصفاً وشاهد السحر. سواء صور شخصية فائقة الواقعية أو مناظر طبيعية خيالية، استخدم Midjourney و Seedream و Nano Banana ونماذج أخرى لإنشاء تحف بصرية بأوصاف بسيطة.',
                    cta: 'إنشاء صور',
                    imageAlt: 'إنشاء تحف بصرية بأوصاف بسيطة باستخدام Midjourney و Seedream و Nano Banana ونماذج أخرى'
                },
                imageEdit: {
                    tag: 'تحرير الصور ونقل الأنماط',
                    title: 'تحرير الصور ونقل الأنماط',
                    desc: 'استخدم الذكاء الاصطناعي لإعادة تشكيل الصور بدقة. سواء تغيير الأنماط أو تعديل العناصر أو استبدال الخلفيات أو تحرير النصوص، كل ذلك باتساق عالٍ.',
                    cta: 'تحرير الصور',
                    beforeAlt: 'قبل تحرير الصور ونقل الأنماط',
                    afterAlt: 'بعد تحرير الصور ونقل الأنماط'
                },
                textToVideo: {
                    tag: 'نص إلى فيديو',
                    title: 'نص إلى فيديو',
                    desc: 'فقط أدخل وصفاً لإنشاء فيديوهات سينمائية مع صوت متزامن وتصوير احترافي وحركة واقعية. اختر من بين نماذج Veo و Sora و Kling و Seedance و Wan.',
                    cta: 'إنشاء فيديو'
                },
                imageToVideo: {
                    tag: 'صورة إلى فيديو',
                    title: 'صورة إلى فيديو',
                    desc: 'حوّل الصور الثابتة إلى فيديوهات سينمائية. سواء صور المنتجات أو الرسوم التوضيحية أو الصور المُنشأة بالذكاء الاصطناعي، أضف الحياة إليها بحركة طبيعية وتعليق صوتي.',
                    cta: 'تحريك الصور'
                },
                upscale: {
                    tag: 'تحسين الدقة',
                    title: 'تحسين الدقة',
                    desc: 'استخدم الذكاء الاصطناعي لتحسين جودة الصور والفيديو. دعم تحسين الدقة عالية الجودة بدون فقدان ورفع دقة الفيديو إلى مستوى احترافي 4K.',
                    cta: 'حسّن الآن',
                    imageAlt: 'استخدم الذكاء الاصطناعي لتحسين جودة الصور والفيديو'
                },
                templates: {
                    tag: 'أكثر من 40 قالب صورة',
                    title: 'أكثر من 40 قالب صورة',
                    desc: 'قوالب ضخمة لإلهام الإبداع: نماذج ثلاثية الأبعاد، نمط غيبلي، ألعاب مصمم، مولّد ميمز، أغلفة مجلات، والمزيد — ارفع صورة واحصل على نتائج فورية.',
                    cta: 'تصفح القوالب',
                    imageAlt: 'مثال على قالب صورة'
                }
            }
        },
        gallery: {
            tag: 'المعرض',
            title: 'استكشف إمكانيات لا حصر لها',
            subtitle: 'شاهد ما يبدعه المبدعون باستخدام Miral — من الصور فائقة الواقعية إلى الفيديوهات السينمائية، الإلهام بين يديك.',
            images: {
                alt1: 'مثال على صورة مُنشأة بواسطة Midjourney',
                alt2: 'مثال على صورة مُنشأة بواسطة Seedream',
                alt3: 'مثال على صورة مُنشأة بواسطة GPT-Image-1',
                alt4: 'مثال على صورة مُنشأة بواسطة Flux',
                alt5: 'مثال على صورة مُنشأة بواسطة Flux Pro',
                alt6: 'مثال على صورة مُنشأة بواسطة Midjourney',
                alt7: 'مثال على صورة مُنشأة بواسطة Seedream',
                alt8: 'مثال على صورة مُنشأة بواسطة GPT-Image-1'
            }
        },
        whyChoose: {
            tag: 'لماذا تختار Miral',
            title: 'إنشاء شامل، كل ما تحتاجه',
            subtitle: 'منصة شاملة تجمع أفضل نماذج إنشاء الصور والفيديو والموسيقى بالذكاء الاصطناعي في العالم.',
            items: {
                allModels: {
                    title: 'جميع النماذج مدمجة، واحد يكفي',
                    desc: 'وصول شامل إلى أكثر من 29 نموذج AI رائد من OpenAI و Google و Alibaba و ByteDance والمزيد. لا حاجة للتبديل بين الأدوات أو إدارة اشتراكات متعددة.'
                },
                fast: {
                    title: 'سرعة البرق',
                    desc: 'يتم إنجاز معظم إنشاء الصور خلال 30 ثانية، ويستغرق إنشاء الفيديو حوالي 1-6 دقائق. بنية تحتية محسّنة تضمن عدم الانتظار طويلاً.'
                },
                credits: {
                    title: 'نظام أرصدة بسيط',
                    desc: 'ادفع حسب الاستخدام، تسعير شفاف. ابدأ بأرصدة مجانية — لا حاجة لاشتراك للبدء في الإنشاء.'
                },
                api: {
                    title: 'واجهة برمجة تطبيقات للمطورين',
                    desc: 'ادمج إنشاء الصور والفيديو والموسيقى بالذكاء الاصطناعي مباشرة في تطبيقاتك من خلال واجهة برمجة التطبيقات الشاملة لدينا. ابنِ منتجك فوق أفضل نماذج AI.'
                }
            }
        },
        testimonials: {
            tag: 'قصص المستخدمين',
            title: 'موثوق من المبدعين حول العالم',
            subtitle: 'انضم إلى آلاف المحترفين والمبدعين الذين يستخدمون Miral لإنشاء الصور والفيديوهات وتشغيل سير عملهم الإبداعي.'
        },
        faq: {
            tag: 'الدعم',
            title: 'الأسئلة الشائعة',
            subtitle: 'دليل شامل للمنصة والنماذج المدعومة وخطط الأسعار والميزات.'
        },
        cta: {
            title: 'ابدأ رحلة إنشاء الذكاء الاصطناعي الآن',
            subtitle: 'انضم إلى آلاف المبدعين والمصممين والشركات التي تستخدم Miral لتحقيق إبداعها مع أفضل نماذج AI في العالم.',
            createImage: 'إنشاء صورة ←',
            createVideo: 'إنشاء فيديو ←',
            note: 'يحصل المستخدمون الجدد على أرصدة مجانية عند التسجيل. لا حاجة لبطاقة ائتمان.'
        },
        apps: {
            title: "التطبيقات",
            quickTitle: "تطبيقات ذكاء اصطناعي سريعة",
        more: "المزيد",
        keywords: {
            viralVideo: "فيديو رائج",
            tiktokAds: "إعلانات TikTok",
            productShowcase: "عرض المنتج",
            aiAvatar: "صورة رمزية بالذكاء الاصطناعي",
            homeModernKitchen: "مطبخ عصري"
        },
            social: 'وسائل التواصل الاجتماعي',
            posters: 'ملصقات',
            interior: 'المنزل',
            entertainment: 'الترفيه',
            lifestyle: 'نمط الحياة',
            comic: 'كوميك',
            items: {
                viralVideo: 'فيديو فيروسي',
                celebrityVideo: 'فيديو مشاهير',
                productShowcase: 'عرض منتج',
                tiktokAds: 'إعلانات TikTok',
                aiMeme: 'ميمز AI',
                aiAvatar: 'أفاتار AI',
                logoAnimation: 'تحريك شعار',
                socialShorts: 'فيديوهات قصيرة',
                brandStory: 'قصة علامة تجارية',
                tutorialClip: 'مقطع تعليمي',
                musicVideo: 'فيديو موسيقي AI',
                animeScene: 'مشهد أنمي',
                movieTrailer: 'إعلان فيلم',
                gameCinematic: 'مشهد لعبة سينمائي',
                visualPoetry: 'شعر بصري',
                natureDoc: 'فيلم وثائقي طبيعي',
                cyberpunkCity: 'مدينة سايبربانك',
                underwaterWorld: 'عالم تحت الماء',
                timelapseArt: 'فن تايم لابس',
                dailyVlog: 'فلوج يومي',
                cookingShow: 'برنامج طبخ',
                fitnessCoach: 'مدرب لياقة',
                travelDiary: 'يوميات سفر',
                fashionShow: 'عرض أزياء',
                petParadise: 'جنة الحيوانات الأليفة',
                weddingMoment: 'لحظة زفاف',
                yogaFlow: 'يوغا',
                homeDecor: 'ديكور منزلي',
                sunsetRun: 'جري عند الغروب',
                instagramReels: 'ريلز Instagram',
                youtubeIntro: 'مقدمة YouTube',
                linkedinPromo: 'ترويج LinkedIn',
                aiThumbnail: 'صورة مصغرة AI',
                podcastClip: 'مقطع بودكاست',
                horrorShort: 'فيديو رعب قصير',
                danceVideo: 'فيديو رقص',
                aiComic: 'كوميكس AI',
                magicShow: 'عرض سحري',
                fantasyWorld: 'عالم خيالي',
                diyCraft: 'حرف يدوية',
                morningRoutine: 'روتين صباحي',
                babyGrowth: 'نمو الطفل',
                streetFood: 'طعام الشوارع',
                bookTrailer: 'إعلان كتاب',
                socialLuxuryBag: 'حقيبة فاخرة',
                socialFashionVote: 'تصويت الموضة',
                socialSneakerDrop: 'حذاء أوربان فاخر',
                socialTropicalCocktail: 'كوكتيل عطلة الأسبوع',
                socialCityBillboard: 'إعلان لوحة المدينة',
                socialStreetwearDrop: 'إصدار ملابس الشارع',
                socialBoxingGloves: 'إعلان قفازات الملاكمة',
                homeEclecticLiving: 'غرفة معيشة انتقائية',
                homeFarmhouseKitchen: 'مطبخ ريفي',
                homeModernKitchen: 'مطبخ عصري بسيط',
                homeVictorianStairs: 'درج فيكتوري',
                homeScandiLiving: 'غرفة معيشة إسكندنافية',
                homeMediterraneanPatio: 'فناء متوسطي',
                homeBohoSunroom: 'غرفة شمسية بوهيمية',
                homeEclecticBedroom: 'غرفة نوم انتقائية',
                comicPortrait: 'كوميك بطل خارق',
                animeCharacter: 'أنمي ميكا',
                mangaScene: 'مانجا ليلة ممطرة',
                comicOilPainting: 'كوميك يومي',
                comicCover: 'كوميك بطل الطاقة',
                animePortrait: 'كوميك قفز الأسطح',
                comicCouple: 'كوميك البطل الصغير',
                mangaWarrior: 'كوميك الساحر'
            }
        }
    },
    musicTags: {
        pop: 'بوب',
        electronic: 'إلكتروني',
        classical: 'كلاسيكي',
        jazz: 'جاز'
    },
    music: {
        breadcrumb: {
            home: 'الرئيسية',
            aiMusic: 'موسيقى AI'
        },
        model: {
            label: 'النموذج',
            aiMusicName: 'موسيقى AI',
            desc: 'إنشاء موسيقى أصلية من الأوصاف، مع دعم أنماط ومدد متنوعة.',
            tagMusic: 'إنشاء موسيقى',
            tagLyrics: 'كتابة كلمات'
        },
        mode: {
            describe: 'وصف',
            lyrics: 'كتابة كلمات'
        },
        form: {
            musicDesc: 'وصف الموسيقى',
            musicDescPlaceholder: 'صِف النمط الموسيقي والمشاعر والمشهد الذي تريده...\n\nمثال: موسيقى إلكترونية مليئة بالطاقة مع ألحان سينثسيزر مستقبلية، مناسبة لفيديوهات ترويجية للمنتجات التقنية',
            optimize: 'تحسين',
            songTitle: 'عنوان الأغنية',
            songTitlePlaceholder: 'أدخل عنوان الأغنية...',
            lyricsDescLabel: 'وصف الكلمات',
            lyricsDescPlaceholder: 'اكتب وصف الكلمات هنا...\n\nمثال:\n[مقدمة]\n...\n[مقطع]\n...\n[لازمة]\n...',
            styleTags: 'وسوم الأنماط',
            styleTagsPlaceholder: 'انقر الوسوم أدناه للإضافة (اختيار متعدد)'
        },
        tags: {
            sections: [
                {label: 'مقطع', value: '[Verse]\n'},
                {label: 'لازمة', value: '[Chorus]\n'},
                {label: 'جسر', value: '[Bridge]\n'},
                {label: 'مقدمة', value: '[Intro]\n'},
                {label: 'خاتمة', value: '[Outro]\n'}
            ],
            styles: [
                {label: 'بوب', value: 'Pop'},
                {label: 'روك', value: 'Rock'},
                {label: 'جاز', value: 'Jazz'},
                {label: 'كلاسيكي', value: 'Classical'},
                {label: 'إلكتروني', value: 'Electronic'},
                {label: 'R&B', value: 'R&B'},
                {label: 'هيب هوب', value: 'Hip-Hop'},
                {label: 'كانتري', value: 'Country'},
                {label: 'فوك', value: 'Folk'},
                {label: 'أجواء', value: 'Ambient'},
                {label: 'سينمائي', value: 'Cinematic'},
                {label: 'لو-فاي', value: 'Lo-fi'},
                {label: 'ميتال', value: 'Metal'},
                {label: 'ريجي', value: 'Reggae'},
                {label: 'بلوز', value: 'Blues'},
                {label: 'سول', value: 'Soul'},
                {label: 'فانك', value: 'Funk'},
                {label: 'إندي', value: 'Indie'}
            ]
        },
        options: {
            duration: 'المدة',
            instrumental: 'موسيقى آلات',
            instrumentalDescOn: 'إنشاء موسيقى آلات فقط، بدون غناء',
            instrumentalDescOff: 'تضمين أداء صوتي'
        },
        errors: {
            titleRequired: 'عنوان الأغنية مطلوب',
            lyricsDescRequired: 'وصف الكلمات مطلوب'
        },
        footer: {
            creditsRequired: 'الأرصدة المطلوبة:',
            creditsLeft: 'المتبقي:',
            generate: 'إنشاء موسيقى'
        },
        preview: {
            generating: 'جاري إنشاء الموسيقى...',
            generatedTitle: 'الموسيقى المُنشأة',
            emptyTitle: 'مولّد موسيقى AI',
            emptySubtitle: 'أنشئ موسيقى أصلية بالذكاء الاصطناعي. صِف النمط أو أدخل كلمات، وأنشئ أغنيتك الخاصة في ثوانٍ.',
            emptyTags: ['بوب', 'جاز', 'سينمائي', 'Lo-fi', 'روك'],
            track: 'مقطوعة',
            play: 'تشغيل',
            pause: 'إيقاف مؤقت',
            mute: 'كتم',
            unmute: 'إلغاء الكتم',
            download: 'تحميل',
            showLyrics: 'عرض الكلمات',
            hideLyrics: 'إخفاء الكلمات',
            generateFailed: 'فشل التوليد',
            requestFailed: 'فشل الطلب، يرجى المحاولة مرة أخرى',
            downloadMp3: 'تحميل MP3',
            downloadWav: 'تحميل WAV',
            regenerate: 'إعادة الإنشاء',
            noHistory: 'لا يوجد سجل بعد'
        },
        intro: {
            title: 'مولّد موسيقى AI',
            desc: 'باستخدام تقنية الذكاء الاصطناعي المتقدمة، ما عليك سوى إدخال وصف أو كلمات لإنشاء موسيقى أصلية عالية الجودة. يدعم أنماطاً موسيقية متعددة، مناسب للمؤثرات الصوتية للفيديو والإعلانات والبودكاست والمزيد.',
            tagMusic: 'إنشاء موسيقى',
            tagLyrics: 'كتابة كلمات',
            tagStyles: 'أنماط متعددة',
            tagCommercial: 'ترخيص تجاري'
        },
        features: {
            badge: 'الميزات الأساسية',
            title: 'ماذا يمكن لمولّد موسيقى AI أن يفعل لك؟',
            items: {
                styles: {
                    icon: '🎵',
                    title: 'أنماط متعددة',
                    desc: 'يدعم البوب والروك والإلكترونية والجاز والكلاسيكية والهيب هوب وعشرات الأنماط الموسيقية لتلبية احتياجات إبداعية متنوعة.'
                },
                lyrics: {
                    icon: '📝',
                    title: 'كتابة كلمات',
                    desc: 'أدخل كلمات لإنشاء أغانٍ كاملة مع علامات الأقسام (مقطع، لازمة، إلخ)، يقوم الذكاء الاصطناعي بالتوزيع والإنتاج الموسيقي تلقائياً.'
                },
                vocals: {
                    icon: '🎤',
                    title: 'تركيب صوتي',
                    desc: 'يدعم أصواتاً ذكورية ونسائية بطبقات متنوعة، يغني الذكاء الاصطناعي كلماتك بنتائج طبيعية وسلسة.'
                },
                instrumental: {
                    icon: '🎹',
                    title: 'وضع الآلات',
                    desc: 'إنشاء مصاحبة آلات عالية الجودة، مناسبة للمؤثرات الصوتية للفيديو وموسيقى خلفية البودكاست والمزيد.'
                },
                fast: {
                    icon: '⚡',
                    title: 'إنشاء سريع',
                    desc: 'نماذج AI متقدمة تضمن إنتاجاً موسيقياً سريعاً، يمكن إنشاء معظم الموسيقى خلال 30 ثانية.'
                },
                commercial: {
                    icon: '💼',
                    title: 'ترخيص تجاري',
                    desc: 'جميع الموسيقى المُنشأة يمكن استخدامها لأغراض تجارية، بما في ذلك الفيديوهات والإعلانات والبودكاست والمزيد.'
                }
            }
        },
        faq: {
            title: 'الأسئلة الشائعة',
            items: {
                howItWorks: {
                    q: 'كيف يعمل مولّد موسيقى AI؟',
                    a: 'يستخدم مولّد موسيقى AI لدينا نماذج تعلم عميق متقدمة لإنشاء موسيقى أصلية بناءً على أوصافك النصية أو كلماتك. ما عليك سوى إدخال النمط الموسيقي والمشاعر ووصف المشهد، وسيقوم الذكاء الاصطناعي بتأليف قطعة موسيقية كاملة تلقائياً.'
                },
                commercial: {
                    q: 'هل يمكن استخدام الموسيقى المُنشأة لأغراض تجارية؟',
                    a: 'نعم، جميع الموسيقى المُنشأة باستخدام منصتنا يمكن استخدامها لأغراض تجارية، بما في ذلك فيديوهات YouTube والإعلانات والبودكاست والألعاب والمزيد.'
                },
                styles: {
                    q: 'ما هي الأنماط الموسيقية المدعومة؟',
                    a: 'ندعم البوب والروك والإلكترونية والجاز والكلاسيكية والهيب هوب والريذم آند بلوز والكانتري والميتال والفوك وعشرات الأنماط الموسيقية الأخرى. يمكنك أيضاً مزج أنماط متعددة لإنشاء موسيقى فريدة.'
                },
                credits: {
                    q: 'كم عدد الأرصدة التي يكلفها كل إنشاء؟',
                    a: 'حسب النموذج المختار، يكلف كل إنشاء 8-10 أرصدة. يمكنك الحصول على أسعار أرصدة أفضل من خلال خطط الاشتراك.'
                },
                download: {
                    q: 'هل يمكنني تحميل الموسيقى المُنشأة؟',
                    a: 'نعم، الموسيقى المُنشأة تدعم تنسيقات MP3 و WAV للتحميل. يمكنك اختيار التنسيق المناسب حسب احتياجاتك.'
                }
            }
        },
        demoTracks: {
            summerBreeze: {title: 'نسيم الصيف', style: 'بوب / منعش', duration: '2:00'},
            spaceJourney: {title: 'رحلة فضائية', style: 'إلكترونية / مستقبلية', duration: '1:30'},
            rainWalk: {title: 'مشية تحت المطر', style: 'جاز / هادئ', duration: '2:30'},
            mountainDawn: {title: 'فجر الجبل', style: 'كلاسيكية / هادئة', duration: '3:00'}
        }
    },
    pricing: {
        title: 'إلهام بلا حدود، اختر الخطة التي تناسبك أفضل',
        subtitle: 'افتح جميع نماذج AI، أنشئ صوراً وفيديوهات وموسيقى بالجملة.',
        promo: 'عرض لفترة محدودة — وفّر 30% على الخطط السنوية',
        monthly: 'شهري',
        yearly: 'سنوي',
        yearlyNote: 'الخطة السنوية — الأرصدة تُسلّم دفعة واحدة، دفعة واحدة أكثر اقتصاداً',
        popular: 'الأكثر شعبية',
        currentPlan: 'الخطة الحالية',
        currentPlanBtn: 'الخطة الحالية',
        upgrade: 'ترقية',
        unavailable: 'غير متاح',
        upgradeSuccess: 'تمت الترقية بنجاح!',
        upgradeFailed: 'فشلت الترقية',
        upgradeModal: {
            title: 'تأكيد الترقية',
            item1: 'سنقوم بخصم فرق السعر من بطاقتك.',
            item2: 'بعد نجاح الدفع، سيتم إضافة الرصيد الإضافي تلقائياً.',
            item3: 'الخطة الجديدة تُفعّل بعد نجاح الدفع.',
            tip: 'نصيحة: تأكد من أن طريقة الدفع الخاصة بك صالحة. يتم تحديث الرصيد خلال ثوانٍ بعد الدفع.',
            cancel: 'إلغاء',
            confirm: 'تأكيد الترقية'
        },
        subscribe: 'اشترك الآن',
        processing: 'جاري المعالجة...',
        creditsPer: 'أرصدة /',
        extraCredits: 'أرصدة إضافية',
        creditsRate: '100 رصيد = $',
        perMonth: 'شهر',
        perYear: 'سنة',
        yearlyBilling: 'يُحاسب سنوياً',
        saveVsMonthly: 'التوفير مقابل الشهري:',
        planDesc: {
            basic: 'مثالي للبداية',
            pro: 'الأفضل للمبدعين والمحترفين',
            ultimate: 'للفرق والمستخدمين المكثفين'
        },
        creditsPack: {
            title: 'شراء حزمة أرصدة',
            subtitle: 'شراء لمرة واحدة، بدون اشتراك',
            buy: 'شراء أرصدة',
            oneTime: 'شراء لمرة واحدة',
            permanent: 'الأرصدة لا تنتهي صلاحيتها أبداً',
            tip: 'نصيحة: الاشتراكات أفضل قيمة',
            tipItems: ['أسعار أرصدة أقل (وفّر 40-60%)', 'خصم 15% على جميع حزم الأرصدة']
        },
        security: {
            noTraining: 'لا تُستخدم لتدريب AI',
            encrypted: 'تخزين مشفر',
            gdpr: 'متوافق مع GDPR',
            delete: 'حذف حساب ذاتي'
        },
        dataSafety: 'تعرّف على التزامنا بأمن البيانات ←',
        allPlansInclude: 'جميع الخطط تتضمن',
        includes: {
            models: 'نماذج AI مميزة',
            fast: 'إنشاء سريع',
            privacy: 'خصوصية 100%',
            commercial: 'استخدام تجاري'
        },
        creditsInfo: {
            title: 'دليل الأرصدة',
            subtitle: 'عرض استهلاك الأرصدة لجميع النماذج',
            model: 'النموذج',
            type: 'النوع',
            cost: 'تكلفة الأرصدة',
            speed: 'السرعة',
            image: 'صورة',
            video: 'فيديو'
        },
        questions: 'أسئلة؟',
        contact: 'تحتاج مساعدة؟',
        contactUs: 'اتصل بنا',
        faq: {
            items: [
                {
                    q: 'ماذا يمكنني إنشاؤه بالأرصدة؟',
                    a: 'يمكن استخدام الأرصدة لإنشاء صور وفيديوهات وموسيقى بالذكاء الاصطناعي. يبدأ إنشاء الصور من 2 أرصدة، وإنشاء الفيديو من 10 أرصدة، والموسيقى من 10 أرصدة لكل مقطوعة. قد تستهلك النماذج المميزة أرصدة أكثر.'
                },
                {
                    q: 'هل يمكنني الإلغاء في أي وقت؟',
                    a: 'نعم، يمكنك إلغاء اشتراكك في أي وقت. يمكنك الاستمرار في استخدام الخدمة حتى نهاية فترة الفوترة الحالية.'
                },
                {
                    q: 'ماذا لو نفدت أرصدتي؟',
                    a: 'يمكنك شراء حزم أرصدة لمرة واحدة في أي وقت (بدون اشتراك). يحصل المشتركون على خصم 15% على حزم الأرصدة. يمكنك أيضاً ترقية خطتك للحصول على أسعار أفضل للحصص الشهرية.'
                },
                {
                    q: 'هل هناك سياسة استرداد أموال؟',
                    a: 'نعم. للمشتريات الأولى من الحزم لمرة واحدة أو الاشتراكات الأولى، يمكنك طلب استرداد الأموال خلال 7 أيام تقويمية إذا كان استخدام الأرصدة أقل من 3%.'
                }
            ]
        }
    },
    modelDetail: {
        breadcrumb: {
            home: 'الرئيسية',
            models: 'النماذج'
        },
        model: 'النموذج',
        modelVersion: 'إصدار النموذج',
        standard: 'قياسي',
        pro: 'احترافي',
        standardDesc: 'جودة قياسية، إنشاء سريع',
        proDesc: 'جودة عالية، يدعم دقة عالية',
        credits: 'أرصدة',
        imagePrompt: 'وصف الصورة',
        imagePromptPlaceholder: 'صِف الصورة التي تريد إنشاءها...',
        videoPrompt: 'وصف الفيديو',
        videoPromptPlaceholder: 'صِف الفيديو الذي تريد إنشاءه...',
        referenceImage: 'صورة مرجعية',
        aspectRatio: 'نسبة العرض للارتفاع',
        thinkingLevel: 'مستوى التفكير',
        thinkingMinimal: 'زمن استجابة منخفض',
        thinkingHigh: 'دقة عالية',
        referenceImageFormats: 'PNG، JPG، JPEG، WEBP',
        uploadImageHint: 'PNG، JPG، JPEG، WEBP',
        nanoBanana2EmptyPreview: 'معاينة إخراج صور Nano Banana 2 الرسمية',
        characters: 'حرف',
        imageSize: 'حجم الصورة',
        auto: 'تلقائي',
        resolution: 'الدقة',
        duration: 'المدة',
        seconds: 'ثوانٍ',
        creditsRequired: 'الأرصدة المطلوبة:',
        creditsRemaining: 'المتبقي:',
        remaining: 'المتبقي:',
        generate: 'توليد',
        getMoreCredits: 'احصل على المزيد من الأرصدة',
        generating: 'جاري التوليد...',
        demoPrompt: 'وصف تجريبي',
        modelLabel: 'النموذج:',
        version: 'الإصدار:',
        size: 'الحجم:',
        download: 'تحميل',
        regenerate: 'إعادة الإنشاء',
        noHistory: 'لا يوجد سجل توليد',
        features: {
            badge: 'الميزات الأساسية',
            title: 'ماذا يمكن لهذا النموذج أن يفعل؟',
            items: {
                realistic: {
                    icon: '📷',
                    title: 'واقعية سينمائية',
                    desc: 'إنشاء صور واقعية عالية الدقة بألوان بشرة طبيعية وملمس مواد غني وإضاءة سينمائية مقنعة.'
                },
                artistic: {
                    icon: '🎨',
                    title: 'نمط فني',
                    desc: 'إنشاء صور فنية بأنماط رسم متنوعة.'
                },
                portrait: {
                    icon: '👤',
                    title: 'صورة شخصية',
                    desc: 'تصوير شخصي احترافي بألوان بشرة طبيعية.'
                },
                landscape: {icon: '🏔️', title: 'مناظر طبيعية', desc: 'تصوير مناظر طبيعية وطبيعة مذهل.'},
                product: {icon: '📦', title: 'منتج', desc: 'تصوير منتجات عالي الجودة للتجارة الإلكترونية.'},
                fast: {icon: '⚡', title: 'إنشاء سريع', desc: 'يتم إنشاء معظم الصور خلال 10-30 ثانية.'},
                highRes: {icon: '🖼️', title: 'دقة عالية', desc: 'دعم إخراج بدقة تصل إلى 4K.'},
                cinematic: {
                    icon: '🎬',
                    title: 'سينمائي',
                    desc: 'إنشاء فيديوهات سينمائية بتصوير احترافي.'
                },
                audioSync: {icon: '🔊', title: 'مزامنة صوتية', desc: 'مزامنة صوتية بصرية أصلية للفيديوهات.'},
                lipSync: {icon: '👄', title: 'مزامنة الشفاه', desc: 'مزامنة شفاه دقيقة لفيديوهات الشخصيات.'},
                animation: {icon: '🎭', title: 'تحريك', desc: 'تحريك شخصيات وحركة سلسة.'},
                longVideo: {icon: '⏱️', title: 'فيديو طويل', desc: 'دعم مدد فيديو أطول.'},
                privacy: {
                    icon: '🔒',
                    title: 'الخصوصية والأمان',
                    desc: 'جميع البيانات مشفرة أثناء النقل ولا تُستخدم لتدريب AI. إبداعاتك ملك لك.'
                }
            }
        },
        whyChoose: {
            items: [
                'إنشاء ذكي مدعوم بـ {name}',
                'إنجاز مهام إبداعية معقدة بسرعة وكفاءة',
                'المحتوى المُنشأ يمكن استخدامه تجارياً',
                'تحديثات مستمرة وقدرات متحسنة',
                'نظام أرصدة موحد، ادفع حسب الاستخدام'
            ]
        },
        faq: {
            title: 'الأسئلة الشائعة',
            imageType: 'صور',
            videoType: 'فيديوهات',
            imageFormats: 'يتم دعم تنسيقات إخراج PNG و JPEG و WebP؛ اختر ما يناسب سير عملك.',
            videoFormats: 'يتم تسليم الفيديوهات بصيغة MP4 بخيارات 480p و 720p ونسب عرض متعددة.',
            items: [
                {
                    q: 'كيف يعمل {name}؟',
                    a: 'ارفع صورة مرجعية أو أدخل وصفاً نصياً — يقوم {name} بإنشاء {type} عالية الجودة بناءً على مدخلاتك. العملية بسيطة ولا تتطلب مهارات خبراء.'
                },
                {
                    q: 'هل يمكنني استخدام {type} المُنشأة تجارياً؟',
                    a: 'نعم. يمكن استخدام المحتوى من {name} تجارياً، بما في ذلك التسويق ووسائل التواصل الاجتماعي واستخدام المنتجات.'
                },
                {
                    q: 'كم عدد الأرصدة لكل إنشاء؟',
                    a: 'كل إنشاء باستخدام {name} يستهلك {credits} أرصدة. يحصل المشتركون على أسعار أرصدة أفضل.'
                },
                {
                    q: 'ما مدى سرعة الإنشاء؟',
                    a: 'السرعة النموذجية لـ {name} هي {speed}. نستمر في التحسين لنتائج موثوقة وسريعة.'
                },
                {q: 'ما هي تنسيقات الإخراج المدعومة؟', a: ''}
            ]
        },
        qwenImage20Pro: {
            negativePromptLabel: 'وصف سلبي (اختياري)',
            negativePromptPlaceholder: 'صِف ما لا تريد أن يظهر (مثلاً: وضوح منخفض، أيدي مشوهة، إلخ)',
            customWidth: 'العرض',
            customHeight: 'الارتفاع',
            sizeHint: 'النطاق: 512×512 إلى 2048×2048',
            sizeErrorRequired: 'يرجى إدخال العرض والارتفاع',
            sizeErrorInteger: 'يجب أن يكون العرض والارتفاع أعداداً صحيحة',
            sizeErrorRange: 'يجب أن تكون الدقة بين 512×512 و 2048×2048',
            promptEnhanceTitle: 'تحسين الوصف',
            promptEnhanceDesc: 'تحسين تفاصيل الوصف للحصول على مخرجات أغنى',
            watermarkTitle: 'علامة مائية',
            watermarkDesc: 'إضافة علامة مائية إلى الصور المُنشأة',
            demoPromptText: 'بين الجبال الثلجية، طفل صغير بملابس التزلج والنظارات الواقية ينزلق بسعادة على زلاجاته؛ بلورات الثلج تتطاير على طول مساره، مع سلاسل جبلية مغطاة بالثلج لا نهاية لها خلفه.',
            faqSizeSupportQ: 'ما هي الأحجام المدعومة؟',
            faqSizeSupportA: 'أدخل العرض والارتفاع ضمن 512~2048 (مثلاً، 2048*2048).',
            faqMaxCountQ: 'كم عدد الصور التي يمكن إنشاؤها كحد أقصى؟',
            faqMaxCountA: 'حتى 4 صور (n=1..4).',
            faqLinkUsageQ: 'كيف أستخدم روابط الصور بعد الإنشاء؟',
            faqLinkUsageA: 'يقوم أولاً بتنزيل الرابط المؤقت الذي يعيده DashScope، ورفعه على خادمنا، وإرجاع رابط دائم يمكن الوصول إليه.'
        },
        zImageTurbo: {
            promptExtendTitle: 'تحسين الوصف',
            promptExtendDesc: 'تحسين تفاصيل الوصف للحصول على مخرجات أغنى',
            customWidth: 'العرض',
            customHeight: 'الارتفاع',
            sizeHint: 'النطاق: 512×512 إلى 2048×2048',
            sizeErrorRequired: 'يرجى إدخال العرض والارتفاع',
            sizeErrorInteger: 'يجب أن يكون العرض والارتفاع أعداداً صحيحة',
            sizeErrorRange: 'يجب أن تكون الدقة بين 512×512 و 2048×2048',
            seedLabel: 'البذرة',
            seedErrorRequired: 'يرجى إدخال بذرة',
            seedErrorInteger: 'يجب أن تكون البذرة عدداً صحيحاً',
            seedErrorRange: 'يجب أن تكون البذرة بين 0 و 2147483647',
            tagQuality: 'جودة عالية',
            tagOfficial: 'اتصال رسمي مباشر',
            tagHighRes: 'دقة عالية',
            tagSeed: 'تحكم بالبذرة',
            tagPromptExtend: 'تحسين الوصف',
            feature1Title: 'إخراج عالي الجودة',
            feature1Desc: 'إنشاء صور عالية الدقة ورفعها للحصول على روابط وصول طويلة الأمد.',
            feature2Title: 'دقة مخصصة',
            feature2Desc: 'أدخل العرض والارتفاع ضمن 512–2048.',
            feature3Title: 'إنشاء قابل للتحكم',
            feature3Desc: 'يدعم البذرة وتحسين الوصف للتكرار والضبط.',
            demoPromptText: 'على رمال ذهبية ناعمة، أثر أقدام واضح يقود أعمق في الإطار؛ الحواف تظهر رمال رطبة وحبيبية، السطح يلمع في ضوء الشمس، يجذب النظر نحو منارة بعيدة.',
            faqSizeSupportQ: 'ما هي الأحجام المدعومة؟',
            faqSizeSupportA: 'أدخل العرض والارتفاع ضمن 512–2048 (مثلاً، 1024*1536).',
            faqSeedQ: 'ما هي البذرة المستخدمة ل؟',
            faqSeedA: 'بنفس الوصف والمعلمات، تساعد البذرة على إعادة إنتاج نتائج مشابهة.',
            faqPromptExtendQ: 'ما هو تحسين الوصف؟',
            faqPromptExtendA: 'عند التفعيل، يقوم بتحسين تفاصيل الوصف للحصول على مخرجات أغنى.'
        }
    },
    modelIntro: {
        common: {
            videoMode: 'وضع الفيديو',
            textToVideo: 'نص إلى فيديو',
            imageToVideo: 'صورة إلى فيديو',
            referenceImage: 'صورة مرجعية',
            referenceAudio: 'صوت مرجعي',
            negativePrompt: 'وصف سلبي',
            duration: 'المدة',
            resolution: 'الدقة',
            aspectRatio: 'نسبة العرض للارتفاع',
            seed: 'البذرة',
            generateAudio: 'إنشاء صوت',
            watermark: 'إضافة علامة مائية',
            endFrame: 'الإطار النهائي',
            promptEnhance: 'تحسين الوصف',
            promptExtend: 'توسيع الوصف',
            imageSize: 'حجم الصورة',
            imageCount: 'عدد الصور',
            style: 'النمط',
            sizeMode: 'وضع الحجم',
            width: 'العرض',
            height: 'الارتفاع',
            optional: 'اختياري',
            uploading: 'جاري الرفع...',
            clickToUpload: 'انقر للرفع',
            quality: 'الجودة',
            qualityAuto: 'تلقائي',
            qualityLow: 'منخفض',
            qualityMedium: 'متوسط',
            qualityHigh: 'عالي',
            multipleOf64Hint: 'يجب أن يكون العرض والارتفاع مضاعفات 64.'
        },
        seegen: {
            aspectAdaptive: 'تلقائي',
            genMode: 'وضع الإنشاء',
            modeStand: 'قياسي',
            modeSpeed: 'سريع'
        },
        pollodance: {
            variantLabel: 'متغير النموذج',
            card20: '2.0',
            card20Fast: '2.0 سريع',
            card20Ref: '2.0 مرجعي',
            card20FastRef: '2.0 سريع مرجعي',
            opt20Desc: 'تحكم متقدم بالحركة، نقل أنماط سينمائية وإنشاء بمستوى صناعي.',
            opt20FastDesc: 'إنشاء عالي السرعة بزمن استجابة منخفض.',
            opt20RefDesc: 'تحكم مرجعي قوي: نقل الأنماط وتتبع الموضوع.',
            opt20FastRefDesc: 'إنشاء سريع مع تحكم مرجعي دقيق.',
            refImages: 'صور مرجعية',
            refVideo: 'فيديو مرجعي',
            refAudio: 'صوت مرجعي',
            webSearch: 'بحث على الويب'
        },
        nanoBanana: {
            version: 'إصدار النموذج',
            title: 'مولّد صور Nano Banana Pro بالذكاء الاصطناعي',
            desc: 'Nano Banana هو نموذج إنشاء صور AI عالي الأداء يدعم إنشاء صور واقعية، ويتفوق في الصور الشخصية والمشاهد الطبيعية. متوفر بنسختين قياسية واحترافية لتلبية الاحتياجات المختلفة.',
            v25Type: 'زمن استجابة منخفض',
            v25TypeBadge: 'سريع',
            v25TypeDesc: 'دقة ثابتة 1024 بكسل، سرعة إنشاء سريعة',
            v31Type: 'دقة عالية',
            v31TypeBadge: 'جودة',
            v31TypeDesc: 'يدعم دقات متعددة 1K / 2K / 4K',
            demoPrompt: 'صورة شخصية سينمائية لامرأة في ضوء الساعة الذهبية، مع ملمس بشرة طبيعي وخلفية بوكيه ناعمة',
            multiSize: 'أحجام متعددة',
            multiSizeDesc: 'يدعم تلقائي، 1:1، 4:3، 3:4، 16:9، 9:16، 3:2، 2:3 وأحجام صور أخرى.',
            featuresDesc: 'يوفر Nano Banana قدرات إنشاء صور عالية الجودة مع خيارات أحجام ودقات متعددة.',
            flexiblePricing: 'تسعير مرن',
            flexiblePricingDesc: 'قياسي 5 أرصدة، احترافي 20 رصيد، اختر حسب الحاجة.',
            commercial: 'ترخيص تجاري',
            commercialDesc: 'جميع الصور المُنشأة يمكن استخدامها لأغراض تجارية.',
            enterPrompt: 'يرجى إدخال وصف',
            generateFailed: 'فشل التوليد',
            requestFailed: 'فشل الطلب، يرجى المحاولة مرة أخرى',
            faq: [
                {
                    q: 'ما الفرق بين النسختين القياسية والاحترافية؟',
                    a: 'النسخة القياسية مناسبة للإنشاء السريع لصور بجودة قياسية، وتستهلك 5 أرصدة. النسخة الاحترافية تدعم دقات أعلى (1K/2K/4K) بجودة صور أفضل، وتستهلك 20 رصيداً.'
                },
                {
                    q: 'كيف يعمل Nano Banana؟',
                    a: 'ما عليك سوى إدخال وصف نصي، وسيقوم نموذج Nano Banana بإنشاء صور واقعية عالية الجودة بناءً على وصفك.'
                },
                {
                    q: 'ما هي أحجام الصور المدعومة؟',
                    a: 'يدعم تلقائي، 1:1 (مربع)، 4:3، 3:4، 16:9 (أفقي)، 9:16 (عمودي)، 3:2، 2:3 وأحجام أخرى.'
                },
                {
                    q: 'هل يمكن استخدام الصور المُنشأة تجارياً؟',
                    a: 'نعم، جميع المحتوى المُنشأ باستخدام Nano Banana يمكن استخدامه لأغراض تجارية.'
                }
            ]
        },
        nanoBanana2: {
            genType: 'إصدار الإنشاء'
        },
        seedream: {
            title: 'مولّد صور Seedream 4 بالذكاء الاصطناعي',
            desc: 'Seedream 4 هو نموذج إنشاء صور AI متقدم متخصص في الصور الفنية والإبداعية. مثالي للرسوم التوضيحية وفن المفاهيم والصور الأنيقة.',
            webSearch: 'بحث الويب',
            webSearchDesc: 'تفعيل بحث الويب للحصول على معلومات مرجعية أكثر دقة',
            watermark: 'إضافة علامة مائية',
            watermarkDesc: 'إضافة علامة مائية إلى الصور المُنشأة',
            sizeModeResolution: 'حسب الدقة',
            sizeModeCustom: 'حجم مخصص',
            customWidth: 'العرض',
            customHeight: 'الارتفاع',
            sizeHint: 'المساحة 1024×1024–4096×4096، نسبة العرض للارتفاع 1/16–16',
            sizeErrorArea: 'يجب أن تكون المساحة بين 1024×1024 و 4096×4096',
            sizeErrorRatio: 'يجب أن تكون نسبة العرض للارتفاع بين 1/16 و 16',
            demoPromptExample: 'ضوء جانبي بعد الظهر يضيء خيمة التخييم، مع ملمس قماش الخيمة الخشن مرئياً بوضوح. كلب ألماني مستلقٍ بالداخل؛ صاحبه يقرفص لمصافحته.',
            features: [
                {
                    icon: '🎨',
                    title: 'نمط فني',
                    desc: 'إنشاء صور فنية مذهلة بأنماط رسم وتوضيح متنوعة.'
                },
                {icon: '🖼️', title: 'دقة عالية', desc: 'دعم دقة تصل إلى 4K لأعمال فنية مفصلة.'},
                {icon: '⚡', title: 'إنشاء سريع', desc: 'يتم إنشاء معظم الصور خلال 15 ثانية.'},
                {icon: '🎭', title: 'نقل الأنماط', desc: 'تطبيق أنماط فنية متنوعة على إبداعاتك.'},
                {icon: '📐', title: 'أحجام متعددة', desc: 'دعم نسب عرض متنوعة للاحتياجات المختلفة.'},
                {
                    icon: '💼',
                    title: 'ترخيص تجاري',
                    desc: 'جميع الصور المُنشأة يمكن استخدامها لأغراض تجارية.'
                }
            ],
            faq: [
                {
                    q: 'فيما يتفوق Seedream 4؟',
                    a: 'يتفوق Seedream 4 في إنشاء صور فنية وإبداعية، بما في ذلك الرسوم التوضيحية وفن المفاهيم والصور الأنيقة.'
                },
                {
                    q: 'كم عدد الأرصدة لكل إنشاء؟',
                    a: 'استخدام Seedream 4 يكلف 8 أرصدة لكل إنشاء. يمكنك الحصول على أسعار أرصدة أفضل من خلال خطط الاشتراك.'
                },
                {
                    q: 'ما هي الأنماط المدعومة؟',
                    a: 'يدعم Seedream 4 أنماطاً فنية متنوعة بما في ذلك الرسم الزيتي والألوان المائية والفن الرقمي والأنمي والمزيد.'
                },
                {
                    q: 'هل يمكن استخدام الصور المُنشأة تجارياً؟',
                    a: 'نعم، جميع المحتوى المُنشأ باستخدام Seedream 4 يمكن استخدامه لأغراض تجارية.'
                }
            ]
        },
        seedream5: {
            title: 'مولّد صور Seedream 5 بالذكاء الاصطناعي',
            desc: 'Seedream 5 هو نموذج إنشاء صور AI متقدم متخصص في الصور الفنية والإبداعية. مثالي للرسوم التوضيحية وفن المفاهيم والصور الأنيقة.',
            webSearch: 'بحث الويب',
            webSearchDesc: 'تفعيل بحث الويب للحصول على معلومات مرجعية أكثر دقة',
            watermark: 'إضافة علامة مائية',
            watermarkDesc: 'إضافة علامة مائية إلى الصور المُنشأة',
            sizeModeResolution: 'حسب الدقة',
            sizeModeCustom: 'حجم مخصص',
            customWidth: 'العرض',
            customHeight: 'الارتفاع',
            sizeHint: 'المساحة 2560×1440–3072×3072، نسبة العرض للارتفاع 1/16–16',
            sizeErrorArea: 'يجب أن تكون المساحة بين 2560×1440 و 3072×3072',
            sizeErrorRatio: 'يجب أن تكون نسبة العرض للارتفاع بين 1/16 و 16',
            demoPromptExample: 'ضوء جانبي بعد الظهر يضيء خيمة التخييم، مع ملمس قماش الخيمة الخشن مرئياً بوضوح. كلب ألماني مستلقٍ بالداخل؛ صاحبه يقرفص لمصافحته.',
            features: [
                {
                    icon: '🎨',
                    title: 'نمط فني',
                    desc: 'إنشاء صور فنية مذهلة بأنماط رسم وتوضيح متنوعة.'
                },
                {icon: '🖼️', title: 'دقة عالية', desc: 'دعم إخراج 2K و 3K بتفاصيل غنية.'},
                {icon: '⚡', title: 'إنشاء سريع', desc: 'يتم إنشاء معظم الصور خلال 15 ثانية.'},
                {icon: '🎭', title: 'نقل الأنماط', desc: 'تطبيق أنماط فنية متنوعة على إبداعاتك.'},
                {icon: '📐', title: 'أحجام مرنة', desc: 'يدعم الدقات المسبقة والأحجام المخصصة.'},
                {
                    icon: '💼',
                    title: 'ترخيص تجاري',
                    desc: 'جميع الصور المُنشأة يمكن استخدامها لأغراض تجارية.'
                }
            ],
            faq: [
                {
                    q: 'فيما يتفوق Seedream 5؟',
                    a: 'يتفوق Seedream 5 في إنشاء صور فنية وإبداعية، بما في ذلك الرسوم التوضيحية وفن المفاهيم والصور الأنيقة.'
                },
                {
                    q: 'كم عدد الأرصدة لكل إنشاء؟',
                    a: 'استخدام Seedream 5 يكلف 10 أرصدة لكل إنشاء. يمكنك الحصول على أسعار أرصدة أفضل من خلال خطط الاشتراك.'
                },
                {
                    q: 'ما هي الدقات المدعومة؟',
                    a: 'يدعم إعدادات مسبقة 2K و 3K، بالإضافة إلى أحجام مخصصة ضمن نطاق المساحة ونسبة العرض للارتفاع المسموح بها.'
                },
                {
                    q: 'هل يمكن استخدام الصور المُنشأة تجارياً؟',
                    a: 'نعم، جميع المحتوى المُنشأ باستخدام Seedream 5 يمكن استخدامه لأغراض تجارية.'
                }
            ]
        },
        midjourney: {
            title: 'مولّد صور Midjourney بالذكاء الاصطناعي',
            desc: 'Midjourney هو نموذج رائد في إنشاء الصور بالذكاء الاصطناعي، يتميز بجودة فنية استثنائية وقدرات إبداعية. مثالي للأعمال الفنية الاحترافية والمشاريع الإبداعية.',
            referenceBoxTitle: 'أضف صوراً مرجعية لتحويل صورة إلى صورة',
            referenceBoxSubtitle: 'يدعم PNG، JPEG، WEBP (بحد أقصى 100 كيلوبايت). حتى 5 صور. صور أقل = نتائج أدق.',
            demoPrompt: 'جزيرة عائمة غامضة في السماء، أطلال قديمة مغطاة ببلورات متوهجة، شلالات تتدفق نحو السحب أدناه، إضاءة أثيرية، نمط فن الخيال',
            referenceImages: 'صور مرجعية',
            referenceImagesCount: 'حتى 5',
            refImageMaxSize: 'يجب ألا تتجاوز كل صورة 100 كيلوبايت',
            style: 'النمط',
            styleRealistic: 'واقعي',
            styleAnime: 'أنمي',
            generationSpeed: 'سرعة التوليد',
            fastDesc: 'توليد بسرعة قياسية',
            turboDesc: 'توليد سريع، معالجة ذات أولوية',
            creative: 'إبداعي',
            highQuality: 'جودة عالية',
            fastTurbo: 'سريع/تيربو',
            creativeGeneration: 'توليد إبداعي',
            speed: 'السرعة',
            features: [
                {
                    icon: '🎨',
                    title: 'تميّز فني',
                    desc: 'جودة فنية رائدة في الصناعة ومخرجات إبداعية.'
                },
                {
                    icon: '🖼️',
                    title: 'دقة عالية',
                    desc: 'إنشاء صور عالية الجودة مناسبة للاستخدام الاحترافي.'
                },
                {icon: '🎭', title: 'أنماط فريدة', desc: 'أنماط فنية مميزة تميّز أعمالك.'},
                {icon: '⚡', title: 'توليد سريع', desc: 'معظم الصور تُنشأ خلال 20 ثانية.'},
                {icon: '📐', title: 'أحجام متعددة', desc: 'دعم نسب عرض وارتفاع ودقات متعددة.'},
                {
                    icon: '💼',
                    title: 'ترخيص تجاري',
                    desc: 'جميع الصور المُنشأة يمكن استخدامها لأغراض تجارية.'
                }
            ],
            faq: [
                {
                    q: 'ما الفرق بين السريع والتيربو؟',
                    a: 'الوضع السريع يكلف 10 أرصدة بسرعة قياسية. وضع التيربو يكلف 20 رصيداً بتوليد أسرع ومعالجة ذات أولوية.'
                },
                {
                    q: 'كيف يعمل Midjourney؟',
                    a: 'ما عليك سوى إدخال وصف نصي، وسيقوم Midjourney بإنشاء صور فنية بناءً على وصفك.'
                },
                {
                    q: 'ما هي أحجام الصور المدعومة؟',
                    a: 'يدعم 1:1 (مربع)، 4:3، 3:4، 16:9 (أفقي)، 9:16 (عمودي)، 3:2، 2:3 وأحجام أخرى.'
                },
                {
                    q: 'هل يمكن استخدام الصور المُنشأة تجارياً؟',
                    a: 'نعم، جميع المحتوى المُنشأ باستخدام Midjourney يمكن استخدامه لأغراض تجارية.'
                }
            ]
        },
        gptImage: {
            title: 'مولّد صور GPT-Image-1 بالذكاء الاصطناعي',
            desc: 'GPT-Image-1 هو نموذج إنشاء صور متعدد الأغراض من OpenAI، قادر على إنشاء مجموعة واسعة من الصور من الأوصاف النصية. مثالي لإنشاء الصور العامة.',
            demoPromptExample: 'حقول توسكانا عند الغسق، تلال متدحرجة مغطاة بالقمح الذهبي، أشجار السرو وبيت حجري قديم في الأفق، غروب الشمس يلقي توهجاً أحمر دافئاً عبر السماء، دافئ، شافي، تصوير مناظر طبيعية، الساعة الذهبية.',
            imageCount: 'عدد الصور',
            promptEnhance: 'تحسين الوصف',
            promptEnhanceDesc: 'تحسين الأوصاف تلقائياً للحصول على نتائج إنشاء أفضل',
            count: 'العدد',
            multiPurpose: 'متعدد الأغراض',
            batchGeneration: 'إنشاء دفعي',
            size1024Square: '1024×1024 (مربع)',
            size1536Landscape: '1536×1024 (أفقي)',
            size1024Portrait: '1024×1536 (عمودي)',
            threeSizes: 'ثلاثة أحجام ثابتة',
            tagQuality: 'جودة عالية',
            tagCommercialShort: 'استخدام تجاري',
            features: [
                {icon: '🎨', title: 'إنشاء متعدد الأغراض', desc: 'إنشاء مجموعة واسعة من الصور لأي غرض.'},
                {icon: '🖼️', title: 'جودة عالية', desc: 'إنشاء صور عالية الجودة بتفاصيل دقيقة.'},
                {icon: '⚡', title: 'توليد سريع', desc: 'معظم الصور تُنشأ خلال 15 ثانية.'},
                {
                    icon: '📝',
                    title: 'فهم النصوص',
                    desc: 'فهم ممتاز للأوصاف النصية المعقدة.'
                },
                {
                    icon: '📐',
                    title: 'ثلاثة أحجام ثابتة',
                    desc: '1024×1024 (مربع)، 1536×1024 (أفقي)، 1024×1536 (عمودي).'
                },
                {
                    icon: '💼',
                    title: 'ترخيص تجاري',
                    desc: 'جميع الصور المُنشأة يمكن استخدامها لأغراض تجارية.'
                }
            ],
            faq: [
                {
                    q: 'كيف يعمل GPT-Image-1؟',
                    a: 'ما عليك سوى إدخال وصف نصي، وسيقوم GPT-Image-1 بإنشاء صور عالية الجودة بناءً على وصفك.'
                },
                {
                    q: 'ما هي أحجام الصور المدعومة؟',
                    a: 'يدعم ثلاثة أحجام ثابتة: 1024×1024 (مربع)، 1536×1024 (أفقي)، و 1024×1536 (عمودي).'
                },
                {
                    q: 'هل يمكن استخدام الصور المُنشأة تجارياً؟',
                    a: 'نعم، جميع المحتوى المُنشأ باستخدام GPT-Image-1 يمكن استخدامه لأغراض تجارية.'
                }
            ]
        },
        gptImage15: {
            title: 'مولّد صور GPT-Image-1.5 بالذكاء الاصطناعي',
            desc: 'GPT-Image-1.5 هو نموذج إنشاء صور متعدد الأغراض من OpenAI، قادر على إنشاء مجموعة واسعة من الصور من الأوصاف النصية. مثالي لإنشاء الصور العامة.',
            demoPromptExample: 'حقول توسكانا عند الغسق، تلال متدحرجة مغطاة بالقمح الذهبي، أشجار السرو وبيت حجري قديم في الأفق، غروب الشمس يلقي توهجاً أحمر دافئاً عبر السماء، دافئ، شافي، تصوير مناظر طبيعية، الساعة الذهبية.',
            imageCount: 'عدد الصور',
            promptEnhance: 'تحسين الوصف',
            promptEnhanceDesc: 'تحسين الأوصاف تلقائياً للحصول على نتائج إنشاء أفضل',
            count: 'العدد',
            multiPurpose: 'متعدد الأغراض',
            batchGeneration: 'إنشاء دفعي',
            size1024Square: '1024×1024 (مربع)',
            size1536Landscape: '1536×1024 (أفقي)',
            size1024Portrait: '1024×1536 (عمودي)',
            threeSizes: 'ثلاثة أحجام ثابتة',
            tagQuality: 'جودة عالية',
            tagCommercialShort: 'استخدام تجاري',
            features: [
                {icon: '🎨', title: 'إنشاء متعدد الأغراض', desc: 'إنشاء مجموعة واسعة من الصور لأي غرض.'},
                {icon: '🖼️', title: 'جودة عالية', desc: 'إنشاء صور عالية الجودة بتفاصيل دقيقة.'},
                {icon: '⚡', title: 'توليد سريع', desc: 'معظم الصور تُنشأ خلال 15 ثانية.'},
                {
                    icon: '📝',
                    title: 'فهم النصوص',
                    desc: 'فهم ممتاز للأوصاف النصية المعقدة.'
                },
                {
                    icon: '📐',
                    title: 'ثلاثة أحجام ثابتة',
                    desc: '1024×1024 (مربع)، 1536×1024 (أفقي)، 1024×1536 (عمودي).'
                },
                {
                    icon: '💼',
                    title: 'ترخيص تجاري',
                    desc: 'جميع الصور المُنشأة يمكن استخدامها لأغراض تجارية.'
                }
            ],
            faq: [
                {
                    q: 'كيف يعمل GPT-Image-1.5؟',
                    a: 'ما عليك سوى إدخال وصف نصي، وسيقوم GPT-Image-1.5 بإنشاء صور عالية الجودة بناءً على وصفك.'
                },
                {
                    q: 'ما هي أحجام الصور المدعومة؟',
                    a: 'يدعم ثلاثة أحجام ثابتة: 1024×1024 (مربع)، 1536×1024 (أفقي)، و 1024×1536 (عمودي).'
                },
                {
                    q: 'هل يمكن استخدام الصور المُنشأة تجارياً؟',
                    a: 'نعم، جميع المحتوى المُنشأ باستخدام GPT-Image-1.5 يمكن استخدامه لأغراض تجارية.'
                }
            ]
        },
        fluxKontext: {
            title: 'مولّد صور Flux Kontext بالذكاء الاصطناعي',
            desc: 'شابة تجلس على سطح عند الساعة الذهبية، ترتدي سترة جينز واسعة، سماعات بيضاء حول رقبتها، تشرب قهوة مثلجة من كوب بلاستيكي شفاف. شعرها المجعد القصير يتطاير قليلاً في الريح بينما تبدأ أضواء المدينة بالتوهج في الأفق.',
            imageCount: 'عدد الصور',
            count: 'العدد',
            demoPrompt1: 'شابة تجلس على سطح عند الساعة الذهبية، ترتدي سترة جينز واسعة، سماعات بيضاء حول رقبتها، تشرب قهوة مثلجة من كوب بلاستيكي شفاف. شعرها المجعد القصير يتطاير قليلاً في الريح بينما تبدأ أضواء المدينة بالتوهج في الأفق.',
            demoPrompt2: 'شاب في العشرينات يجلس على أرضية استوديو فني فوضوي، محاط بلوحات غير مكتملة وأنابيب دهان. يرتدي قميصاً أبيض ملطخ بالألوان، وجينز ممزق.',
            demoPrompt3: 'أم شابة تعدّل قبعة طفلها أثناء جلوسها على بطانية نزهة. ترتدي سترة كريمية وتنورة كوردوراي طويلة، حافية على العشب.',
            highQuality: 'جودة عالية',
            fastGen: 'توليد سريع',
            multiSize: 'أحجام متعددة',
            outputStyle: 'نمط الإخراج',
            outputStyleDesc: {
                auto: 'افتراضي — يحدد النموذج النمط تلقائياً، بدون مظهر مفروض',
                photographic: 'تصوير فوتوغرافي — صور واقعية، ضوء وظلال طبيعية',
                digital_art: 'فن رقمي — مظهر CG/رسم توضيحي، ألوان حيوية وغنية',
                anime: 'أنمي — نمط أنمي/كرتون ياباني، خطوط نظيفة'
            },
            outputStyleLabel: {
                auto: 'افتراضي',
                photographic: 'تصوير فوتوغرافي',
                digital_art: 'فن رقمي',
                anime: 'أنمي'
            },
            features: [
                {icon: '✨', title: 'إخراج عالي الجودة', desc: 'إنشاء صور مفصلة وعالية الدقة.'},
                {icon: '🎨', title: 'نص إلى صورة', desc: 'إنشاء صور بدقة من الأوصاف النصية.'},
                {icon: '⚡', title: 'توليد سريع', desc: 'معظم الصور تُنجز في حوالي 15 ثانية.'},
                {icon: '📐', title: 'أحجام متعددة', desc: 'دعم نسب عرض 1:1، 3:2، 2:3.'},
                {icon: '💼', title: 'ترخيص تجاري', desc: 'الصور المُنشأة يمكن استخدامها لأغراض تجارية.'}
            ],
            faq: [
                {
                    q: 'كيف يعمل Flux Kontext؟',
                    a: 'أدخل وصفاً نصياً؛ يقوم Flux Kontext بإنشاء صور عالية الجودة ويدعم صورة واحدة أو متعددة لكل طلب.'
                },
                {q: 'ما هي أحجام الصور المدعومة؟', a: 'يدعم 1:1 (مربع)، 3:2 (أفقي)، 2:3 (عمودي).'},
                {
                    q: 'هل يمكنني إنشاء صور متعددة في وقت واحد؟',
                    a: 'نعم، يمكنك إنشاء 1-3 صور، كل منها تُحاسب بشكل منفصل.'
                },
                {
                    q: 'هل يمكن استخدام الصور المُنشأة تجارياً؟',
                    a: 'نعم، المحتوى المُنشأ باستخدام Flux Kontext يمكن استخدامه لأغراض تجارية.'
                }
            ]
        },
        fluxPro11Ultra: {
            title: 'مولّد صور Flux Pro 1.1 Ultra بالذكاء الاصطناعي',
            desc: 'Flux Pro 1.1 Ultra لإنشاء نص إلى صورة عالي الجودة مع نسب عرض متعددة وإنشاء دفعي.',
            imageCount: 'عدد الصور',
            count: 'العدد',
            demoPrompt1: 'شابة تجلس على سطح عند الساعة الذهبية، ترتدي سترة جينز واسعة، سماعات بيضاء حول رقبتها، تشرب قهوة مثلجة من كوب بلاستيكي شفاف. شعرها المجعد القصير يتطاير قليلاً في الريح بينما تبدأ أضواء المدينة بالتوهج في الأفق.',
            demoPrompt2: 'شاب في العشرينات يجلس على أرضية استوديو فني فوضوي، محاط بلوحات غير مكتملة وأنابيب دهان. يرتدي قميصاً أبيض ملطخ بالألوان، وجينز ممزق.',
            demoPrompt3: 'أم شابة تعدّل قبعة طفلها أثناء جلوسها على بطانية نزهة. ترتدي سترة كريمية وتنورة كوردوراي طويلة، حافية على العشب.',
            highQuality: 'جودة عالية',
            fastGen: 'توليد سريع',
            multiSize: 'أحجام متعددة',
            outputStyle: 'نمط الإخراج',
            outputStyleDesc: {
                auto: 'افتراضي — يحدد النموذج النمط تلقائياً، بدون مظهر مفروض',
                photographic: 'تصوير فوتوغرافي — صور واقعية، ضوء وظلال طبيعية',
                digital_art: 'فن رقمي — مظهر CG/رسم توضيحي، ألوان حيوية وغنية',
                anime: 'أنمي — نمط أنمي/كرتون ياباني، خطوط نظيفة'
            },
            outputStyleLabel: {
                auto: 'افتراضي',
                photographic: 'تصوير فوتوغرافي',
                digital_art: 'فن رقمي',
                anime: 'أنمي'
            },
            features: [
                {icon: '✨', title: 'إخراج عالي الجودة', desc: 'إنشاء صور مفصلة وعالية الدقة.'},
                {icon: '🎨', title: 'نص إلى صورة', desc: 'إنشاء صور بدقة من الأوصاف النصية.'},
                {icon: '⚡', title: 'توليد سريع', desc: 'معظم الصور تُنجز في حوالي 15 ثانية.'},
                {
                    icon: '📐',
                    title: 'أحجام متعددة',
                    desc: 'دعم 21:9، 16:9، 4:3، 3:2، 1:1، 2:3، 3:4، 9:16، 9:21.'
                },
                {icon: '💼', title: 'ترخيص تجاري', desc: 'الصور المُنشأة يمكن استخدامها لأغراض تجارية.'}
            ],
            faq: [
                {
                    q: 'كيف يعمل Flux Pro 1.1 Ultra؟',
                    a: 'أدخل وصفاً نصياً لإنشاء صور عالية الجودة؛ يدعم 1-4 صور لكل طلب.'
                },
                {q: 'ما هي أحجام الصور المدعومة؟', a: 'يدعم 21:9، 16:9، 4:3، 3:2، 1:1، 2:3، 3:4، 9:16، 9:21.'},
                {
                    q: 'هل يمكنني إنشاء صور متعددة في وقت واحد؟',
                    a: 'نعم، يمكنك إنشاء 1-4 صور، كل منها تُحاسب بشكل منفصل.'
                },
                {
                    q: 'هل يمكن استخدام الصور المُنشأة تجارياً؟',
                    a: 'نعم، المحتوى يمكن استخدامه لأغراض تجارية.'
                }
            ]
        },
        fluxSchnell: {
            title: 'مولّد صور Flux Schnell بالذكاء الاصطناعي',
            desc: 'Flux Schnell لإنشاء نص إلى صورة سريع مع نسب عرض متعددة وإنشاء دفعي.',
            imageCount: 'عدد الصور',
            count: 'العدد',
            demoPrompt1: 'شابة تجلس على سطح عند الساعة الذهبية، ترتدي سترة جينز واسعة، سماعات بيضاء حول رقبتها، تشرب قهوة مثلجة من كوب بلاستيكي شفاف. شعرها المجعد القصير يتطاير قليلاً في الريح بينما تبدأ أضواء المدينة بالتوهج في الأفق.',
            demoPrompt2: 'شاب في العشرينات يجلس على أرضية استوديو فني فوضوي، محاط بلوحات غير مكتملة وأنابيب دهان. يرتدي قميصاً أبيض ملطخ بالألوان، وجينز ممزق.',
            demoPrompt3: 'أم شابة تعدّل قبعة طفلها أثناء جلوسها على بطانية نزهة. ترتدي سترة كريمية وتنورة كوردوراي طويلة، حافية على العشب.',
            highQuality: 'جودة عالية',
            fastGen: 'توليد سريع',
            multiSize: 'أحجام متعددة',
            outputStyle: 'نمط الإخراج',
            outputStyleDesc: {
                auto: 'افتراضي — يحدد النموذج النمط تلقائياً، بدون مظهر مفروض',
                photographic: 'تصوير فوتوغرافي — صور واقعية، ضوء وظلال طبيعية',
                digital_art: 'فن رقمي — مظهر CG/رسم توضيحي، ألوان حيوية وغنية',
                anime: 'أنمي — نمط أنمي/كرتون ياباني، خطوط نظيفة'
            },
            outputStyleLabel: {
                auto: 'افتراضي',
                photographic: 'تصوير فوتوغرافي',
                digital_art: 'فن رقمي',
                anime: 'أنمي'
            },
            features: [
                {icon: '✨', title: 'إخراج عالي الجودة', desc: 'إنشاء صور مفصلة وعالية الدقة.'},
                {icon: '🎨', title: 'نص إلى صورة', desc: 'إنشاء صور بدقة من الأوصاف النصية.'},
                {icon: '⚡', title: 'توليد سريع', desc: 'معظم الصور تُنجز في حوالي 15 ثانية.'},
                {
                    icon: '📐',
                    title: 'أحجام متعددة',
                    desc: 'دعم 21:9، 16:9، 4:3، 3:2، 1:1، 2:3، 3:4، 9:16، 9:21.'
                },
                {icon: '💼', title: 'ترخيص تجاري', desc: 'الصور المُنشأة يمكن استخدامها لأغراض تجارية.'}
            ],
            faq: [
                {
                    q: 'كيف يعمل Flux Schnell؟',
                    a: 'أدخل وصفاً نصياً لإنشاء صور عالية الجودة بسرعة؛ يدعم 1-4 صور لكل طلب.'
                },
                {q: 'ما هي أحجام الصور المدعومة؟', a: 'يدعم 21:9، 16:9، 4:3، 3:2، 1:1، 2:3، 3:4، 9:16، 9:21.'},
                {
                    q: 'هل يمكنني إنشاء صور متعددة في وقت واحد؟',
                    a: 'نعم، يمكنك إنشاء 1-4 صور، كل منها تُحاسب بشكل منفصل.'
                },
                {
                    q: 'هل يمكن استخدام الصور المُنشأة تجارياً؟',
                    a: 'نعم، المحتوى يمكن استخدامه لأغراض تجارية.'
                }
            ]
        },
        flux2: {
            title: 'مولّد صور FLUX.2 بالذكاء الاصطناعي',
            desc: 'يجلب FLUX.2 كفاءة مستوى المؤسسات ودقة احترافية لإنشاء النص إلى صورة مع تفاصيل واقعية فوتوغرافية، وأيادٍ ووجوه وملامس دقيقة.',
            variant: 'متغير النموذج',
            variantLabel: 'متغير النموذج',
            variantDesc: {
                'klein-04': 'زمن حقيقي',
                'klein-09': 'متوازن',
                'max': 'أعلى جودة',
                'pro': 'إنتاج',
                'flex': 'قابل للتخصيص'
            },
            promptUpsampling: 'تحسين الوصف',
            promptUpsamplingHint: 'تحسين تفاصيل الوصف للحصول على مخرجات أغنى (غير متاح لنماذج Klein).',
            steps: 'الخطوات',
            stepsHint: 'خطوات أعلى تنتج تفاصيل أكثر لكن تستغرق وقتاً أطول. متغير Flex فقط.',
            guidance: 'التوجيه',
            guidanceHint: 'يتحكم بمدى التزام المخرجات بالوصف. متغير Flex فقط.',
            tagPhotorealism: 'واقعية فوتوغرافية',
            tagMultilingual: 'متعدد اللغات',
            tagVariants: '5 متغيرات',
            demoPrompt1: 'شابة تجلس على سطح عند الساعة الذهبية، ترتدي سترة جينز واسعة، سماعات بيضاء حول رقبتها، تشرب قهوة مثلجة من كوب بلاستيكي شفاف. شعرها المجعد القصير يتطاير قليلاً في الريح بينما تبدأ أضواء المدينة بالتوهج في الأفق.',
            features: [
                {icon: '✨', title: 'تفاصيل واقعية فوتوغرافية', desc: 'أيادٍ ووجوه وأقمشة وشعارات وأشياء صغيرة دقيقة بدقة تصل إلى 4 ميغابكسل.'},
                {icon: '🎨', title: 'الطباعة والتصميم', desc: 'يُصيّر نصوصاً واضحة وقابلة للقراءة ويلتزم بتعليمات التخطيط المعقدة.'},
                {icon: '🌍', title: 'متعدد اللغات', desc: 'دعم الأوصاف باللغة الأصلية مع اتباع تعليمات متطور.'},
                {icon: '🎯', title: '5 متغيرات نموذج', desc: 'Klein 4B/9B للسرعة، Max للجودة، Pro للإنتاج الضخم، Flex للتحكم المخصص.'},
                {icon: '⚙️', title: 'تحكم مرن', desc: 'خطوات وتوجيه وحجم وتحمل أمان قابل للتعديل لسير عمل الإنتاج.'}
            ],
            faq: [
                {
                    q: 'ما هي متغيرات نموذج FLUX.2؟',
                    a: 'يقدم FLUX.2 خمسة متغيرات: Klein 4B و 9B (سريع، حجم كبير)، Max (أعلى جودة مع بحث تأريضي)، Pro (إنتاج على نطاق واسع)، و Flex (خطوات وتوجيه قابل للتعديل).'
                },
                {
                    q: 'ما هي أحجام الصور المدعومة؟',
                    a: 'يستخدم FLUX.2 أبعاد البكسل (العرض × الارتفاع) التي يجب أن تكون مضاعفات 16. تشمل الإعدادات المسبقة 1:1 (1024×1024)، 4:3، 3:4، 16:9، 9:16، 21:9، و 9:21.'
                },
                {
                    q: 'ما هو تحسين الوصف (Prompt Upsampling)؟',
                    a: 'عند التفعيل، يحسّن النموذج وصفك داخلياً للحصول على تفاصيل أغنى. متاح لمتغيرات Max و Pro و Flex (وليس Klein).'
                },
                {
                    q: 'ما هي الخطوات والتوجيه في وضع Flex؟',
                    a: 'الخطوات (1-50) تتحكم في جودة الاستنتاج — أعلى يعني تفاصيل أكثر لكن أبطأ. التوجيه (1.5-10) يتحكم في الالتزام بالوصف — أعلى يعني أقرب لوصفك.'
                },
                {
                    q: 'هل يمكن استخدام الصور المُنشأة تجارياً؟',
                    a: 'نعم، المحتوى يمكن استخدامه لأغراض تجارية.'
                }
            ]
        },
        seedance: {
            title: 'مولّد فيديو Seedance AI بالذكاء الاصطناعي',
            desc: 'Seedance هو نموذج فيديو AI من الجيل التالي يدعم مزامنة صوتية بصرية أصلية، وحركة سينمائية، وتعبيرات عاطفية. يغطي وضع نص إلى فيديو، وصورة إلى فيديو، وتمديد الفيديو.',
            textToVideo: 'نص إلى فيديو',
            imageToVideo: 'صورة إلى فيديو',
            videoExtend: 'تمديد الفيديو',
            uploadImage: 'انقر لرفع صورة مرجعية',
            uploadHint: 'PNG، JPG، JPEG (بحد أقصى 20 ميغابايت)',
            endFrame: 'صورة الإطار النهائي',
            endFrameHint: '(اختياري) ارفع إطاراً نهائياً للتحكم بنهاية الفيديو',
            uploadEndFrame: 'انقر لرفع صورة الإطار النهائي',
            uploadVideo: 'انقر لرفع فيديو مرجعي',
            uploadVideoHint: 'MP4، MOV، WebM (بحد أقصى 100 ميغابايت)',
            videoPrompt: 'وصف الفيديو',
            promptPlaceholder: 'صِف الفيديو الذي تريد إنشاءه...',
            videoPromptPlaceholder: 'صِف الفيديو الذي تريد إنشاءه...',
            negativePrompt: 'وصف سلبي',
            negativePromptPlaceholder: 'صِف ما لا تريد أن يظهر في الفيديو (اختياري)',
            duration: 'المدة',
            videoDuration: 'مدة الفيديو',
            resolution: 'الدقة',
            aspectRatio: 'نسبة العرض للارتفاع',
            promptEnhance: 'تحسين الوصف',
            promptEnhanceDesc: 'تحسين الأوصاف تلقائياً للحصول على نتائج إنشاء أفضل',
            generateAudio: 'إنشاء صوت',
            audioOn: 'صوت أصلي (صوت + مؤثرات صوتية)',
            audioOff: 'فيديو فقط، بدون صوت',
            seedValue: 'قيمة البذرة',
            seedHint: 'قيمة البذرة هي المعرف الفريد للنمط العام. استخدام نفس البذرة يحافظ على تناسق النمط، بينما ضبط المعلمات الأخرى يساعد في تحسين التفاصيل البصرية.',
            seedPlaceholder: '-1 (عشوائي)',
            characters: 'حرف',
            creditsRequired: 'الأرصدة المطلوبة:',
            creditsRemaining: 'المتبقي:',
            generate: 'توليد',
            generating: 'جاري التوليد...',
            demoPrompt: 'وصف تجريبي',
            demoPromptExample: 'هرّ أبيض ناعم ولطيف يرقص بمرح على أطراف أصابعه، جسمه القطيف يتمايل بلطف مع مخالب وردية صغيرة مرفوعة. على سجادة ناعمة تحت إضاءة صفراء دافئة، نمط كرتوني شافي، تفاصيل دقيقة، ألوان ناعمة ورقيقة.',
            modelLabel: 'النموذج:',
            durationLabel: 'المدة:',
            techSpecsTitle: 'المواصفات التقنية',
            techSpecsDesc: 'يدعم Seedance مزامنة صوتية بصرية أصلية، وحركة سينمائية، وتعبيرات عاطفية. يغطي وضع نص إلى فيديو، وصورة إلى فيديو، وتمديد الفيديو.',
            t2vTitle: 'نص إلى فيديو (T2V)',
            t2vDesc: 'تحويل الأوصاف إلى مشاهد فيديو سينمائية',
            i2vTitle: 'صورة إلى فيديو (I2V)',
            i2vDesc: 'تحريك صورة واحدة باستخدام الذكاء الاصطناعي',
            input: 'المدخلات:',
            textPrompt: 'وصف نصي',
            imagePrompt: 'صورة + وصف',
            audio: 'الصوت:',
            nativeAudio: 'إنشاء صوت أصلي',
            bestFor: 'الأفضل لـ:',
            t2vBestFor: 'مثالي لإنشاء محتوى سينمائي وإعلانات وفيديوهات وسائل التواصل الاجتماعي.',
            i2vBestFor: 'الأفضل لتحريك الصور الشخصية وعروض المنتجات والمحتوى الإبداعي.',
            featuresDesc: 'سواء كنت مصمماً أو مسوّقاً أو صانع محتوى أو مستخدماً عادياً، يساعدك Seedance على إنشاء محتوى AI عالي الجودة بسرعة.',
            features: [
                {
                    icon: '🎬',
                    title: 'إنشاء صوتي بصري أصلي',
                    desc: 'إنشاء متزامن للفيديو والصوت في خطوة واحدة، بجودة سينمائية. مزامنة شفاه طبيعية ودبلجة حوار.'
                },
                {
                    icon: '😊',
                    title: 'تعبيرات مدفوعة بالعاطفة',
                    desc: 'أداء جديد مدرك للعواطف لتعبيرات وجه أكثر واقعية. تعبيرات دقيقة تشمل التردد والحزن والتوتر أو الكبت العاطفي.'
                },
                {
                    icon: '🎥',
                    title: 'تحكم كاميرا بمستوى مخرج',
                    desc: 'يدعم حركات كاميرا الدفع والسحب والتحريك والدوران والتتبع. توجيه الإطار الأول والأخير لانتقالات سلسة.'
                },
                {
                    icon: '📱',
                    title: 'مدخلات متعددة الأنماط',
                    desc: 'يدعم نص إلى فيديو، وصورة إلى فيديو، وسير عمل إبداعي مرن آخر.'
                },
                {
                    icon: '⚡',
                    title: 'توليد سريع',
                    desc: 'محرك استنتاج محسّن يضمن إنتاجاً سريعاً، معظم الفيديوهات تُنجز خلال دقائق.'
                },
                {
                    icon: '💼',
                    title: 'ترخيص تجاري',
                    desc: 'جميع الفيديوهات المُنشأة يمكن استخدامها لأغراض تجارية، مناسبة للإعلانات ووسائل التواصل الاجتماعي والمزيد.'
                }
            ],
            enterPrompt: 'يرجى إدخال وصف',
            imageRequired: 'وضع صورة إلى فيديو يتطلب صورة مرجعية',
            videoRequired: 'وضع تمديد الفيديو يتطلب فيديو مرجعياً',
            generateFailed: 'فشل التوليد',
            requestFailed: 'فشل الطلب، يرجى المحاولة مرة أخرى',
            faq: [
                {
                    q: 'كيف يعمل Seedance؟',
                    a: 'يمكنك رفع صورة مرجعية أو إدخال وصف نصي مباشرة، وسيقوم نموذج Seedance بإنشاء محتوى فيديو عالي الجودة بناءً على تعليماتك، مع صوت متزامن. العملية بسيطة وبديهية، لا تتطلب مهارات احترافية.'
                },
                {
                    q: 'هل يمكن استخدام الفيديوهات المُنشأة تجارياً؟',
                    a: 'نعم، جميع المحتوى المُنشأ باستخدام Seedance يمكن استخدامه لأغراض تجارية، بما في ذلك مواد التسويق ووسائل التواصل الاجتماعي وعروض المنتجات والمزيد.'
                },
                {
                    q: 'كم عدد الأرصدة لكل إنشاء؟',
                    a: 'استخدام Seedance يكلف 18 رصيداً لكل إنشاء. يمكنك الحصول على أسعار أرصدة أفضل من خلال خطط الاشتراك.'
                },
                {
                    q: 'ما مدى سرعة التوليد؟',
                    a: 'متوسط سرعة توليد Seedance حوالي 1.5 دقيقة. نستمر في تحسين بنيتنا التحتية لضمان توليد سريع ومستقر.'
                },
                {
                    q: 'ما هي تنسيقات الإخراج المدعومة؟',
                    a: 'يتم إخراج الفيديوهات بصيغة MP4، داعمة دقات 480p و 720p و 1080p، بمدد 5 أو 10 ثوانٍ، ونسب عرض متعددة.'
                }
            ]
        },
        veo: {
            title: 'مولّد فيديو Veo 3.1 AI بالذكاء الاصطناعي',
            desc: 'Google Veo 3.1 هو نموذج فيديو AI متطور يدعم إنشاء صوت أصلي، ودقة فائقة، وإنشاء فيديو طويل. مثالي لإنتاج الفيديو الاحترافي.',
            fastType: 'نوع سريع',
            fastTypeBadge: 'سرعة عالية، تكلفة أقل',
            fastTypeDesc: '(يدعم صور مرجعية 16:9)',
            qualityType: 'نوع الجودة',
            qualityTypeBadge: 'تفاصيل أغنى',
            qualityTypeDesc: 'حركة أكثر سلاسة. الإطار النهائي اختياري في وضع الصورة للتحكم بالإطار الأخير.',
            imageMode: 'وضع الإنشاء',
            startEndFrames: 'إطارات البداية/النهاية',
            referenceImage: 'صورة مرجعية',
            startFrame: 'إطار البداية',
            startFrameHint: 'تعيين الإطار الأول. يتحرك الفيديو من هذا الإطار.',
            uploadStartFrame: 'انقر لرفع إطار البداية',
            endFrame: 'الإطار النهائي',
            endFrameHint: 'تعيين الإطار الأخير. ينتهي الفيديو عند هذا الإطار.',
            uploadEndFrame: 'انقر لرفع الإطار النهائي',
            negativePrompt: 'وصف سلبي',
            negativePromptPlaceholder: 'صِف ما لا تريد أن يظهر في الفيديو...',
            features: [
                {
                    icon: '🎬',
                    title: 'إنشاء صوت أصلي',
                    desc: 'إنشاء متزامن للفيديو والصوت، بما في ذلك الحوار والمؤثرات الصوتية.'
                },
                {
                    icon: '📺',
                    title: 'دقة فائقة الوضوح',
                    desc: 'دعم إخراج بدقة تصل إلى 4K لإنتاج فيديو احترافي.'
                },
                {
                    icon: '⏱️',
                    title: 'دعم الفيديو الطويل',
                    desc: 'إنشاء فيديوهات تصل إلى دقيقتين، مناسبة لاحتياجات إبداعية متنوعة.'
                },
                {icon: '🎥', title: 'حركة سينمائية', desc: 'حركات كاميرا احترافية وانتقالات سلسة.'},
                {icon: '⚡', title: 'توليد سريع', desc: 'محرك استنتاج محسّن لإنتاج سريع.'},
                {
                    icon: '💼',
                    title: 'ترخيص تجاري',
                    desc: 'جميع الفيديوهات المُنشأة يمكن استخدامها لأغراض تجارية.'
                }
            ],
            faq: [
                {
                    q: 'ما الفرق بين النوع السريع ونوع الجودة؟',
                    a: 'النوع السريع أسرع وأكثر اقتصاداً، مناسب للتكرار السريع. نوع الجودة ينتج تفاصيل أغنى وحركة أكثر سلاسة، مثالي للمخرجات النهائية.'
                },
                {
                    q: 'كيف يعمل Veo 3.1؟',
                    a: 'أدخل وصفاً نصياً أو ارفع صورة مرجعية، وسيقوم Veo 3.1 بإنشاء محتوى فيديو عالي الجودة بناءً على تعليماتك، مع صوت متزامن اختيارياً.'
                },
                {
                    q: 'كم عدد الأرصدة لكل إنشاء؟',
                    a: 'استخدام Veo 3.1 يكلف 30 رصيداً لكل إنشاء. يمكنك الحصول على أسعار أرصدة أفضل من خلال خطط الاشتراك.'
                },
                {
                    q: 'ما هي الدقات والمدد المدعومة؟',
                    a: 'يدعم دقات 720p و 1080p، بمدد 5 ثوانٍ و 10 ثوانٍ، وحتى دقيقتين للفيديوهات الأطول.'
                }
            ]
        },
        veo31: {
            genType: 'نوع الإنشاء',
            genTypeFast: 'سريع',
            genTypeQuality: 'جودة',
            endFrame: 'الإطار النهائي'
        },
        veo30: {
            title: 'مولّد فيديو Veo 3.0 AI بالذكاء الاصطناعي',
            desc: 'Google Veo 3.0 هو نموذج فيديو AI متقدم يدعم نص إلى فيديو وصورة إلى فيديو، بمدة 4/6/8 ثوانٍ ودقة 720p/1080p.',
            fastType: 'نوع سريع',
            fastTypeBadge: 'أسرع، تكلفة أقل',
            fastTypeDesc: '(يدعم صورة مرجعية 16:9)',
            qualityType: 'نوع الجودة',
            qualityTypeBadge: 'تفاصيل أغنى',
            qualityTypeDesc: 'حركة أكثر سلاسة. الإطار النهائي في وضع الصورة اختياري للتحكم بالإطار الأخير.',
            imageMode: 'وضع الصورة',
            startEndFrames: 'إطار البداية/النهاية',
            referenceImage: 'صورة مرجعية',
            referenceImageHint: 'ارفع صورة مرجعية؛ سيتم إنشاء الفيديو بناءً عليها.',
            uploadReferenceImage: 'انقر لرفع صورة مرجعية',
            startFrame: 'إطار البداية',
            startFrameHint: 'تعيين الإطار الأول. يتحرك الفيديو من هذا الإطار.',
            uploadStartFrame: 'انقر لرفع إطار البداية',
            endFrame: 'الإطار النهائي',
            endFrameHint: 'تعيين الإطار الأخير. ينتهي الفيديو عند هذا الإطار.',
            uploadEndFrame: 'انقر لرفع الإطار النهائي',
            negativePrompt: 'وصف سلبي',
            negativePromptPlaceholder: 'صِف ما لا تريد أن يظهر في الفيديو...',
            seedRangeError: 'يجب أن تكون البذرة عدداً صحيحاً بين 0 و 2147483647.',
            duration: 'المدة',
            resolution: 'الدقة',
            demoPrompt: 'فتاة مراهقة ترسم في دفترها عند نافذة مقهى، قطرات المطر تطرق على الزجاج...',
            features: [
                {
                    icon: '🎬',
                    title: 'إنشاء صوت أصلي',
                    desc: 'إنشاء متزامن للفيديو والصوت، بما في ذلك الحوار والمؤثرات الصوتية.'
                },
                {
                    icon: '📺',
                    title: 'دقة عالية',
                    desc: 'دعم إخراج 720p و 1080p لإنتاج فيديو احترافي.'
                },
                {icon: '⏱️', title: 'مدد متعددة', desc: 'دعم إنشاء فيديو بمدة 4 و 6 و 8 ثوانٍ.'},
                {icon: '🎥', title: 'حركة سينمائية', desc: 'حركات كاميرا احترافية وانتقالات سلسة.'},
                {icon: '⚡', title: 'توليد سريع', desc: 'محرك استنتاج محسّن لإنتاج سريع.'},
                {
                    icon: '💼',
                    title: 'ترخيص تجاري',
                    desc: 'جميع الفيديوهات المُنشأة يمكن استخدامها لأغراض تجارية.'
                }
            ],
            faq: [
                {
                    q: 'ما الفرق بين النوع السريع ونوع الجودة؟',
                    a: 'النوع السريع أسرع وأكثر اقتصاداً، مناسب للتكرار السريع. نوع الجودة ينتج تفاصيل أغنى وحركة أكثر سلاسة، مثالي للمخرجات النهائية.'
                },
                {
                    q: 'كيف يعمل Veo 3.0؟',
                    a: 'أدخل وصفاً نصياً أو ارفع صورة مرجعية، وسيقوم Veo 3.0 بإنشاء محتوى فيديو عالي الجودة بناءً على تعليماتك، مع صوت متزامن اختيارياً.'
                },
                {
                    q: 'كم عدد الأرصدة لكل إنشاء؟',
                    a: 'استخدام Veo 3.0 يكلف 25 رصيداً لكل إنشاء. يمكنك الحصول على أسعار أرصدة أفضل من خلال خطط الاشتراك.'
                },
                {
                    q: 'ما هي الدقات والمدد المدعومة؟',
                    a: 'يدعم دقات 720p و 1080p، بمدد 4 أو 6 أو 8 ثوانٍ.'
                }
            ]
        },
        veo31fast: {
            title: 'مولّد فيديو Veo 3.1 Fast AI بالذكاء الاصطناعي',
            desc: 'Google Veo 3.1 Fast لإنشاء أسرع، يدعم نص إلى فيديو وصورة إلى فيديو مع إطار ذيل اختياري، بمدة 4/6/8 ثوانٍ ودقة 720p/1080p/4K.',
            referenceImage: 'صورة مرجعية',
            referenceImageHint: 'ارفع صورة مرجعية؛ سيتم إنشاء الفيديو بناءً عليها.',
            uploadReferenceImage: 'انقر لرفع صورة مرجعية',
            endFrame: 'إطار الذيل',
            endFrameHint: 'اختياري. تعيين صورة الإطار الأخير للفيديو للتحكم بالنهاية.',
            uploadEndFrame: 'انقر لرفع إطار الذيل',
            duration: 'المدة',
            resolution: 'الدقة',
            seedRangeError: 'يجب أن تكون البذرة عدداً صحيحاً بين 0 و 2147483647.',
            demoPrompt: 'فتاة مراهقة ترسم في دفترها عند نافذة مقهى، قطرات المطر تطرق على الزجاج...',
            features: [
                {icon: '⚡', title: 'توليد سريع', desc: 'محسّن لإخراج أسرع.'},
                {icon: '📺', title: 'دقة 4K', desc: 'دعم إخراج 720p و 1080p و 4K.'},
                {icon: '⏱️', title: 'مدد متعددة', desc: 'دعم فيديو بمدة 4 و 6 و 8 ثوانٍ.'},
                {
                    icon: '🖼️',
                    title: 'إطار ذيل اختياري',
                    desc: 'يمكن لصورة إلى فيديو رفع إطار ذيل للتحكم بالنهاية.'
                },
                {icon: '🎥', title: 'حركة سينمائية', desc: 'حركات كاميرا احترافية وانتقالات سلسة.'},
                {
                    icon: '💼',
                    title: 'ترخيص تجاري',
                    desc: 'جميع الفيديوهات المُنشأة يمكن استخدامها لأغراض تجارية.'
                }
            ],
            faq: [
                {
                    q: 'ما الفرق بين Veo 3.1 Fast و Veo 3.1؟',
                    a: 'Veo 3.1 Fast محسّن للسرعة وتكلفة أرصدة أقل، مع دعم 4K وإطار ذيل اختياري.'
                },
                {
                    q: 'ما هو إطار الذيل؟',
                    a: 'لصورة إلى فيديو، يمكنك رفع صورة إطار الذيل بحيث ينتهي الفيديو عند هذا الإطار، مما يمنحك التحكم في النهاية.'
                },
                {
                    q: 'كم عدد الأرصدة لكل إنشاء؟',
                    a: 'استخدام Veo 3.1 Fast يكلف 20 رصيداً لكل إنشاء.'
                },
                {
                    q: 'ما هي الدقات والمدد المدعومة؟',
                    a: 'يدعم دقات 720p و 1080p و 4K، بمدد 4 أو 6 أو 8 ثوانٍ.'
                }
            ]
        },
        kling: {
            title: 'مولّد فيديو Kling 2.6 AI بالذكاء الاصطناعي',
            desc: 'Kling 2.6 هو نموذج فيديو AI عالي الأداء يدعم نص إلى فيديو وصورة إلى فيديو، بجودة حركة ممتازة وسرعة إنشاء عالية.',
            features: [
                {
                    icon: '🎬',
                    title: 'حركة عالية الجودة',
                    desc: 'حركة سلسة وطبيعية بمخرجات بجودة احترافية.'
                },
                {icon: '📱', title: 'نسب عرض متعددة', desc: 'دعم 1:1، 16:9، 9:16 ونسب عرض أخرى.'},
                {
                    icon: '🔊',
                    title: 'إنشاء صوت',
                    desc: 'إنشاء صوت أصلي اختياري لتجربة فيديو كاملة.'
                },
                {icon: '⚡', title: 'توليد سريع', desc: 'معظم الفيديوهات تُنشأ خلال دقيقتين.'},
                {icon: '🖼️', title: 'صورة إلى فيديو', desc: 'تحريك الصور الثابتة بحركة مدعومة بالذكاء الاصطناعي.'},
                {
                    icon: '💼',
                    title: 'ترخيص تجاري',
                    desc: 'جميع الفيديوهات المُنشأة يمكن استخدامها لأغراض تجارية.'
                }
            ],
            faq: [
                {
                    q: 'كيف يعمل Kling 2.6؟',
                    a: 'أدخل وصفاً نصياً أو ارفع صورة مرجعية، وسيقوم Kling 2.6 بإنشاء محتوى فيديو عالي الجودة بناءً على تعليماتك.'
                },
                {
                    q: 'كم عدد الأرصدة لكل إنشاء؟',
                    a: 'استخدام Kling 2.6 يكلف 28 رصيداً لكل إنشاء. يمكنك الحصول على أسعار أرصدة أفضل من خلال خطط الاشتراك.'
                },
                {
                    q: 'ما هي الدقات والمدد المدعومة؟',
                    a: 'يدعم دقات 720p و 1080p، بمدد 5 و 10 ثوانٍ.'
                },
                {
                    q: 'هل يمكنني استخدام الفيديوهات المُنشأة تجارياً؟',
                    a: 'نعم، جميع المحتوى المُنشأ باستخدام Kling 2.6 يمكن استخدامه لأغراض تجارية.'
                }
            ]
        },
        kling3: {
            title: 'مولّد فيديو Kling 3.0 AI بالذكاء الاصطناعي',
            desc: 'Kling 3.0 هو نموذج فيديو AI عالي الأداء يدعم نص إلى فيديو وصورة إلى فيديو، بجودة حركة ممتازة وسرعة إنشاء عالية.',
            features: [
                {
                    icon: '🎬',
                    title: 'حركة عالية الجودة',
                    desc: 'حركة سلسة وطبيعية بمخرجات بجودة احترافية.'
                },
                {icon: '📱', title: 'نسب عرض متعددة', desc: 'دعم 1:1، 16:9، 9:16 ونسب عرض أخرى.'},
                {
                    icon: '🔊',
                    title: 'إنشاء صوت',
                    desc: 'إنشاء صوت أصلي اختياري لتجربة فيديو كاملة.'
                },
                {icon: '⚡', title: 'توليد سريع', desc: 'معظم الفيديوهات تُنشأ خلال دقيقتين.'},
                {icon: '🖼️', title: 'صورة إلى فيديو', desc: 'تحريك الصور الثابتة بحركة مدعومة بالذكاء الاصطناعي.'},
                {
                    icon: '💼',
                    title: 'ترخيص تجاري',
                    desc: 'جميع الفيديوهات المُنشأة يمكن استخدامها لأغراض تجارية.'
                }
            ],
            faq: [
                {
                    q: 'كيف يعمل Kling 3.0؟',
                    a: 'أدخل وصفاً نصياً أو ارفع صورة مرجعية، وسيقوم Kling 3.0 بإنشاء محتوى فيديو عالي الجودة بناءً على تعليماتك.'
                },
                {
                    q: 'كم عدد الأرصدة لكل إنشاء؟',
                    a: 'استخدام Kling 3.0 يكلف 28 رصيداً لكل إنشاء. يمكنك الحصول على أسعار أرصدة أفضل من خلال خطط الاشتراك.'
                },
                {
                    q: 'ما هي الدقات والمدد المدعومة؟',
                    a: 'يدعم دقات 720p و 1080p، بمدد 5 و 10 ثوانٍ.'
                },
                {
                    q: 'هل يمكنني استخدام الفيديوهات المُنشأة تجارياً؟',
                    a: 'نعم، جميع المحتوى المُنشأ باستخدام Kling 3.0 يمكن استخدامه لأغراض تجارية.'
                }
            ]
        },
        sora: {
            title: 'مولّد فيديو Sora 2 AI بالذكاء الاصطناعي',
            desc: 'Sora 2 هو نموذج فيديو AI متطور من OpenAI، قادر على إنشاء فيديوهات عالية الجودة بحركة واقعية وجودة سينمائية.',
            demoPromptExample: '@sama المدير التنفيذي لـ OpenAI، سام، يقدم منتج الخزانة هذا، قائلاً إنه نفس الذي يملكه ومفيد جداً.',
            landscape: 'أفقي',
            portrait: 'عمودي',
            removeWatermark: 'إزالة العلامة المائية',
            enabled: 'مفعّل',
            disabled: 'معطّل',
            noWatermark: 'بدون علامة مائية',
            cinematic: 'جودة سينمائية',
            restrictedAccess: 'وصول مقيد',
            '60secDuration': 'مدة 4 / 8 / 12 ثانية',
            photorealistic: 'واقعي فوتوغرافي',
            physicsSimulation: 'محاكاة فيزيائية',
            features: [
                {
                    icon: '🎬',
                    title: 'جودة سينمائية',
                    desc: 'إنشاء فيديوهات بمظهر وإحساس سينمائي احترافي.'
                },
                {
                    icon: '🎥',
                    title: 'حركة واقعية',
                    desc: 'حركة طبيعية وواقعية للشخصيات والمشاهد.'
                },
                {icon: '⏱️', title: 'مدة مرنة', desc: 'دعم أطوال فيديو متنوعة للاحتياجات المختلفة.'},
                {icon: '⚡', title: 'توليد سريع', desc: 'محسّن لإنتاج فيديو سريع.'},
                {icon: '🖼️', title: 'مدخلات متعددة الأنماط', desc: 'دعم وضع نص إلى فيديو وصورة إلى فيديو.'},
                {
                    icon: '💼',
                    title: 'ترخيص تجاري',
                    desc: 'جميع الفيديوهات المُنشأة يمكن استخدامها لأغراض تجارية.'
                }
            ],
            faq: [
                {
                    q: 'كيف يعمل Sora 2؟',
                    a: 'أدخل وصفاً نصياً أو ارفع صورة مرجعية، وسيقوم Sora 2 بإنشاء محتوى فيديو عالي الجودة بناءً على تعليماتك.'
                },
                {
                    q: 'كم عدد الأرصدة لكل إنشاء؟',
                    a: 'استخدام Sora 2 يكلف 15 رصيداً لكل إنشاء. يمكنك الحصول على أسعار أرصدة أفضل من خلال خطط الاشتراك.'
                },
                {
                    q: 'ما الذي يميز Sora 2؟',
                    a: 'يتفوق Sora 2 في إنشاء حركة واقعية وفيديوهات بجودة سينمائية، مما يجعله مثالياً لإنشاء محتوى احترافي.'
                },
                {
                    q: 'هل يمكنني استخدام الفيديوهات المُنشأة تجارياً؟',
                    a: 'نعم، جميع المحتوى المُنشأ باستخدام Sora 2 يمكن استخدامه لأغراض تجارية.'
                }
            ]
        },
        wan: {
            title: 'مولّد فيديو Wan AI بالذكاء الاصطناعي',
            desc: 'Wan هو نموذج فيديو AI متعدد الاستخدامات يدعم نص إلى فيديو وصورة إلى فيديو بجودة وسرعة ممتازة.',
            multiFormat: 'تنسيقات متعددة',
            smoothMotion: 'حركة سلسة',
            referenceAudio: 'صوت مرجعي',
            uploadAudio: 'انقر لرفع صوت مرجعي',
            uploadAudioHint: 'MP3، WAV، M4A (اختياري، يوجّه المقطع الصوتي للفيديو)',
            features: [
                {
                    icon: '🎬',
                    title: 'مخرجات عالية الجودة',
                    desc: 'إنشاء فيديوهات بجودة احترافية من نص أو صور.'
                },
                {icon: '⚡', title: 'توليد سريع', desc: 'إنتاج فيديو سريع لسير عمل فعال.'},
                {icon: '📱', title: 'تنسيقات متعددة', desc: 'دعم نسب عرض ودقات متعددة.'},
                {icon: '🖼️', title: 'تحريك الصور', desc: 'إحياء الصور الثابتة بحركة AI.'},
                {icon: '🎥', title: 'حركة سلسة', desc: 'حركة طبيعية وسلسة في الفيديوهات المُنشأة.'},
                {
                    icon: '💼',
                    title: 'ترخيص تجاري',
                    desc: 'جميع الفيديوهات المُنشأة يمكن استخدامها لأغراض تجارية.'
                }
            ],
            faq: [
                {
                    q: 'كيف يعمل Wan؟',
                    a: 'أدخل وصفاً نصياً أو ارفع صورة مرجعية، وسيقوم Wan بإنشاء محتوى فيديو عالي الجودة بناءً على تعليماتك.'
                },
                {
                    q: 'أي إصدار من Wan يجب أن أستخدم؟',
                    a: 'Wan 2.5 و 2.6 يقدمان أحدث الميزات وأفضل جودة. Wan 2.2 خيار اقتصادي للمشاريع الأبسط.'
                },
                {
                    q: 'كم عدد الأرصدة لكل إنشاء؟',
                    a: 'Wan 2.6 يكلف 70 رصيداً، Wan 2.5 يكلف 60 رصيداً، و Wan 2.2 يكلف 10 أرصدة لكل إنشاء.'
                },
                {
                    q: 'هل يمكنني استخدام الفيديوهات المُنشأة تجارياً؟',
                    a: 'نعم، جميع المحتوى المُنشأ باستخدام Wan يمكن استخدامه لأغراض تجارية.'
                }
            ]
        },
        wan25: {
            title: 'مولّد فيديو Wan 2.5 AI بالذكاء الاصطناعي',
            desc: 'Wan 2.5 هو نموذج فيديو AI متعدد الاستخدامات يدعم نص إلى فيديو وصورة إلى فيديو بجودة وسرعة ممتازة.',
            features: [
                {
                    icon: '🎬',
                    title: 'مخرجات عالية الجودة',
                    desc: 'إنشاء فيديوهات بجودة احترافية من نص أو صور.'
                },
                {icon: '⚡', title: 'توليد سريع', desc: 'إنتاج فيديو سريع لسير عمل فعال.'},
                {icon: '📱', title: 'تنسيقات متعددة', desc: 'دعم نسب عرض ودقات متعددة.'},
                {icon: '🖼️', title: 'تحريك الصور', desc: 'إحياء الصور الثابتة بحركة AI.'},
                {icon: '🎥', title: 'حركة سلسة', desc: 'حركة طبيعية وسلسة في الفيديوهات المُنشأة.'},
                {
                    icon: '💼',
                    title: 'ترخيص تجاري',
                    desc: 'جميع الفيديوهات المُنشأة يمكن استخدامها لأغراض تجارية.'
                }
            ],
            faq: [
                {
                    q: 'كيف يعمل Wan 2.5؟',
                    a: 'أدخل وصفاً نصياً أو ارفع صورة مرجعية، وسيقوم Wan 2.5 بإنشاء محتوى فيديو عالي الجودة بناءً على تعليماتك.'
                },
                {
                    q: 'ما الفرق بين Wan 2.5 و Wan 2.6؟',
                    a: 'Wan 2.6 يقدم تحسينات إضافية في الجودة والاستقرار؛ Wan 2.5 اقتصادي ومناسب لمعظم حالات الاستخدام.'
                },
                {q: 'كم عدد الأرصدة لكل إنشاء؟', a: 'Wan 2.5 يكلف 60 رصيداً لكل إنشاء.'},
                {
                    q: 'هل يمكنني استخدام الفيديوهات المُنشأة تجارياً؟',
                    a: 'نعم، جميع المحتوى المُنشأ باستخدام Wan 2.5 يمكن استخدامه لأغراض تجارية.'
                }
            ]
        },
        wan26: {
            title: 'مولّد فيديو Wan 2.6 AI بالذكاء الاصطناعي',
            desc: 'Wan 2.6 هو نموذج فيديو AI محسّن بجودة واستقرار أفضل، يدعم نص إلى فيديو وصورة إلى فيديو.',
            features: [
                {
                    icon: '🎬',
                    title: 'مخرجات عالية الجودة',
                    desc: 'إنشاء فيديوهات بجودة احترافية من نص أو صور بجودة محسّنة.'
                },
                {icon: '⚡', title: 'توليد سريع', desc: 'إنتاج فيديو سريع لسير عمل فعال.'},
                {icon: '📱', title: 'تنسيقات متعددة', desc: 'دعم نسب عرض ودقات متعددة.'},
                {icon: '🖼️', title: 'تحريك الصور', desc: 'إحياء الصور الثابتة بحركة AI.'},
                {icon: '🎥', title: 'حركة سلسة', desc: 'حركة طبيعية وسلسة في الفيديوهات المُنشأة.'},
                {
                    icon: '💼',
                    title: 'ترخيص تجاري',
                    desc: 'جميع الفيديوهات المُنشأة يمكن استخدامها لأغراض تجارية.'
                }
            ],
            faq: [
                {
                    q: 'ما الفرق بين Wan 2.6 و Wan 2.5؟',
                    a: 'Wan 2.6 يقدم تحسينات إضافية في الجودة والاستقرار لمخرجات أعلى جودة.'
                },
                {
                    q: 'كيف يعمل Wan 2.6؟',
                    a: 'أدخل وصفاً نصياً أو ارفع صورة مرجعية، وسيقوم Wan 2.6 بإنشاء محتوى فيديو عالي الجودة بناءً على تعليماتك.'
                },
                {q: 'كم عدد الأرصدة لكل إنشاء؟', a: 'Wan 2.6 يكلف 70 رصيداً لكل إنشاء.'},
                {
                    q: 'هل يمكنني استخدام الفيديوهات المُنشأة تجارياً؟',
                    a: 'نعم، جميع المحتوى المُنشأ باستخدام Wan 2.6 يمكن استخدامه لأغراض تجارية.'
                }
            ]
        },
        wan22: {
            title: 'مولّد فيديو Wan 2.2 Classic AI بالذكاء الاصطناعي',
            desc: 'Wan 2.2 هو نموذج فيديو AI كلاسيكي لنص إلى فيديو وصورة إلى فيديو، يركز على مخرجات مستقرة وفعالية تكلفة عالية.',
            demoPromptExample: 'فتاة بنمشات قليلة وشعر أحمر فوضوي تجلس على سطح عند الغروب، سترة جينز بالية قليلاً، تحمل كاميرا بولارويد، أفق المدينة يتوهج بألوان ناعمة خلفها.',
            resolutionBadge: '720p',
            classicVersion: 'إصدار كلاسيكي',
            stableReliable: 'مستقر وموثوق',
            costEffective: 'اقتصادي',
            features: [
                {
                    icon: '🎬',
                    title: 'نص/صورة إلى فيديو',
                    desc: 'يدعم نص إلى فيديو وصورة إلى فيديو للإنشاء اليومي والاختبار الدفعي.'
                },
                {icon: '⚡', title: 'نتائج مستقرة', desc: 'نموذج كلاسيكي ناضج بجودة مخرجات متوقعة.'},
                {icon: '💰', title: 'صديق للميزانية', desc: 'استهلاك أرصدة أقل لسير العمل عالي التردد.'},
                {icon: '📐', title: 'نسب شائعة', desc: 'يدعم نسب عرض شائعة مثل 16:9 و 9:16.'},
                {icon: '🎥', title: 'إخراج نظيف', desc: 'يقدم جودة فيديو واضحة ومستقرة.'},
                {icon: '💼', title: 'ترخيص تجاري', desc: 'المحتوى المُنشأ يمكن استخدامه تجارياً.'}
            ],
            faq: [
                {
                    q: 'ما الفرق بين Wan 2.2 و Wan 2.5؟',
                    a: 'Wan 2.2 أفضل للسيناريوهات الحساسة للتكلفة وعالية الحجم؛ Wan 2.5/2.6 يوفران قدرات وجودة أقوى.'
                },
                {
                    q: 'كيف يعمل Wan 2.2؟',
                    a: 'أدخل وصفاً أو ارفع صورة مرجعية، وسيقوم النموذج بإنشاء فيديو بناءً على تعليماتك.'
                },
                {
                    q: 'هل يمكن استخدام الفيديوهات المُنشأة تجارياً؟',
                    a: 'نعم، مخرجات Wan 2.2 يمكن استخدامها لأغراض تجارية.'
                }
            ]
        },
        kling25: {
            title: 'مولّد فيديو Kling 2.5 AI بالذكاء الاصطناعي',
            desc: 'Kling 2.5 هو نموذج فيديو AI قياسي يدعم نص إلى فيديو وصورة إلى فيديو بجودة مستقرة وقيمة جيدة.',
            standard: 'قياسي',
            reliable: 'موثوق',
            costEffective: 'اقتصادي',
            standardQuality: 'جودة قياسية',
            textToVideo: 'نص إلى فيديو',
            imageToVideo: 'صورة إلى فيديو',
            referenceImage: 'صورة مرجعية',
            referenceImageHint: 'انقر للرفع أو اسحب وأفلت',
            referenceImageFormats: 'يدعم PNG، JPG، JPEG، WEBP (بحد أقصى 10 ميغابايت)',
            endFrame: 'الإطار النهائي',
            endFrameOptional: 'اختياري',
            endFrameFormats: 'PNG، JPG، JPEG',
            endFrameHint: 'تقييد إطار النهاية؛ أفضل عند مطابقة نسبة عرض الصورة المرجعية',
            videoPrompt: 'وصف الفيديو',
            promptPlaceholder: 'صِف الفيديو الذي تريد إنشاءه...',
            negativePrompt: 'وصف سلبي',
            negativePromptPlaceholder: 'صِف ما يجب استبعاده...',
            duration: 'المدة',
            aspectRatio: 'نسبة العرض للارتفاع',
            uploading: 'جاري الرفع...',
            clickToUploadReference: 'انقر لرفع صورة مرجعية',
            clickToUploadEndFrame: 'انقر لرفع صورة الإطار النهائي',
            remove: 'إزالة',
            creditsRequired: 'الأرصدة المطلوبة:',
            remaining: 'المتبقي:',
            generate: 'توليد',
            generating: 'جاري التوليد...',
            demoPrompt: 'وصف تجريبي',
            demoPromptExample: 'استخدم صورة الزقيم الخيالي المرفوعة كإطار أول. أبقِ نفس الزقيم، اللافتات النيونية، الانعكاسات والمرأة ذات القبعة وهي تمشي بعيداً. حرّك الكاميرا ببطء للأمام عبر الزقيم...',
            model: 'النموذج:',
            durationLabel: 'المدة:',
            introTitle: 'إنشاء فيديوهات AI عالية الجودة باستخدام Kling 2.5 القياسي',
            featuresBadge: 'الميزات الأساسية',
            featuresTitle: 'ماذا يمكن لـ {name} أن يفعل؟',
            faqTitle: 'الأسئلة الشائعة',
            errorPromptRequired: 'يرجى إدخال وصف',
            errorImageRequired: 'الصورة المرجعية مطلوبة في وضع صورة إلى فيديو',
            errorGenerationFailed: 'فشل التوليد',
            errorRequestFailed: 'فشل الطلب، يرجى المحاولة مرة أخرى',
            errorUploadFailed: 'فشل الرفع، يرجى المحاولة مرة أخرى',
            features: [
                {
                    icon: '🎬',
                    title: 'نص/صورة إلى فيديو',
                    desc: 'يدعم نص إلى فيديو وصورة إلى فيديو بخيارات مدة 5/10 ثوانٍ.'
                },
                {icon: '⚡', title: 'مخرجات موثوقة', desc: 'نموذج قياسي ناضج بأداء مستقر.'},
                {icon: '💰', title: 'قيمة ممتازة', desc: 'استهلاك أرصدة أقل من النماذج الأعلى.'},
                {icon: '📐', title: 'نسب متعددة', desc: 'يدعم 1:1، 16:9، و 9:16.'},
                {icon: '💼', title: 'ترخيص تجاري', desc: 'المحتوى المُنشأ يمكن استخدامه تجارياً.'}
            ],
            faq: [
                {
                    q: 'ما الفرق بين Kling 2.5 و Kling 2.6؟',
                    a: 'Kling 2.5 محسّن للتكلفة والإنتاجية، بينما Kling 2.6 يوفر قدرات شاملة أقوى.'
                },
                {
                    q: 'كيف يعمل Kling 2.5؟',
                    a: 'أدخل وصفاً أو ارفع صورة مرجعية، وسيقوم Kling 2.5 بإنشاء الفيديو وفقاً لذلك.'
                },
                {q: 'هل يمكن استخدام الفيديوهات المُنشأة تجارياً؟', a: 'نعم، مخرجات Kling 2.5 يمكن استخدامها تجارياً.'}
            ]
        },
        viduq3pro: {
            title: 'فيديو Vidu Q3 Pro AI',
            desc: 'Vidu Q3 Pro يدعم نص إلى فيديو وصورة إلى فيديو مع دقة، وطول 1-16 ثانية، ونسب عرض، وصوت اختياري.',
            imageUrlHint: 'يتم قبول روابط صور HTTPS فقط (الرفع يرجع رابطاً عاماً). يجب أن تكون نسبة عرض الصورة بين 1:4 و 4:1.',
            lengthLabel: 'المدة (ثوانٍ)',
            optional: 'اختياري',
            tagHighQuality: 'جودة عالية',
            tagLength: '1-16 ثانية',
            tagResolution: 'حتى 2K',
            demoPromptExample: 'كورنيش بحري عند شروق الشمس، عدّائون، نورس فوق الماء، شراع في الأفق.',
            features: [
                {icon: '🎬', title: 'نص وصورة', desc: 'إنشاء من وصف أو صورة مرجعية.'},
                {icon: '📐', title: 'نسب عرض', desc: 'وضع النص: 16:9، 9:16، 1:1، 4:3، 3:4.'},
                {icon: '⏱️', title: 'طول مرن', desc: 'اختر من 1 إلى 16 ثانية.'},
                {icon: '🎵', title: 'صوت اختياري', desc: 'تفعيل صوت طبيعي للمقطع.'},
                {icon: '🎲', title: 'تحكم بالبذرة', desc: 'بذرة اختيارية لنتائج أكثر قابلية للتكرار.'}
            ],
            faq: [
                {q: 'ماذا يتطلب وضع صورة إلى فيديو؟', a: 'رابط صورة HTTPS عام (JPG/PNG). يجب أن تكون نسبة العرض أضيق من 1:4 أو 4:1.'},
                {q: 'ما الفرق بين وضعي النص والصورة؟', a: 'وضع النص يستخدم نسبة العرض؛ وضع الصورة يستخدم رابط صورتك ولا يرسل حقول نسبة العرض النصية فقط.'},
                {q: 'كيف تُحسب الأرصدة؟', a: 'حسب الأرصدة المعروضة على الصفحة، بناءً على المدة والدقة وإعدادات الصوت.'}
            ]
        },
        wanAnimate: {
            title: 'Wan Animate',
            desc: 'تحريك الشخصيات من صورة مرجعية وفيديو حركة. جودة قياسية أو احترافية.',
            animateMode: 'وضع التحريك',
            modeAnimate: 'صورة إلى حركة',
            modeReplace: 'استبدال شخصية الفيديو',
            referenceVideo: 'فيديو مرجعي',
            quality: 'وضع الجودة',
            refImageLabel: 'صورة مرجعية',
            refImageHint: 'الشخصية أو الموضوع المراد تحريكه (JPG/PNG/JPEG/BMP/WEBP، بحد أقصى 5 ميغابايت، أضلاع 200-4096 بكسل، نسبة 1:3-3:1).',
            refVideoLabel: 'فيديو مرجعي',
            refVideoHint: 'مرجع الحركة (MP4/AVI/MOV، 2-30 ثانية، بحد أقصى 200 ميغابايت، أضلاع 200-2048 بكسل، نسبة 1:3-3:1).',
            animateModeLabel: 'وضع التحريك',
            btnAnimate: 'تحريك',
            animateModeBadgeAnimate: 'حركة',
            animateModeBadgeReplace: 'استبدال',
            btnAnimateDesc: 'دمج الشخصية من الصورة مع الحركة من الفيديو.',
            btnReplace: 'استبدال',
            btnReplaceDesc: 'استبدال الشخصية في الفيديو بالشخصية من الصورة.',
            qualityLabel: 'وضع الجودة',
            qualityStd: 'قياسي',
            qualityPro: 'احترافي',
            watermarkLabel: 'علامة مائية',
            uploadVideoRequired: 'يرجى رفع فيديو مرجعي.',
            uploadImage: 'رفع صورة',
            uploadVideo: 'رفع فيديو',
            uploading: 'جاري الرفع...',
            imageUploadHint: 'JPG، PNG، JPEG، BMP، WEBP · بحد أقصى 5 ميغابايت',
            videoUploadHint: 'MP4، AVI، MOV · 2-30 ثانية · بحد أقصى 200 ميغابايت',
            uploadImageRequired: 'يرجى رفع صورة مرجعية.',
            errImageFileTooLarge: 'ملف الصورة كبير جداً (بحد أقصى 5 ميغابايت).',
            errImageDimensions: 'يجب أن يكون عرض وارتفاع الصورة بين 200 و 4096 بكسل.',
            errImageAspect: 'يجب أن تكون نسبة عرض الصورة بين 1:3 و 3:1.',
            errImageInvalid: 'ملف صورة غير صالح أو غير قابل للقراءة.',
            errVideoFileTooLarge: 'ملف الفيديو كبير جداً (بحد أقصى 200 ميغابايت).',
            errVideoDuration: 'يجب أن تكون مدة الفيديو بين 2 و 30 ثانية.',
            errVideoDimensions: 'يجب أن يكون عرض وارتفاع الفيديو بين 200 و 2048 بكسل.',
            errVideoAspect: 'يجب أن تكون نسبة عرض الفيديو بين 1:3 و 3:1.',
            errVideoInvalid: 'ملف فيديو غير صالح أو غير قابل للقراءة.',
            defaultModelName: 'Wan Animate',
            demoEmptyHint: 'ارفع صورة شخصية وفيديو حركة، واستخدم Wan Animate لإنشاء رسوم شخصيات متحركة مذهلة.',
            demoEmptyTitle: 'تحريك الشخصيات',
            demoStepCharacter: 'الشخصية',
            demoStepMotion: 'الحركة',
            demoStepAnimate: 'تحريك',
            faqCredits: 'الوضع القياسي يستخدم أرصدة أقل لكل إنشاء مقارنة بالوضع الاحترافي. راجع سطر الأرصدة أعلاه.',
            characterAnimation: 'تحريك الشخصيات',
            faceSwap: 'تبديل الوجوه',
            motionTransfer: 'نقل الحركة',
            identityReplacement: 'استبدال الهوية',
            motionAccuracy: 'دقة حركة عالية',
            features: [
                {icon: '🎭', title: 'وضعان', desc: 'تحريك نقل الحركة أو استبدال الشخصية بالكامل.'},
                {icon: '📐', title: 'اتصال DashScope رسمي', desc: 'مدعوم بـ Wan 2.2 Animate على Alibaba Cloud.'},
                {icon: '⚡', title: 'قياسي / احترافي', desc: 'اختر الجودة القياسية أو الاحترافية حسب المهمة.'},
                {icon: '💧', title: 'علامة مائية اختيارية', desc: 'تفعيل أو تعطيل العلامة المائية على المخرجات.'}
            ],
            faq: [
                {q: 'ما هي المدخلات المطلوبة؟', a: 'رابط صورة HTTPS عام ورابط فيديو بعد الرفع. يجب أن تستوفي الصور والفيديوهات حدود الحجم ونسبة العرض.'},
                {q: 'ما الفرق بين التحريك والاستبدال؟', a: 'التحريك يطبق حركة الفيديو على شخصية صورتك. الاستبدال يبدل الشخصية في الفيديو بشخصية صورتك.'},
                {q: 'كيف تُحسب الأرصدة؟', a: 'الوضع الاحترافي يكلف أكثر من الوضع القياسي لكل إنشاء، كما هو موضح على الصفحة.'}
            ]
        },
        hailuo: {
            title: 'مولّد فيديو Hailuo 2.3 AI بالذكاء الاصطناعي',
            desc: 'Hailuo 2.3 هو نموذج فيديو AI من الجيل التالي مصمم لإنشاء فيديوهات إبداعية عالية الجودة.',
            demoPromptExample: 'لقطة سينمائية لأمواج تتحطم على شاطئ صخري عند الغروب، ضوء ذهبي ينعكس على الماء...',
            highQuality: 'جودة عالية',
            highQualityOutput: 'مخرجات عالية الجودة',
            features: [
                {icon: '🎬', title: 'نص إلى فيديو', desc: 'إنشاء فيديوهات عالية الجودة مباشرة من الأوصاف النصية.'},
                {
                    icon: '✨',
                    title: 'تحسين الوصف',
                    desc: 'تحسين الوصف يساعد في تحسين التناسق والجودة.'
                },
                {icon: '🌊', title: 'نمط إبداعي', desc: 'مثالي للمحتوى الإبداعي والفني.'},
                {icon: '⚡', title: 'توليد سريع', desc: 'خط أنابيب محسّن لسرعة إنجاز أعلى.'},
                {icon: '🎨', title: 'جودة بصرية', desc: 'ينتج مخرجات بصرية مفصلة ومستقرة.'},
                {icon: '💼', title: 'ترخيص تجاري', desc: 'المحتوى المُنشأ يمكن استخدامه تجارياً.'}
            ],
            faq: [
                {
                    q: 'كيف يعمل Hailuo 2.3؟',
                    a: 'أدخل وصفاً أو ارفع صورة مرجعية وسيقوم النموذج بإنشاء الفيديو المناسب.'
                },
                {
                    q: 'ما هو تحسين الوصف؟',
                    a: 'تحسين الوصف يعيد كتابة وإثراء الأوصاف للحصول على جودة إنشاء أفضل.'
                },
                {
                    q: 'هل يمكن استخدام الفيديوهات المُنشأة تجارياً؟',
                    a: 'نعم، مخرجات Hailuo 2.3 يمكن استخدامها تجارياً.'
                },
                {
                    q: 'كم عدد الأرصدة لكل إنشاء؟',
                    a: 'كل إنشاء يُحاسب حسب قواعد أرصدة النموذج الحالية.'
                }
            ]
        },
        runway: {
            title: 'مولّد فيديو Runway AI بالذكاء الاصطناعي',
            desc: 'Runway هو نموذج فيديو AI احترافي مع تحكم مرن بالنسبة والمدة والبذرة.',
            demoPromptExample: 'عند الغسق، تظهر صوَر الرافعات في موقع بناء سنغافوري مقابل غروب شمس ساطع. عدة عمال بناء يرتدون خوذات يحزمون أدواتهم، مستعدين للمغادرة...',
            professional: 'احترافي',
            multiOption: 'خيارات متعددة',
            highQuality: 'جودة عالية',
            multiFormat: 'نسب متعددة',
            reproducibleSeed: 'بذرة قابلة للتكرار',
            features: [
                {
                    icon: '🎬',
                    title: 'صورة إلى فيديو',
                    desc: 'ارفع صورة مرجعية ووصفاً لإنشاء فيديوهات عالية الجودة بسرعة.'
                },
                {icon: '📐', title: 'نسب متعددة', desc: 'يدعم 16:9، 9:16، 1:1، 4:3، 3:4، و 21:9.'},
                {icon: '🎲', title: 'تحكم بالبذرة', desc: 'استخدم البذرة لإعادة إنتاج نتائج إنشاء مشابهة.'},
                {
                    icon: '⚡',
                    title: 'مخرجات احترافية',
                    desc: 'مخرجات متسقة مناسبة لسير العمل الاحترافي والتجاري.'
                },
                {icon: '🖼️', title: 'تحريك الصور', desc: 'تحويل الصور الثابتة إلى لقطات فيديو ديناميكية.'},
                {icon: '💼', title: 'ترخيص تجاري', desc: 'المحتوى المُنشأ يمكن استخدامه تجارياً.'}
            ],
            faq: [
                {
                    q: 'كيف يعمل Runway؟',
                    a: 'ارفع صورة مرجعية وأدخل وصفاً؛ سيقوم النموذج بإنشاء الفيديو المناسب.'
                },
                {q: 'ما هي نسب العرض المدعومة؟', a: 'يدعم 16:9، 9:16، 1:1، 4:3، 3:4، و 21:9.'},
                {q: 'هل يمكن استخدام الفيديوهات المُنشأة تجارياً؟', a: 'نعم، مخرجات Runway يمكن استخدامها تجارياً.'}
            ]
        }
    },
    privacy: {
        title: 'سياسة الخصوصية',
        lastUpdated: 'آخر تحديث: 15 يناير 2025',
        navTerms: 'شروط الخدمة ←',
        navTrust: 'الثقة والسلامة ←',
        sections: [
            {
                title: '1. جمع المعلومات',
                paragraphs: ['نجمع المعلومات التي تقدمها عند التسجيل واستخدام خدماتنا، بما في ذلك عنوان البريد الإلكتروني واسم المستخدم ومعلومات الدفع.', 'نقوم أيضاً بجمع بيانات الاستخدام تلقائياً مثل عنوان IP ونوع المتصفح ووقت الوصول والميزات المستخدمة.']
            },
            {
                title: '2. استخدام المعلومات',
                paragraphs: ['نستخدم المعلومات المجمعة لتقديم خدماتنا وصيانتها وتحسينها، ومعالجة المعاملات، وإرسال إشعارات متعلقة بالخدمة، ومنع الاحتيال وإساءة الاستخدام.', 'لا نبيع معلوماتك الشخصية لأطراف ثالثة.']
            },
            {
                title: '3. المحتوى المُنشأ بالذكاء الاصطناعي',
                paragraphs: ['الصور التي ترفعها والأوصاف التي تدخلها تُستخدم فقط لإنشاء المحتوى الذي تطلبه ولا تُستخدم لتدريب نماذج الذكاء الاصطناعي.', 'يتم تخزين المحتوى المُنشأ مؤقتاً على خوادمنا لتمكينك من تحميله، ثم يُحذف وفقاً لسياسة الاحتفاظ بالبيانات لدينا.']
            },
            {
                title: '4. أمن البيانات',
                paragraphs: ['نتخذ إجراءات أمنية معيارية في الصناعة لحماية معلوماتك الشخصية، بما في ذلك تشفير SSL وضوابط الوصول وتدقيقات أمنية منتظمة.', 'على الرغم من بذل قصارى جهدنا لحماية بياناتك، لا توجد طريقة نقل عبر الإنترنت آمنة بنسبة 100%.']
            },
            {
                title: '5. استخدام ملفات تعريف الارتباط',
                paragraphs: ['نستخدم ملفات تعريف الارتباط والتقنيات المشابهة لتحسين تجربة المستخدم وتحليل الاستخدام وتقديم محتوى مخصص.', 'يمكنك إدارة تفضيلات ملفات تعريف الارتباط من خلال إعدادات المتصفح. قد يؤثر تعطيل ملفات تعريف الارتباط على بعض الميزات.']
            },
            {
                title: '6. خدمات الطرف الثالث',
                paragraphs: ['قد نستخدم مزودي خدمات طرف ثالث لمساعدتنا في تقديم الخدمات، مثل معالجة المدفوعات وتحليل البيانات ودعم العملاء.', 'يصل مزودو الخدمات هؤلاء إلى معلوماتك الشخصية فقط بالقدر اللازم لأداء الخدمات لصالحنا.']
            },
            {
                title: '7. حقوقك',
                paragraphs: ['لديك حق الوصول إلى معلوماتك الشخصية أو تصحيحها أو حذفها. لديك أيضاً الحق فيطلب تقييد معالجة بياناتك أو نقل بياناتك إلى خدمة أخرى.', 'لممارسة هذه الحقوق، يرجى الاتصال بنا على miral_support@miralvis.com. سنرد على طلبك خلال 30 يوماً.']
            },
            {
                title: '8. التوافق مع GDPR',
                paragraphs: ['بالنسبة للمستخدمين في المنطقة الاقتصادية الأوروبية، نلتزم بمتطلبات لائحة حماية البيانات العامة (GDPR). أساسنا القانوني لمعالجة بياناتك يشمل أداء العقد والمصالح المشروعة وموافقتك.']
            },
            {
                title: '9. اتصل بنا',
                paragraphs: ['إذا كان لديك أي أسئلة أو مخاوف بشأن سياسة الخصوصية، يرجى الاتصال بفريق حماية البيانات لدينا على miral_support@miralvis.com.']
            }
        ]
    },
    terms: {
        title: 'شروط الخدمة',
        lastUpdated: 'آخر تحديث: 15 يناير 2025',
        navPrivacy: 'سياسة الخصوصية ←',
        navTrust: 'الثقة والسلامة ←',
        sections: [
            {
                title: '1. نظرة عامة على الخدمة',
                paragraphs: ['Miral (المشار إليها فيما بعد بـ "المنصة") هي منصة ذكاء اصطناعي تدمج إنشاء الصور والفيديو والموسيقى. تحكم شروط الخدمة هذه (المشار إليها فيما بعد بـ "الشروط") شروط وقواعد استخدامك للمنصة.', 'باستخدام المنصة، فإنك توافق على الالتزام بهذه الشروط. إذا كنت لا توافق على هذه الشروط، يرجى عدم استخدام المنصة.']
            },
            {
                title: '2. تسجيل الحساب',
                paragraphs: ['يجب أن يكون عمرك 18 عاماً على الأقل لتسجيل حساب. تحتاج إلى تقديم معلومات تسجيل دقيقة وكاملة وأنت مسؤول عن الحفاظ على أمان حسابك.', 'أنت مسؤول عن جميع الأنشطة التي تتم من خلال حسابك. إذا اكتشفت أي استخدام غير مصرح به، يرجى إخطارنا فوراً.']
            },
            {
                title: '3. استخدام الخدمة',
                paragraphs: ['توفر المنصة خدمات إنشاء محتوى AI قائمة على الأرصدة. يمكن الحصول على الأرصدة من خلال الاشتراك أو الشراء لمرة واحدة. تستهلك نماذج وميزات AI المختلفة كميات مختلفة من الأرصدة.', 'توافق على عدم استخدام المنصة لأي أغراض غير قانونية أو ضارة أو منتهكة. يُحظر إنشاء محتوى غير قانوني أو إباحي أو عنيف أو منتهك للحقوق.']
            },
            {
                title: '4. الملكية الفكرية',
                paragraphs: ['تنتمي حقوق الملكية الفكرية للمحتوى الذي تنشئه عبر المنصة إليك، رهناً بشروط استخدام كل مزود نموذج AI.', 'العلامات التجارية والشعارات وتصميمات الواجهة ورمز البرمجيات للمنصة محمية بقوانين الملكية الفكرية ولا يجوز استخدامها بدون إذن.']
            },
            {
                title: '5. الدفع والاسترداد',
                paragraphs: ['جميع المدفوعات بالدولار الأمريكي. تُحاسب رسوم الاشتراك شهرياً أو سنوياً، حسب الخطة المختارة.', 'للمشتريات الأولى من الحزم لمرة واحدة أو الاشتراكات الأولى، يمكن طلب استرداد الأموال خلال 7 أيام تقويمية إذا كان استخدام الأرصدة أقل من 3%.']
            },
            {
                title: '6. إخلاء المسؤولية',
                paragraphs: ['توفر المنصة الخدمات "كما هي" ولا تقدم أي ضمانات صريحة أو ضمنية فيما يتعلق بتوفر الخدمات أو دقتها أو ملاءمتها.', 'قد يكون المحتوى المُنشأ بالذكاء الاصطناعي غير دقيق أو غير مثالي. يجب على المستخدمين تقييم مدى قابلية المحتوى المُنشأ للاستخدام بأنفسهم.']
            },
            {
                title: '7. حدود المسؤولية',
                paragraphs: ['بالحد الأقصى المسموح به قانوناً، لا تتحمل المنصة مسؤولية أي أضرار مباشرة أو غير مباشرة أو عرضية أو تبعية ناتجة عن استخدام أو عدم القدرة على استخدام الخدمات.', 'لا تتجاوز المسؤولية الكلية للمنصة إجمالي الرسوم التي دفعتها في آخر 12 شهراً.']
            },
            {
                title: '8. تعديل الشروط',
                paragraphs: ['نحتفظ بالحق في تعديل هذه الشروط في أي وقت. تصبح الشروط المعدلة سارية عند نشرها على هذه الصفحة.', 'الاستمرار في استخدام المنصة يشير إلى قبول الشروط المعدلة. سيتم إخطار التغييرات الجوهرية عبر البريد الإلكتروني أو إشعار المنصة.']
            },
            {
                title: '9. اتصل بنا',
                paragraphs: ['إذا كان لديك أي أسئلة حول هذه الشروط، يرجى الاتصال بنا على miral_support@miralvis.com.']
            }
        ]
    },
    trustSafety: {
        tag: '🛡️ الثقة والسلامة',
        title: 'أمن بياناتك هو أولويتنا القصوى',
        subtitle: 'تعرّف على كيفية حماية خصوصيتك وأمن بياناتك.',
        badges: [
            {
                icon: '🛡️',
                title: 'بدون تدريب AI',
                desc: 'المحتوى الذي ترفعه والأعمال التي تنشئها لا تُستخدم أبداً لتدريب أي نماذج ذكاء اصطناعي.'
            },
            {
                icon: '🔒',
                title: 'تشفير شامل',
                desc: 'جميع نقل البيانات يستخدم تشفير TLS 1.3، والبيانات المخزنة تستخدم تشفير AES-256.'
            },
            {
                icon: '✓',
                title: 'متوافق مع GDPR',
                desc: 'متوافق بالكامل مع متطلبات لائحة حماية البيانات العامة للاتحاد الأوروبي.'
            },
            {
                icon: '🗑️',
                title: 'تحكم ذاتي بالبيانات',
                desc: 'يمكنك تصدير أو حذف جميع بياناتك في أي وقت، بما في ذلك حذف الحساب.'
            }
        ],
        sections: [
            {
                title: 'شفافية معالجة البيانات',
                paragraphs: ['نحن شفافون تماماً بشأن كيفية تعاملنا مع البيانات. الصور والفيديوهات التي ترفعها تُستخدم فقط لإنشاء المحتوى الذي تطلبه ويتم حذفها من الخوادم خلال 24 ساعة بعد المعالجة.', 'يتم تخزين المحتوى المُنشأ في حسابك، ويمكنك تحميله أو حذفه في أي وقت. لا نشارك محتواك بدون موافقتك.']
            },
            {
                title: 'بنية تحتية آمنة',
                paragraphs: ['تم نشر خدماتنا على بنية تحتية سحابية رائدة عالمياً مع حماية أمنية متعددة الطبقات. جميع الخوادم تقع في مراكز بيانات معتمدة من SOC 2 و ISO 27001.', 'نجري تدقيقات أمنية واختبارات اختراق منتظمة لضمان أمان النظام. جميع الموظفين يتلقون تدريباً أمنياً صارماً.']
            },
            {
                title: 'سلامة المحتوى',
                paragraphs: ['ننشر أنظمة سلامة محتوى متقدمة تكشف تلقائياً وتحظر إنشاء المحتوى الضار. يشمل ذلك على سبيل المثال لا الحصر المحتوى العنيف والإباحي ومنتهك الحقوق.', 'إذا اكتشفت أي محتوى مخالف، يرجى الإبلاغ عنه على abuse@miral.org.']
            },
            {
                title: 'التوافق والشهادات',
                paragraphs: ['نلتزم بلوائح حماية البيانات الرئيسية عالمياً، بما في ذلك GDPR (الاتحاد الأوروبي) و CCPA (كاليفورنيا) و LGPD (البرازيل).', 'معالجة المدفوعات لدينا متوافقة مع معايير PCI DSS، مما يضمن أمان معلومات الدفع الخاصة بك.']
            }
        ],
        ctaTitle: 'مخاوف أمنية؟',
        ctaDesc: 'فريق الأمن لدينا جاهز للإجابة على أسئلتك',
        ctaButton: 'اتصل بفريق الأمن',
        navTerms: 'شروط الخدمة ←',
        navPrivacy: 'سياسة الخصوصية ←'
    },
    gallery: {
        tag: 'سجل الإبداع',
        title: 'إبداعاتي',
        subtitle: 'عرض جميع سجل إنشاءاتك بالذكاء الاصطناعي.',
        loginRequired: 'يرجى تسجيل الدخول لعرض سجل إنشاءاتك',
        empty: 'لا توجد إبداعات بعد',
        loadMore: 'تحميل المزيد',
        filters: {
            all: 'الكل',
            pending: 'جاري المعالجة',
            finish: 'مكتمل',
            failed: 'فشل'
        },
        usePrompt: 'إنشاء بهذا الوصف',
        download: 'تحميل',
        status: {
            pending: 'جاري المعالجة',
            finish: 'مكتمل',
            failed: 'فشل'
        }
    },
    inspiration: {
        title: 'الإلهام',
        subtitle: 'شاهد ما يبدعه المبدعون باستخدام Miral — من الصور فائقة الواقعية إلى الفيديوهات السينمائية، الإلهام بين يديك.',
        filters: {
            all: 'الكل',
            image: 'صور',
            video: 'فيديو',
            portrait: 'صور شخصية',
            landscape: 'مناظر طبيعية',
            fantasy: 'خيال',
            anime: 'أنمي'
        }
    },
    profile: {
        joinTime: 'تاريخ الانضمام',
        tabs: {
            account: 'الحساب',
            billing: 'الفواتير',
            privacy: 'البيانات والخصوصية'
        },
        balance: {
            title: 'نظرة عامة على الرصيد',
            available: 'الأرصدة المتاحة'
        },
        subscription: {
            currentPlan: 'الخطة الحالية',
            status: 'الحالة',
            activated: 'مفعّل',
            cancelled: 'يُلغى بنهاية الفترة الحالية',
            pending: 'جاري المعالجة',
            failed: 'فشل الدفع',
            expiryDate: 'صالح حتى',
            permanent: 'دائم',
            upgradePlan: 'ترقية أو تغيير الخطة',
            cancelPlan: 'إلغاء الاشتراك',
            cancelNote: 'يبقى اشتراكك نشطاً حتى نهاية فترة الفوترة الحالية',
            cancelWarning: 'سيتم إلغاء اشتراكك. يمكنك الاستمرار في استخدام جميع الميزات حتى',
            restorePlan: 'استئناف الاشتراك'
        },
        upgrade: {
            title: 'ترقية',
            desc: 'احصل على وصول غير محدود ومزايا حصرية',
            btn: 'عرض الخطط'
        },
        billing: {
            title: 'سجل المدفوعات',
            subtitle: 'عرض سجلات مدفوعاتك وتحميل الفواتير',
            empty: 'لا توجد سجلات فوترة بعد',
            creditsPack: 'حزمة أرصدة',
            oneTime: 'لمرة واحدة',
            monthly: 'شهري',
            yearly: 'سنوي',
            refresh: 'تحديث',
            plan: 'الخطة',
            date: 'التاريخ',
            amount: 'المبلغ',
            invoice: 'الفاتورة',
            download: 'تحميل',
            invoiceModal: {
                title: 'تفاصيل الفاتورة',
                orderInfo: 'معلومات الطلب',
                invoiceInfo: 'معلومات الفاتورة',
                plan: 'الخطة',
                date: 'تاريخ الدفع',
                amount: 'المبلغ',
                paymentId: 'رقم الطلب',
                close: 'إغلاق',
                download: 'تحميل الفاتورة',
                fullName: 'الاسم الكامل',
                fullNamePlaceholder: 'أدخل اسمك الكامل',
                email: 'البريد الإلكتروني',
                emailPlaceholder: 'أدخل بريدك الإلكتروني',
                company: 'الشركة',
                companyPlaceholder: 'الاسم القانوني للشركة',
                taxId: 'الرقم الضريبي',
                taxIdPlaceholder: 'أدخل الرقم الضريبي',
                addressLine1: 'العنوان - السطر 1',
                addressLine1Placeholder: 'عنوان الشارع',
                addressLine2: 'العنوان - السطر 2',
                addressLine2Placeholder: 'شقة، جناح، إلخ (اختياري)',
                city: 'المدينة',
                cityPlaceholder: 'المدينة',
                province: 'المحافظة',
                provincePlaceholder: 'المحافظة',
                postalCode: 'الرمز البريدي',
                postalCodePlaceholder: 'الرمز البريدي',
                country: 'البلد',
                countryPlaceholder: 'البلد',
                invoiceRemarks: 'ملاحظات',
                invoiceRemarksPlaceholder: 'ملاحظات الفاتورة',
                optional: 'اختياري',
                required: 'هذا الحقل مطلوب'
            }
        },
        privacy: {
            title: 'إعدادات الخصوصية',
            cardTitle: 'بياناتك محمية',
            cardSubtitle: 'التزامنا بخصوصية وأمن بياناتك',
            item1: 'لا تُستخدم بياناتك أبداً لتدريب نماذج الذكاء الاصطناعي',
            item2: 'نقل وتخزين البيانات مشفر بالكامل',
            item3: 'يتم حذف الأعمال المُنشأة تلقائياً بعد انتهاء فترة التخزين',
            item4: 'بدون حلقات تغذية راجعة، بدون استخدام ثانوي للبيانات المشتقة',
            item5: 'التزام صارم بلوائح حماية البيانات'
        },
        support: {
            title: 'تحتاج مساعدة؟',
            desc: 'فريق الدعم لدينا هنا لمساعدتك',
            btn: 'اتصل بالدعم',
            note: 'miral_support@miralvis.com · الرد خلال 24 ساعة'
        }
    },
    payment: {
        success: {
            title: 'تمت عملية الدفع بنجاح',
            message: 'شكراً لشرائك! تمت معالجة طلبك بنجاح وتمت إضافة الأرصدة إلى حسابك.',
            goHome: 'العودة للرئيسية',
            viewProfile: 'عرض الملف الشخصي'
        },
        cancel: {
            title: 'تم إلغاء الدفع',
            message: 'تم إلغاء دفعتك. إذا كان لديك أي أسئلة، لا تتردد في الاتصال بفريق الدعم لدينا.',
            tryAgain: 'حاول مرة أخرى',
            goHome: 'الذهاب للرئيسية'
        }
    },
    seo: {
        default: {
            title: 'Miral - مولّد صور وفيديو وموسيقى بالذكاء الاصطناعي',
            description: 'Miral منصة إنشاء بالذكاء الاصطناعي شاملة تدعم أفضل نماذج AI مثل Seedream 4 و Midjourney و GPT Image و Veo 3 و Sora 2. أنشئ صوراً وفيديوهات وموسيقى مذهلة بسهولة.',
            keywords: 'مولّد صور AI، مولّد فيديو AI، مولّد موسيقى AI، نص إلى صورة، نص إلى فيديو، Seedream، Midjourney، Veo، Sora، Miral'
        },
        home: {
            title: 'Miral: مولد الصور والفيديو والموسيقى بالذكاء الاصطناعي',
            description: 'أنشئ صوراً وفيديوهات وموسيقى عالية الجودة على Miral باستخدام نماذج رائدة مثل Seedream 5 وMidjourney وVeo 3.1 وSora 2 وغيرها، ضمن منصة واحدة سهلة الاستخدام.'
        },
        pricing: {
            title: 'الأسعار - منصة إنشاء Miral AI',
            description: 'تقدم Miral خطط أسعار مرنة لجميع احتياجاتك الإبداعية. اشترِ أرصدة، ادفع حسب الاستخدام، بدون اشتراك مطلوب.'
        },
        profile: {
            title: 'الملف الشخصي - Miral',
            description: 'إدارة حساب Miral الخاص بك، عرض سجل الطلبات وسجل الإنشاءات.'
        },
        models: {
            title: 'نماذج AI - Miral',
            description: 'استكشف أفضل نماذج AI على منصة Miral، بما في ذلك نماذج إنشاء الصور والفيديو والموسيقى.',
            wan25: {
                title: 'Wan 2.5 - نموذج فيديو AI قوي',
                description: 'يقدم Wan 2.5 إنشاء فيديو AI من المستوى التالي. أنشئ فيديوهات واقعية وسلسة بحركة وتفاصيل متقدمة، مثالي للمبدعين والشركات.'
            },
            wan26: {
                title: 'Wan 2.6 - مولّد فيديو AI محسّن',
                description: 'ارتقِ بإنشاء الفيديو مع Wan 2.6. ينشئ هذا النموذج المتقدم فيديوهات فائقة الواقعية بحركة وتفاصيل وسرعة محسّنة للمحتوى الاحترافي.'
            },
            wan22: {
                title: 'Wan 2.2 - مولّد فيديو AI سريع',
                description: 'Wan 2.2 نموذج فيديو AI سريع وموثوق. أنشئ فيديوهات عالية الجودة بسرعة، مثالي للمبدعين الذين يحتاجون إنتاج محتوى احترافي سريع.'
            },
            wanAnimate: {
                title: 'Wan Animate - تحريك الشخصيات - Miral',
                description: 'حرك الشخصيات بصورة مرجعية وفيديو حركة عبر Alibaba Wan 2.2 Animate.'
            },
            veo30: {
                title: 'Veo 3.0 - نموذج فيديو AI رائد',
                description: 'Veo 3.0 مولّد فيديو AI من الدرجة الأولى. أنشئ فيديوهات واقعية وسينمائية بتقنية AI متقدمة، مثالي لإنشاء محتوى احترافي وتسويقي.'
            },
            veo31: {
                title: 'Veo 3.1 - إنشاء فيديو AI متقدم',
                description: 'Veo 3.1 نموذج فيديو AI رائد لإنشاء فيديوهات مذهلة وواقعية. أنشئ مقاطع سينمائية ورسوم متحركة ومحتوى بجودة وسرعة لا مثيل لهما.'
            },
            kling26: {
                title: 'Kling 2.6 - نموذج فيديو AI متميز',
                description: 'يحيي Kling 2.6 إنشاء فيديو AI احترافي. أنشئ فيديوهات عالية الجودة وسلسة بتقنية AI متقدمة للمبدعين والمسوّقين والشركات.'
            },
            kling3: {
                title: 'Kling 3 - مولّد فيديو AI - Miral',
                description: 'إنشاء فيديوهات AI عالية الجودة بنموذج Kling 3.'
            },
            kling25: {
                title: 'Kling 2.5 - نموذج فيديو AI موثوق',
                description: 'يقدم Kling 2.5 إنشاء فيديو AI قوي للمبدعين. أنشئ فيديوهات عالية الجودة بحركة سلسة وتفاصيل دقيقة، مثالي للمحتوى والتسويق.'
            },
            seedance: {
                title: 'Seedance AI - مولّد فيديو AI متقدم',
                description: 'إنشاء فيديوهات AI عالية الجودة مع Seedance AI. أنشئ مقاطع ورسوم متحركة ومحتوى سينمائي مذهل بنماذج AI متطورة لنتائج سريعة واحترافية.'
            },
            sora2: {
                title: 'مولّد فيديو Sora 2 بالذكاء الاصطناعي من النص والصورة | Miral',
                description: 'أنشئ فيديوهات Sora 2 من النص أو الصور على Miral. جرّبه بأرصدة مجانية واختر 4–12 ثانية ودقة 720p/1080p ونسبة 16:9/9:16.'
            },
            hailuo23: {
                title: 'Hailuo 2.3 - مولّد فيديو AI ذكي',
                description: 'يقدم Hailuo 2.3 إنشاء فيديو AI ذكي. أنشئ فيديوهات عالية الجودة وإبداعية بتقنية AI متقدمة لصناع المحتوى والشركات.'
            },
            viduq3pro: {
                title: 'Vidu Q3 Pro - مولّد فيديو AI - Miral',
                description: 'إنشاء نص إلى فيديو وصورة إلى فيديو مع Vidu Q3 Pro، دقات وأطوال متعددة.'
            },
            runway: {
                title: 'Runway - منصة إنشاء فيديو AI',
                description: 'Runway منصة فيديو AI رائدة للمبدعين. حرر وأنشئ وحسّن الفيديوهات بأدوات AI قوية، مثالية لإنتاج محتوى احترافي.'
            },
            nanobanana: {
                title: 'Nano Banana - مولّد صور AI - Miral',
                description: 'إنشاء صور إبداعية بسرعة بنموذج Nano Banana.'
            },
            seedream4: {
                title: 'Seedream 4 - مولّد صور AI',
                description: 'أنشئ صور AI مذهلة وعالية الدقة مع Seedream 4. أنشئ فناً واقعياً ورسوماً توضيحية وتصاميم بتقنية AI متقدمة للعمل الإبداعي الاحترافي.'
            },
            seedream5: {
                title: 'Seedream 5 - مولّد صور AI من ByteDance - Miral',
                description: 'إنشاء صور AI عالية الجودة بنموذج ByteDance Seedream 5.'
            },
            midjourney: {
                title: 'Midjourney - مولّد فن AI',
                description: 'Midjourney مولّد فن AI رائد. أنشئ صوراً وفناً وتصاميم مذهلة من أوصاف نصية، مثالي للفنانين والمصممين وصناع المحتوى.'
            },
            gptimage1: {
                title: 'GPT-Image-1 - نموذج صور AI من OpenAI',
                description: 'ينشئ GPT-Image-1 من OpenAI صور AI عالية الجودة من النص. أنشئ صوراً واقعية وإبداعية للتصميم والتسويق وإنشاء المحتوى.'
            },
            gptimage15: {
                title: 'GPT Image 1.5 - مولّد صور AI من OpenAI - Miral',
                description: 'إنشاء صور AI عالية الجودة بنموذج OpenAI GPT Image 1.5.'
            },
            fluxpro11ultra: {
                title: 'Flux Pro 1.1 Ultra - مولّد صور AI متميز',
                description: 'يقدم Flux Pro 1.1 Ultra إنشاء صور AI فائقة الجودة. أنشئ صوراً واقعية ومفصلة بتقنية AI متقدمة للتصميم والفن الاحترافي.'
            },
            fluxschnell: {
                title: 'Flux Schnell - مولّد صور AI سريع',
                description: 'Flux Schnell مولّد صور AI سريع كالبرق. أنشئ صوراً عالية الجودة بسرعة، مثالي للمبدعين الذين يحتاجون محتوى بصرياً احترافياً وسريعاً.'
            },
            flux2: {
                title: 'FLUX.2 - مولّد صور AI - Miral',
                description: 'إنشاء صور AI بجودة احترافية بنموذج FLUX.2 — 5 متغيرات للسرعة والجودة والتحكم.'
            },
            zimageturbo: {
                title: 'Z Image Turbo - مولّد صور AI - Miral',
                description: 'إنشاء صور عالية الدقة بنموذج Z Image Turbo.'
            }
        },
        tools: {
            title: 'أدوات صور AI - Miral',
            description: 'توفر Miral أدوات معالجة صور AI متنوعة بما في ذلك إزالة العلامات المائية وإزالة الخلفية وتحسين الصور والمزيد.',
            watermarkRemover: {
                title: 'إزالة العلامات المائية من الصور بالذكاء الاصطناعي | Miral',
                description: 'أزل العلامات المائية والشعارات والتواريخ والنصوص من الصور عبر الإنترنت بالذكاء الاصطناعي، مع الحفاظ على التفاصيل وتصدير نتائج نظيفة بصيغة JPG أو PNG أو WebP.'
            },
            backgroundRemover: {
                title: 'إزالة خلفية الصور مجاناً بالذكاء الاصطناعي | Miral',
                description: 'أزل خلفيات الصور مجاناً بالذكاء الاصطناعي. قص الصور الشخصية والمنتجات مع الحفاظ على الشعر والحواف وأنشئ PNG شفافاً من JPG أو PNG أو WebP.'
            },
            imageEraser: {
                title: 'أداة مسح الصور بالذكاء الاصطناعي - إزالة العناصر من الصور',
                description: 'امسح العناصر والأشخاص والعلامات المائية والنصوص غير المرغوب فيها من الصور بالذكاء الاصطناعي. مرر الفرشاة فوق المنطقة وستقوم الذكاء الاصطناعي بإزالتها بسلاسة وملء الفراغ بمحتوى طبيعي. مثالي لتنظيف الصور.'
            },
            objectRemover: {
                title: 'إزالة العناصر بالذكاء الاصطناعي - أزل العناصر من الصور',
                description: 'أزل العناصر غير المرغوب فيها من الصور بالذكاء الاصطناعي. مرر الفرشاة فوق العنصر وستقوم الذكاء الاصطناعي بإزالته بسلاسة وملء المنطقة بمحتوى طبيعي. مثالي لتنظيف صورك.'
            },
            aiPersonRemover: {
                title: 'إزالة الأشخاص بالذكاء الاصطناعي - أزل الأشخاص من الصور',
                description: 'أزل الأشخاص من الصور بالذكاء الاصطناعي. مرر الفرشاة فوق أي شخص وستقوم الذكاء الاصطناعي بإزالته بسلاسة وملء المنطقة بمحتوى طبيعي. مثالي لإزالة المارة والغرباء من صورك.'
            },
            'whiteBackground': {
                title: 'خلفية بيضاء AI - استبدال خلفية الصورة بالأبيض',
                description: 'استبدال خلفيات الصور بالأبيض النقي تلقائياً باستخدام الذكاء الاصطناعي. مثالي لصور المنتجات التجارية وصور الهوية وصور الكتالوجات.'
            },
            'blueBackground': {
                title: 'خلفية زرقاء AI - استبدال خلفية الصورة بالأزرق',
                description: 'استبدال خلفيات الصور بالأزرق النقي تلقائياً باستخدام الذكاء الاصطناعي. مثالي لصور جوازات السفر وصور الهوية والوثائق الرسمية.'
            },
            faceSwap: {
                title: 'تبديل الوجوه بالذكاء الاصطناعي - تبديل الوجوه في الصور',
                description: 'تبديل الوجوه في الصور بالذكاء الاصطناعي. ارفع صورة مستهدفة ووجه مصدر لدمج الوجوه بسلاسة بنتائج واقعية وطبيعية.'
            },
            imageEnhancer: {
                title: 'محسّن الصور بالذكاء الاصطناعي - تحسين ورفع دقة الصور',
                description: 'تحسين ورفع دقة الصور بالذكاء الاصطناعي. شحذ التفاصيل وإصلاح الضبابية ورفع الدقة واستعادة الصور القديمة لنتائج عالية الجودة والاحترافية.'
            },
            docCropEnhance: {
                title: 'قص المستندات وتصحيحها بالذكاء الاصطناعي | Miral',
                description: 'اقصص وصحح صور المستندات والاختبارات والواجبات والكتب عبر الإنترنت. عالج الميل والمنظور وانحناء الصفحات والظلال للحصول على ملفات مسح واضحة وحادة.'
            },
            handwrittenErase: {
                title: 'إزالة خط اليد من الاختبارات بالذكاء الاصطناعي | Miral',
                description: 'أزل الإجابات المكتوبة بخط اليد من الاختبارات والواجبات ودفاتر التمارين بالذكاء الاصطناعي مع الحفاظ على النص المطبوع. يدعم التدوير والقص وتصحيح الانحناء.'
            }
        },
        music: {
            title: 'مولّد موسيقى AI - Miral',
            description: 'إنشاء موسيقى فريدة من الأوصاف النصية باستخدام مولّد موسيقى AI من Miral.'
        },
        inspiration: {
            title: 'الإلهام - Miral',
            description: 'تصفح الأعمال المميزة من مجتمع Miral واحصل على إلهام إنشاء AI.'
        },
        gallery: {
            title: 'معرضي - Miral',
            description: 'عرض وإدارة جميع إنشاءاتك على منصة Miral.'
        },
        faq: {
            title: 'الأسئلة الشائعة - Miral',
            description: 'الأسئلة المتكررة حول منصة Miral لمساعدتك على البدء بالإنشاء بالذكاء الاصطناعي.'
        },
        about: {
            title: 'About Us - Miral',
            description: 'Learn about the Miral AI platform for image, video, and music creation.'
        },
        contact: {
            title: 'Contact Us - Miral',
            description: 'Contact Miral support for help and feedback.'
        },
        terms: {
            title: 'شروط الخدمة - Miral',
            description: 'شروط خدمة واتفاقية المستخدم لمنصة Miral.'
        },
        privacy: {
            title: 'سياسة الخصوصية - Miral',
            description: 'سياسة الخصوصية وبيان حماية البيانات لمنصة Miral.'
        },
        trustSafety: {
            title: 'الثقة والسلامة - Miral',
            description: 'سياسات الثقة والسلامة لمنصة Miral.'
        },
    imageModels: {
            title: "نماذج الصور بالذكاء الاصطناعي - ميرال",
            description: "استكشف أفضل نماذج الصور المدعومة بالذكاء الاصطناعي على منصة ميرال، وقم بإنشاء صور مذهلة من خلال نصوص توضيحية.",
            relatedModelsTitle: "استكشف المزيد من نماذج الصور المدعومة بالذكاء الاصطناعي",
            demoPrompt: "مطالبة نصية",
            demoOutput: "صورة مُولّدة",
            demoPlaceholder: "صورة نموذجية - قريباً",
            promptLabel: "إنشاء باستخدام",
            usePrompt: "استخدم هذه المطالبة →",
            imagePlaceholder: "مثال على صورة ذكاء اصطناعي",
            replaceImageHint: "تم إنشاؤها من التعليمات المعروضة بجانب هذه الصورة",
            flux1: {
                title: "مولد الصور FLUX.1 بتقنية الذكاء الاصطناعي مجاناً عبر الإنترنت | ميرال",
                description: "أنشئ صورًا عالية الجودة بتقنية الذكاء الاصطناعي عبر الإنترنت باستخدام FLUX.1 عبر Flux Pro 1.1 Ultra أو Flux Schnell. استكشف تسع نسب عرض إلى ارتفاع، وأنماطًا بصرية، ورصيدًا مجانيًا.",
                heroHeadline: "مولد صور FLUX.1 بتقنية الذكاء الاصطناعي",
                heroIntro: "استخدم مولد الصور FLUX.1 AI من Black Forest Labs مجانًا على Miral AI. سجّل للحصول على رصيد مجاني واختر بين جودة مخرجات Flux Pro 1.1 Ultra العالية وسرعة إنشاء الصور متعددة الأنماط باستخدام Flux Schnell.",
                eyebrow: "مختبرات الغابة السوداء · FLUX.1",
                sectionKicker: "FLUX.1",
                ctaTag: "FLUX.1 · ميرال",
                badges: ["تحويل النص إلى صورة", "نسبة العرض إلى الارتفاع 9 نسب العرض", "احترافي وسريع", "فن فوتوغرافي / رقمي / أنمي"],
                previewLabel: "Flux Pro 1.1 Ultra",
                previewMeta: ["1:1", "16:9", "9:16", "9 نسب"],
                previewTitle: "اختر بين الجودة العالية والاستكشاف الإبداعي السريع",
                previewDesc: "استخدم Pro 1.1 Ultra للحصول على صور مفصلة أو Schnell لاستكشاف اتجاهات التصوير الفوتوغرافي والفن الرقمي والأنمي بسرعة.",
                keyFeaturesTitle: "أنشئ صورًا عالية الجودة باستخدام مولد النصوص إلى صور FLUX.1",
                keyFeaturesIntro: "استكشف ميزات Flux Pro 1.1 Ultra و Flux Schnell لفهم سريع وسرعة إخراج وأنماط مرئية ونسب عرض مرنة.",
                exploreTitle: "استكشف المزيد من نماذج الصور المدعومة بالذكاء الاصطناعي",
                mainFeaturesTitle: "الميزات الرئيسية لـ FLUX.1",
                generatedImageLabel: "صورة مُولّدة",
                versionLabel: "الإصدار",
                featureLabel: "الميزات الرئيسية",
                useCaseLabel: "الأفضل لـ",
                controlsTitle: "اختر النموذج والنسبة والأسلوب البصري المناسب",
                controlsIntro: "استخدم Flux Pro 1.1 Ultra للحصول على صور نهائية مصقولة أو Flux Schnell للاستكشاف الأسرع، ثم قم بمطابقة نسبة العرض إلى الارتفاع والنمط مع القناة المقصودة.",
                galleryTitle: "المزيد من أمثلة صور FLUX.1",
                discussionTitle: "أسئلة اختيار FLUX.1 الشائعة",
                communityTitle: "طرق شائعة للإنشاء باستخدام FLUX.1",
                tutorialPrompt: "مكتبة هادئة داخل بيت زجاجي بجانب البحر عند شروق الشمس، مصابيح قراءة دافئة، أرفف من خشب البلوط الفاتح، انعكاسات ناعمة على الأرض، صور فوتوغرافية داخلية واقعية.",
                qualityBenefits: [
                    "حسّن جودة المواد والإضاءة والعمق المكاني.",
                    "اتبع التعليمات التفصيلية التي تجمع بين الموضوع والتكوين والكاميرا والأسلوب.",
                    "استكشف توجيهات التصوير الفوتوغرافي والفن الرقمي والأنمي من خلال تعليمات نصية واضحة."
                ],
                features: [
                    { name: "تحويل النصوص إلى صور بجودة عالية باستخدام FLUX.1", short: "حوّل التوجيهات المكتوبة إلى صور مرئية احترافية ومفصلة.", desc: "يُعدّ برنامج Flux Pro 1.1 Ultra مناسبًا للأعمال التي تتطلب دقة عالية في تفاصيل الصورة، والمواد المستخدمة، والإضاءة، واللمسة النهائية. ويساعد وصف الموضوع، والتكوين، والكاميرا، والأسلوب بوضوح على توجيه الصورة نحو مسار مشروعك.", demo: { type: 'table', rows: [
                        { prompt: "صورة خارجية لفندق صحراوي فاخر في وقت الغروب، جدران من الطين المدكوك، توهج دافئ من النوافذ، أعشاب محلية، ظلال طويلة، تصوير معماري واقعي.", image: require('@/assets/images/flux1/b9d1e267-bb35-4d5c-a196-fae49460749d.webp') },
                        { prompt: "تصوير فوتوغرافي تحريري لأطباق الرافيولي المصنوعة يدوياً على طبق أسود غير لامع، مع زيت الريحان، ومنديل من الكتان، وإضاءة نافذة موجهة، وعمق مجال ضحل.", image: require('@/assets/images/flux1/2ab9dde4-0420-4594-b875-a8465741b767.webp') }
                    ] } },
                    { name: "إنشاء سريع باستخدام Flux Schnell", short: "أنشئ مسودات سريعة، واختبر المُحفزات، واستكشف الأفكار بسرعة.", desc: "يُعدّ Flux Schnell خيارًا مثاليًا لسير العمل الذي يتطلب اختبارًا سريعًا للتكوين أو الأسلوب أو المفهوم. أنشئ مسودة، راجع التوجيه، ثم حسّن التعليمات لتكرارها مرة أخرى.", prompt: "مفهوم جناح عرض تجاري معياري من الورق المقوى لشركة ناشئة صديقة للبيئة، منصات عرض منتجات بسيطة، أسطح من الورق المعاد تدويره، إضاءة عرض ساطعة، تصميم نظيف.", image: require('@/assets/images/flux1/b8ffe8cb-1d2f-4bfc-897f-1068861614f9.webp') },
                    { name: "تسع نسب عرض للصور", short: "يدعم تنسيقات العرض العريض جدًا، والأفقي، والمربع، والعمودي، والطويل.", desc: "يدعم كل من Flux Pro 1.1 Ultra و Flux Schnell نسب العرض 21:9 و 16:9 و 4:3 و 3:2 و 1:1 و 2:3 و 3:4 و 9:16 و 9:21 للبنرات وصور المنتجات ومحتوى وسائل التواصل الاجتماعي والملصقات والصور المرئية للهواتف المحمولة.", prompt: "مرصد جبلي بانورامي بنسبة عرض إلى ارتفاع 21:9 فوق بحر من السحب، منصة مشاهدة زجاجية، ضوء الصباح الباكر، متسلقون صغار الحجم للمقارنة، لوحة سينمائية غير لامعة.", image: require('@/assets/images/flux1/a5efd8d2-571d-406d-9a01-f30581d4ea3b.webp') },
                    { name: "أنماط بصرية متعددة في Schnell", short: "اختر: تصوير فوتوغرافي، فن رقمي، أو أنمي.", desc: "يقدم Flux Schnell توجيهات بأسلوب السيارات والتصوير الفوتوغرافي والفن الرقمي والأنمي، مما يسهل التبديل بين الصور الواقعية والرسوم التوضيحية والأنمي دون تغيير النماذج.", demo: { type: 'table', rows: [
                        { prompt: "أسلوب التصوير: ميكانيكي دراجات يقوم بضبط دراجة سباق كلاسيكية في مرآب مضاء بأشعة الشمس، أيادٍ ملطخة بالشحم، انعكاسات واقعية للكروم.", image: require('@/assets/images/flux1/2b870b40-a436-42b9-980f-538e303cdfce.webp') },
                        { prompt: "أسلوب الأنمي: مقهى قطط مريح داخل قطار معلق، وسحب غروب الشمس بألوان الباستيل خارج النوافذ، وشخصيات معبرة، ورسومات خطية نظيفة.", image: require('@/assets/images/flux1/faded76c-4da1-49bb-98dc-10b8276f7da8.webp') }
                    ] } },
                    { name: "استخدامات إبداعية مرنة", short: "أنشئ صورًا للمنتجات، والتسويق، والصور الشخصية، والمفاهيم، ومحتوى وسائل التواصل الاجتماعي.", desc: "تدعم عائلة FLUX.1 صور المنتجات والعلامات التجارية المصقولة بالإضافة إلى مفاهيم الحملات السريعة والصور الشخصية وتصميمات البيئة ونسب العرض إلى الارتفاع الخاصة بالمنصة.", prompt: "صورة إطلاق حذاء رياضي مستدام بنسيج معاد تدويره، وتفاصيل رباط عائمة، وخلفية متدرجة باللون الأخضر الطحلبي، ومساحة فارغة جريئة لنص الإعلان على وسائل التواصل الاجتماعي.", image: require('@/assets/images/flux1/0dfa0b4b-7722-40f4-9bc0-7bbf9bb1c000.webp') }
                ],
                showcaseKicker: "أمثلة توضيحية",
                showcaseTitle: "أمثلة على أوامر FLUX.1 للحصول على صور ذكاء اصطناعي أفضل",
                showcaseIntro: "استخدم هذه التوجيهات الخاصة بـ FLUX.1 كنقطة انطلاق. صف بوضوح الموضوع، والتكوين، والإضاءة، والكاميرا، والمواد، ولوحة الألوان، والأسلوب البصري.",
                variantsKicker: "دليل النموذج",
                variantsTitle: "مقارنة بين Flux Pro 1.1 Ultra وFlux Schnell",
                variantsIntro: "اختر طراز FLUX.1 بناءً على الجودة والسرعة والتحكم في الأسلوب الذي يحتاجه مشروعك.",
                variants: [
                    { name: "Flux Pro 1.1 Ultra", tag: "جودة عالية", desc: "مصمم خصيصًا لتحويل النصوص إلى صور بدقة وواقعية ووضوح، مع دعم تسع نسب عرض إلى ارتفاع.", bestFor: "الأفضل لتصوير المنتجات، وصور الحملات الإعلانية الرئيسية، والتصاميم النهائية المصقولة." },
                    { name: "Flux Schnell", tag: "سريع", desc: "مصمم للتكرار السريع مع تسع نسب عرض إلى ارتفاع وأنماط تلقائية، وتصويرية، وفنية رقمية، وأنمي.", bestFor: "الأفضل للمسودات، واختبار المُحفزات، ومحتوى وسائل التواصل الاجتماعي، والاستكشاف السريع." }
                ],
                useCasesKicker: "مصمم للاستخدام العملي",
                useCasesTitle: "حالات استخدام FLUX.1 الشائعة",
                useCases: [
                    { name: "FLUX.1 لتصوير المنتجات", desc: "أنشئ صورًا رئيسية للمنتجات، ومشاهد من الحياة اليومية، ومفاهيم بصرية للتجارة الإلكترونية." },
                    { name: "FLUX.1 للتسويق والإعلان", desc: "أنشئ إعلانات وسائل التواصل الاجتماعي، وبنرات الحملات، وصورًا تسويقية تحمل علامتك التجارية." },
                    { name: "FLUX.1 للصور الشخصية الواقعية", desc: "أنشئ صورًا شخصية احترافية بإضاءة وخلفيات وتكوينات مُتحكَّم بها." },
                    { name: "FLUX.1 للفن الرقمي", desc: "استخدم Schnell لاستكشاف اتجاهات الرسم، والخيال، والفن الرقمي بسرعة." },
                    { name: "FLUX.1 لصور الأنمي", desc: "استخدم نمط Schnell Anime للشخصيات ومشاهد الأنمي." },
                    { name: "FLUX.1 للفن المفاهيمي", desc: "استكشف البيئات السينمائية، ومشاهد الألعاب، والشخصيات، والعوالم المرئية." },
                    { name: "FLUX.1 لصور وسائل التواصل الاجتماعي", desc: "استخدم تسع نسب عرض إلى ارتفاع لمحتوى المنصات الأفقية والمربعة والعمودية." },
                    { name: "FLUX.1 للملصقات واللافتات", desc: "اختر نسبة عرض إلى ارتفاع مناسبة للأحداث، والعروض الترويجية، ومفاهيم تصميم صفحات الجوال." }
                ],
                howToKicker: "ثلاثة بسيطة الخطوات",
                howToTitle: "كيفية استخدام مولد الصور FLUX.1 AI عبر الإنترنت مجانًا",
                howToIntro: "سجل للحصول على رصيد مجاني واستخدم Flux Pro 1.1 Ultra أو Flux Schnell عبر الإنترنت على Miral.",
                howToSteps: [
                    { title: "أدخل نصًا تفصيليًا", desc: "صف الموضوع، والإعداد، والتكوين، والإضاءة، والكاميرا، والمواد، والألوان، والأسلوب المستهدف." },
                    { title: "اختر النموذج والنسبة", desc: "اختر Pro 1.1 Ultra للحصول على جودة مصقولة أو Schnell للاستكشاف السريع، ثم حدد نسبة العرض إلى الارتفاع ونمط Schnell." },
                    { title: "إنشاء وتحسين", desc: "قم بإنشاء الصورة، ومراجعتها وتنزيلها، أو قم بتعديل التعليمات أو النسبة أو النمط للحصول على نسخة أخرى." }
                ],
                howToCta: "استخدم مولد صور الذكاء الاصطناعي FLUX.1 مجانًا",
                faqTitle: "الأسئلة الشائعة حول FLUX.1",
                faqs: [
                    { q: "ما هو مولد الصور FLUX.1 المدعوم بالذكاء الاصطناعي؟", a: "FLUX.1 هي عائلة نماذج لتوليد الصور من شركة Black Forest Labs. على منصة Miral، استخدم Flux Pro 1.1 Ultra وFlux Schnell لتحويل النصوص إلى صور للمنتجات، والتسويق، والصور الشخصية، والأنمي، والفنون التصورية." },
                    { q: "هل يمكنني استخدام مولد الصور FLUX.1 AI مجانًا؟", a: "نعم. سجّل الآن لتحصل على رصيد مجاني وابدأ بإنشاء صور عالية الجودة باستخدام مولد الصور FLUX.1 المدعوم بالذكاء الاصطناعي فورًا. يتم استخدام الرصيد المخصص لإنشاء الصور." },
                    { q: "ما الفرق بين Flux Pro 1.1 Ultra و Flux Schnell؟", a: "يُعدّ برنامج Flux Pro 1.1 Ultra مناسبًا للصور النهائية المصقولة حيث تُعدّ التفاصيل واللمسة النهائية مهمة. أما برنامج Flux Schnell فهو مناسب للمسودات السريعة والاختبار الفوري واستكشاف أنماط متعددة، مع أنماط تلقائية وفوتوغرافية وفنية رقمية وأنمي." },
                    { q: "ما هي نسب أبعاد الصور التي يدعمها FLUX.1؟", a: "يدعم Flux Pro 1.1 Ultra و Flux Schnell على Miral نسب العرض 21:9 و 16:9 و 4:3 و 3:2 و 1:1 و 2:3 و 3:4 و 9:16 و 9:21، ليصبح المجموع تسع نسب عرض." },
                    { q: "ما الأنماط التي يدعمها Flux Schnell؟", a: "يدعم Flux Schnell كلاً من Auto و Photographic و Digital Art و Anime للمطابقة التلقائية والصور الواقعية والرسوم التوضيحية الرقمية و المرئيات الخاصة بالأنمي." },
                    { q: "كيف أستخدم مولد الصور FLUX.1 AI عبر الإنترنت؟", a: "أدخل نصًا، واختر Flux Pro 1.1 Ultra أو Flux Schnell، ثم حدد نسبة العرض إلى الارتفاع. مع Schnell، يمكنك أيضًا اختيار نمط مرئي قبل النقر على \"إنشاء\"." },
                    { q: "ما هي أفضل أمثلة أوامر FLUX.1؟", a: "تُقدّم إرشادات FLUX.1 الفعّالة وصفًا واضحًا للموضوع، والإعداد، والتكوين، والإضاءة، والكاميرا، والمواد، ولوحة الألوان، والأسلوب المستهدف. استخدم الأمثلة الموجودة في هذه الصفحة كنقطة انطلاق، وقم بتكييفها مع مشروعك." },
                    { q: "FLUX.1 مقابل FLUX.2: أيهما يجب أن أستخدم؟", a: "اختر FLUX.1 للحصول على مخرجات احترافية مع Flux Pro 1.1 Ultra أو لإنشاء أنماط متعددة بسرعة مع Flux Schnell. اختر صفحة FLUX.2 على Miral عندما تحتاج إلى إصدارات Klein وMax وPro وFlex." },
                    { q: "FLUX.1 مقابل Midjourney: أيهما يجب أن أستخدم؟", a: "يُعدّ برنامج FLUX.1 خيارًا مثاليًا لنسب العرض إلى الارتفاع الواضحة، وسير العمل السريع Schnell، أو مخرجات Pro 1.1 Ultra المصقولة. أما برنامج Midjourney فقد يناسب المستخدمين الذين يفضلون أساليبه الفنية، وسير العمل القائم على الصور المرجعية، والعملية الإبداعية." }
                ],
                ctaTitle: "استخدم FLUX.1 مجانًا على Miral!",
                ctaDesc: "سجّل الآن لتحصل على رصيد مجاني. اختر Flux Pro 1.1 Ultra أو Flux Schnell، وأنشئ صورًا بالنسب والأسلوب الذي يناسب مشروعك."
            },
            flux2: {
                title: "مولد الصور FLUX.2 بتقنية الذكاء الاصطناعي مجاناً عبر الإنترنت | ميرال",
                description: "أنشئ صورًا واقعية بتقنية الذكاء الاصطناعي عبر الإنترنت باستخدام FLUX.2. اختر خمسة نماذج مختلفة لصور المنتجات والملصقات والأعمال الفنية والصور التسويقية المصقولة.",
                heroHeadline: "مولد صور FLUX.2 بالذكاء الاصطناعي",
                heroIntro: "استخدم مولد الصور FLUX.2 AI من Black Forest Labs مجانًا على Miral AI. سجّل الآن لتحصل على رصيد مجاني، وابدأ فورًا بإنشاء صور واقعية عالية الجودة، وصور منتجات، وملصقات، ومواد تسويقية مرئية.",
                eyebrow: "مختبرات الغابة السوداء · FLUX.2",
                sectionKicker: "FLUX.2",
                ctaTag: "FLUX.2 · ميرال",
                badges: ["تحويل النص إلى صورة", "واقعية فوتوغرافية", "طباعة دقيقة", "نسب عرض متعددة"],
                previewLabel: "FLUX.2",
                previewMeta: ["1:1", "1024 × 1024", "PNG"],
                previewTitle: "من موجه دقيق إلى تصميم مرئي جاهز للإنتاج",
                previewDesc: "أنشئ صورًا تفصيلية للمنتجات، ومفاهيم الحملات الإعلانية، والصور الشخصية، والتصاميم الغنية بالنصوص في سير عمل واحد مبسط.",
                keyFeaturesTitle: "أنشئ صورًا احترافية باستخدام مولد تحويل النصوص إلى صور FLUX.2",
                keyFeaturesIntro: "استكشف الميزات الرئيسية لمولد الصور FLUX.2 AI للحصول على توجيهات دقيقة وتفاصيل مصقولة ومخرجات واقعية وتحكم بصري موثوق.",
                exploreTitle: "استكشف المزيد من نماذج الصور المدعومة بالذكاء الاصطناعي",
                mainFeaturesTitle: "الميزات الرئيسية لـ FLUX.2",
                generatedImageLabel: "صورة مُولّدة",
                versionLabel: "الإصدار",
                featureLabel: "الميزات الرئيسية",
                useCaseLabel: "الأفضل لـ",
                controlsTitle: "اختر إصدار FLUX.2 المناسب وإعدادات الإخراج",
                controlsIntro: "استخدم Klein للتكرار السريع، وMax للحصول على أعلى جودة نهائية، وPro لسير العمل الإنتاجي، أو Flex للتحكم في الطباعة والتفاصيل الدقيقة.",
                galleryTitle: "المزيد من أمثلة صور FLUX.2",
                discussionTitle: "أسئلة نموذج FLUX.2",
                communityTitle: "طرق شائعة للإبداع باستخدام FLUX.2",
                tutorialPrompt: "صورة إعلانية مميزة لزجاجة عطر زمردية شفافة على حجر جيري باهت، ضوء صباحي ناعم، انكسار زجاجي واقعي، طباعة راقية، مساحة سلبية واسعة.",
                qualityBenefits: [
                    "اتبع التعليمات التفصيلية مع تحكم أكبر في الموضوع والتكوين والإضاءة والأسلوب.",
                    "أنشئ نسيجًا واقعيًا، وعمقًا، وتفاصيل دقيقة لأعمال مرئية احترافية.",
                    "تعامل مع الملصقات الغنية بالنصوص، وملصقات المنتجات، ورسومات الحملات الإعلانية باستخدام طباعة أكثر وضوحًا."
                ],
                features: [
                    { name: "توليف صور عالي الجودة", short: "يوفر التزامًا فوريًا محسنًا وجودة صورة فائقة دون زيادة في زمن الاستجابة.", desc: "يُحسّن برنامج FLUX.2 بشكل كبير من سرعة المحاذاة الفورية، بل ويدعم المدخلات المطولة مثل النصوص التفصيلية ووصف المشاهد. ويضمن أن الصور المُولّدة تُقدّم دقة أعلى دون التأثير على السرعة، مما يقلل الحاجة إلى التعديلات المتكررة ويُمكّن المُبدعين من الوصول إلى النتيجة النهائية بشكل أسرع.", demo: { type: 'table', rows: [
                        { prompt: "منظر طبيعي خلاب بألوان نابضة بالحياة وتفاصيل دقيقة، يعرض غروب الشمس فوق سلسلة جبال.",image: require('@/assets/images/flux2/1a2627bd-61e0-406a-9308-19f2883d004e.webp') },
                        { prompt: "فن تجريدي للترجمة بين اللغات الوظيفية واللغات منخفضة المستوى." ,image: require('@/assets/images/flux2/sample.webp')},
                        { prompt: "صورة شخصية من عالم الأنمي/الرسوم المتحركة، مفصلة ومتقنة الصنع، لكنها تبدو وكأنها من صنع الإنسان." ,image: require('@/assets/images/flux2/57047990-2e26-4b44-bacf-f10bca5ee70d.webp')}
                    ] } },
                    { name: "تفاصيل فائقة وواقعية", short: "يُنتج نسيجًا وإضاءة وعمقًا واقعيًا للحصول على صور بجودة الاستوديو.", desc: "يلتقط برنامج FLUX.2 تفاصيل دقيقة وإضاءة واقعية وعمقًا طبيعيًا، مما يجعل الصور الناتجة تبدو وكأنها صور فوتوغرافية حقيقية. وهذا ما يجعله خيارًا مثاليًا لتصوير المنتجات والصور الشخصية والمشاهد السينمائية حيث تُعدّ المصداقية أمرًا بالغ الأهمية.", prompt: "صورة فوتوغرافية للمنتج في الاستوديو لساعة ميكانيكية فضية على خلفية داكنة، بإضاءة جانبية ناعمة، وملمس معدني مصقول واقعي، وعمق مجال ضحل، وانعكاسات خفيفة، وتكوين تحريري متميز." ,image: require('@/assets/images/flux2/b1d818f0-ff1f-4612-b586-62f75e14466c.webp') },
                    { name: "التزام قوي بالطلبات", short: "يتبع التعليمات المعقدة بدقة، بما في ذلك المواضيع والأساليب والتكوينات المحددة.", desc: "يُفسّر برنامج FLUX.2 التعليمات متعددة الأجزاء والمتداخلة بدقةٍ مذهلة، حيث يتعامل مع مواضيع محددة، وأنماط فنية، ولوحات ألوان، وتعليمات تركيبية في عملية واحدة. وهذا يمنح المبدعين مزيدًا من التحكم ويقلل من الحاجة إلى إعادة المحاولة عند وصف ما يريدونه بدقة.", prompt: "ترام أحمر يعبر ساحة أوروبية ممطرة عند الغسق، ثلاثة راكبي دراجات في المقدمة، نوافذ مقهى دافئة على اليسار، سماء زرقاء في وقت الغروب، تكوين متناظر، تصوير سينمائي.",image: require('@/assets/images/flux2/2026b767-edcb-4441-b70e-a6d94ae6ebb9.webp') },
                    { name: "معالجة متقدمة للخطوط", short: "يُحسّن عرض النصوص داخل الصور من حيث التدقيق الإملائي وتناسق الأسلوب. يُحسّن عرض النصوص داخل الصور من حيث التدقيق الإملائي وتناسق الأسلوب.", desc: "يُقدّم برنامج FLUX.2 تحسيناتٍ في توليد النصوص والتحكم بها عبر الصور، مع اتساقٍ أدقّ في أنماط الخطوط. وهذا يُتيح إنتاج موادّ نصية ولافتاتٍ للملصقات والإعلانات والقصص المصوّرة ورسومات العلامات التجارية مع تقليلٍ كبيرٍ للتشوّهات.", demo: { type: 'table', rows: [
                        { prompt: "صورة جميلة وساحرة لمنظر طبيعي مع النص \"FLUX 2\"، جمال رقيق، تتضمن التوت الأزرق." ,image: require('@/assets/images/flux2/c2f47f20-00b4-4cec-b972-e7a69d40be56.webp') },
                        { prompt: "كعكة غابة سوداء مكتوب عليها عبارة \"FLUX 2 Pro\"، لذيذة، تصوير الطعام." ,image: require('@/assets/images/flux2/2258b023-29ba-433f-b909-88f542adc3b9.webp') }
                    ] } },
                    { name: "إنشاء سريع وقابل للتوسع", short: "اختر من بين سرعة تنفيذ أقل من ثانية إلى إخراج بأعلى جودة.", desc: "يضم برنامج FLUX.2 طرازات كلاين السريعة وطرازات Pro وMax وFlex المُخصصة للإنتاج. هذه المجموعة تجعله عمليًا للمسودات السريعة، وإنتاج المحتوى بكميات كبيرة، وإنتاج مواد تسويقية أو إبداعية بجودة نهائية.", prompt: "صورة منتج تحريرية أنيقة لزجاجة عطر خضراء شفافة على حجر جيري، ضوء صباحي ناعم، ظلال خفيفة، جمالية حملة إعلانية فاخرة." ,image: require('@/assets/images/flux2/2a4b147b-31c2-4ded-a626-d7e209fb751b.webp')}
                ],
                showcaseKicker: "أمثلة توضيحية",
                showcaseTitle: "أمثلة على مُوجِّهات FLUX.2 لتحسين صور الذكاء الاصطناعي",
                showcaseIntro: "استخدم أمثلة FLUX.2 هذه كنقطة انطلاق، وقم بتخصيص الموضوع والتكوين والإضاءة والأسلوب، ثم أرسل طلبك مباشرة إلى المولد.",
                variantsKicker: "دليل النموذج",
                variantsTitle: "مقارنة بين طرازات FLUX.2: كلاين، ماكس، برو، فليكس",
                variantsIntro: "قارن بين FLUX.2 Klein و Max و Pro و Flex لاختيار نموذج الصور المناسب للذكاء الاصطناعي من أجل التكرار السريع، والأصول ذات الجودة النهائية، وحجم الإنتاج، أو التحكم الدقيق في الطباعة.",
                variants: [
                    { name: "FLUX.2 Klein 4B / 9B", tag: "أسرع", desc: "اختر FLUX.2 Klein لإنشاء الصور بسرعة وبكميات كبيرة، ولعمليات الرسم التخطيطي، ولعمل النماذج الأولية السريعة.", bestFor: "الأفضل للمسودات، والمجموعات، والتكرار السريع" },
                    { name: "FLUX.2 Max", tag: "أعلى جودة", desc: "اختر FLUX.2 Max للحصول على الأصول النهائية، وأقوى متابعة فورية، وإنتاج راسخ.", bestFor: "الأفضل للحملات المميزة والصور الرئيسية" },
                    { name: "FLUX.2 Pro", tag: "إنتاجي", desc: "اختر FLUX.2 Pro للحصول على توازن مثالي بين جودة الصورة ووقت التسليم والإخراج القابل للتطوير.", bestFor: "الأفضل للتسويق وإنتاج المحتوى" },
                    { name: "FLUX.2 Flex", tag: "تحكم", desc: "اختر FLUX.2 Flex للحصول على توجيه قابل للتعديل، وطباعة، وعرض النصوص، والحفاظ على التفاصيل الصغيرة.", bestFor: "الأفضل للملصقات والبطاقات التعريفية وعناصر التصميم" }
                ],
                useCasesKicker: "مصمم للاستخدام العملي",
                useCasesTitle: "استخدامات FLUX.2 الشائعة",
                useCases: [
                    { name: "FLUX.2 لتصوير المنتجات", desc: "أنشئ صورًا احترافية للمنتجات، ومشاهد من الحياة اليومية، وتنوعات صور التجارة الإلكترونية." },
                    { name: "FLUX.2 للتسويق والإعلان", desc: "حوّل أفكار حملاتك التسويقية إلى إعلانات على مواقع التواصل الاجتماعي، وبنرات إعلانية، وصور متناسقة لعلامتك التجارية." },
                    { name: "FLUX.2 للملصقات والطباعة", desc: "استخدم تقنية عرض النصوص FLUX.2 لإنتاج عناوين وعلامات وملصقات ورسومات نصية أكثر وضوحًا." },
                    { name: "FLUX.2 للصور الشخصية الواقعية", desc: "أنشئ صورًا شخصية مفصلة بتقنية الذكاء الاصطناعي مع تحكم دقيق في الإضاءة والتصميم والتكوين." },
                    { name: "FLUX.2 للتصميم المفاهيمي", desc: "استكشف البيئات السينمائية والشخصيات والاتجاهات البصرية بسرعة." },
                    { name: "FLUX.2 للتصميم التحريري", desc: "أنشئ رسومات توضيحية وأغلفة مميزة للمقالات والعروض التقديمية. ابتكر رسومات توضيحية وأغلفة مميزة للمقالات والعروض التقديمية." }
                ],
                howToKicker: "ثلاثة بسيطة الخطوات",
                howToTitle: "كيفية استخدام مُولِّد الصور FLUX.2 AI عبر الإنترنت",
                howToIntro: "استخدم مولد الصور FLUX.2 AI عبر الإنترنت على Miral للانتقال من مطالبة نصية مفصلة إلى صورة تم إنشاؤها.",
                howToSteps: [
                    { title: "أدخل نصك المطلوب", desc: "صف الموضوع، والتكوين، والإضاءة، والألوان، والأسلوب، وأي نص تريد أن يظهر في الصورة." },
                    { title: "اختر إعدادات FLUX.2", desc: "افتح المولد، وحدد Klein أو Max أو Pro أو Flex، ثم اختر حجم الإخراج الذي يناسب مشروعك." },
                    { title: "إنشاء الصورة", desc: "ابدأ عملية الإنشاء، راجع النتيجة، وقم بتنزيل الصورة أو قم بتحسين مطالبتك للحصول على نسخة أخرى." }
                ],
                howToCta: "جرّب مولد الصور FLUX.2 بتقنية الذكاء الاصطناعي",
                faqTitle: "الأسئلة الشائعة حول FLUX.2",
                faqs: [
                    { q: "ما هو FLUX.2؟", a: "FLUX.2 هو نموذج الذكاء الاصطناعي من الجيل التالي من شركة Black Forest Labs لتحويل النصوص إلى صور. يقوم هذا النموذج بتحويل النصوص المكتوبة إلى صور عالية الجودة ودقيقة التفاصيل، وهو متوفر على منصة Miral للاستخدام في مجالات الفن والتصميم والتسويق وإنشاء الصور المرئية للمنتجات مباشرةً من متصفحك." },
                    { q: "ما هي الأداة التي يمكنني استخدامها لإنشاء صور المنتجات ومواد التسويق المرئية الغنية بالنصوص؟", a: "يجمع برنامج FLUX.2 بين التماسك السريع والتفاصيل والواقعية الفوتوغرافية ومعالجة الطباعة للحصول على صور احترافية للمنتجات وصور تسويقية غنية بالنصوص تتطلب الدقة والوضوح." },
                    { q: "هل يمكنني استخدام مولد الصور FLUX.2 AI مجاناً؟", a: "نعم. سجّل الآن لتحصل على رصيد مجاني وابدأ بإنشاء صور عالية الجودة باستخدام مولد الصور FLUX.2 AI فورًا. يتم استخدام الرصيد المخصص لإنشاء الصور." },
                    { q: "كيف أستخدم مولد الصور FLUX.2 AI عبر الإنترنت؟", a: "أدخل نصًا تفصيليًا، واختر FLUX.2 Klein أو Max أو Pro أو Flex، ثم حدد حجم الصورة، وانقر على \"إنشاء\". يُعدّ FLUX.2 مثاليًا للمواد التسويقية، وتصوير المنتجات، والأفكار السينمائية، والتصاميم الإبداعية لوسائل التواصل الاجتماعي، وتصميم الملصقات." },
                    { q: "كم يستغرق برنامج FLUX.2 لإنشاء الصور؟", a: "يعتمد وقت الإنشاء على نوع FLUX.2 المُختار، وحجم الصورة، وحمل الخدمة الحالي. صُمم Klein للتكرار السريع جدًا، بينما تُعطي Max وPro وFlex أولويات مختلفة لتوازن الجودة والتحكم." },
                    { q: "كيف يمكنني إصلاح صورة FLUX.2 التي لا تستجيب لطلباتي؟", a: "صف الموضوع، والمكان، والتكوين، والإضاءة، ونوع الكاميرا أو الأسلوب الفني، والألوان، وأي نص مطلوب بشكل أكثر تفصيلاً. استخدم أمثلة FLUX.2 الموجودة في هذه الصفحة كنقطة انطلاق، وقم بتخصيصها لمشروعك." },
                    { q: "أي نموذج من FLUX.2 يجب أن أختار؟", a: "اختر FLUX.2 Klein للمسودات السريعة والدفعات، وMax للحصول على أصول نهائية عالية الجودة، وPro لإنشاء الصور على نطاق الإنتاج، أو Flex عندما تكون الطباعة والتحكم الدقيق في غاية الأهمية." },
                    { q: "FLUX.2 Max مقابل Pro: ما الفرق؟", a: "يُعطي برنامج FLUX.2 Max الأولوية للجودة القصوى، والاستجابة السريعة، والإنتاج الموثوق. بينما يُوازن برنامج FLUX.2 Pro بين جودة الإنتاج الاحترافية، وسرعة الإنجاز، وقابلية التوسع في الإنتاج لتلبية احتياجات سير العمل الإبداعي اليومي." },
                    { q: "FLUX.2 مقابل Midjourney: أيهما يجب أن أستخدم؟", a: "اختر بناءً على سير العمل بدلاً من اختيار حلٍّ واحدٍ يناسب الجميع. يُعدّ FLUX.2 خيارًا مثاليًا للمتابعة الدقيقة للتعليمات، والطباعة، وتصميم المنتجات المرئية، والإنتاج القائم على واجهة برمجة التطبيقات (API). أما Midjourney، فقد يُناسب المبدعين الذين يُفضّلون سير العمل الفني المُميّز وأدوات التواصل المجتمعي التي يُقدّمها." }
                ],
                ctaTitle: "جرّب FLUX.2 مجاناً على Miral!",
                ctaDesc: "أدخل فكرتك أعلاه واستخدم مولد الصور FLUX.2 AI لإنشاء صور مفصلة باستخدام نموذج المتغير الذي يناسب سير عملك."
            },
            seedream: {
                title: "مولد صور Seedream AI مجاني عبر الإنترنت | ميرال",
                description: "أنشئ صورًا عالية الجودة بتقنية الذكاء الاصطناعي عبر الإنترنت باستخدام Seedream. احصل على فهم دقيق وسريع، وعرض نصوص واضح، ومخرجات مفصلة بدقة 2K-4K للمشاريع الإبداعية.",
                heroHeadline: "مولد صور Seedream AI",
                heroIntro: "استخدم مولد الصور بتقنية الذكاء الاصطناعي من Seedream مجانًا. سجّل الآن لتحصل على رصيد مجاني، وابدأ فورًا بإنشاء صور عالية الجودة للمنتجات، والملصقات، والصور الشخصية، والصور التسويقية.",
                eyebrow: "ByteDance Seed · Seedream AI",
                sectionKicker: "Seedream AI",
                ctaTag: "سيدريم · ميرال",
                badges: ["تحويل النص إلى صورة", "فهم الغرض", "مخرجات بدقة 2K / 3K / 4K", "عرض نص واضح"],
                previewLabel: "Seedream AI",
                previewMeta: ["1:1", "2K / 3K / 4K", "حجم مخصص"],
                previewTitle: "من الفكرة الإبداعية إلى صورة دقيقة وعالية الدقة",
                previewDesc: "أنشئ تركيبات معقدة، وصور منتجات، وصور شخصية، وتصميمات غنية بالنصوص بتفاصيل دقيقة وتحكم سريع وموثوق.",
                keyFeaturesTitle: "أنشئ صورًا دقيقة باستخدام مولد الصور النصية بتقنية الذكاء الاصطناعي من Seedream",
                keyFeaturesIntro: "استكشف ميزات الذكاء الاصطناعي في Seedream لفهم أعمق للنوايا، والتركيب المعقد، والإخراج عالي الدقة، والتفاصيل الواقعية، وعرض النصوص بدقة من خلال توليد الصور من النصوص.",
                exploreTitle: "استكشف نماذج الذكاء الاصطناعي من Seedream",
                mainFeaturesTitle: "الميزات الرئيسية لتحويل النصوص إلى صور باستخدام الذكاء الاصطناعي في Seedream",
                seedream5Desc: "استخدم أحدث نموذج من Seedream للحصول على مطالبات دقيقة، وواقعية محسّنة، وعرض نصوص، وإخراج عالي الدقة.",
                seedream4Desc: "افتح سير عمل Seedream 4 المُعتمد لإنشاء صور نصية موثوقة وإعدادات إخراج مرنة.",
                features: [
                    { name: "فهم أعمق للمطالبة", short: "يُفسّر النية الإبداعية، والعلاقات المكانية، والتعليمات التفصيلية.", desc: "يتجاوز نظام Seedream AI مجرد مطابقة مصطلحات التعليمات المنفصلة. فهو يحلل العلاقات بين المواضيع والتصميم والخصائص والسياق المرئي لإنتاج نتائج أكثر تماسكًا من التعليمات النصية المعقدة.", demo: { type: 'table', rows: [
                        { prompt: "رف عرض 3x3، منظر أمامي، مع تسعة أشياء مختلفة مرتبة حسب المادة واللون، وإضاءة استوديو متناسقة ومحاذاة مكانية دقيقة.", image: require('@/assets/images/seedream/0217834949526105a9f949eb72c2227dac5c405ca3d9cd6c996b9_0.webp') },
                        { prompt: "صورة منتج تحريرية لساعة بجانب قطعة قماش كتان مطوية وكوب خزفي، تكوين مثلث متوازن، ضوء صباحي ناعم.", image: require('@/assets/images/seedream/021783495149924e4fd4c285bd49f804239cddc30345c48dc6024_0.webp') },
                        { prompt: "مشهد سوق سينمائي مع متسوقين في المقدمة، وموضوع مركزي واضح، وعمق متعدد الطبقات، وضوء دافئ ينعكس على الرصيف المبلل.", image: require('@/assets/images/seedream/994ae318-58d7-4ffa-98e1-ea97553ff0c0.webp') }
                    ] } },
                    { name: "التحكم في التركيب المعقد", short: "يتعامل مع مواضيع وخصائص وتخطيطات منظمة متعددة بتماسك أكبر.", desc: "يتبع مولد الصور Seedream AI تعليمات متعددة الأجزاء عبر مشاهد معقدة، مما يساعد على الحفاظ على سمات الكائنات المطلوبة ومواقعها وألوانها وعلاقاتها في تكوين واحد.", prompt: "مشهد تحريري أمامي بثلاث مزهريات خزفية بأشكال مختلفة على منصات حجرية متداخلة، وكرة حمراء خلف أطول مزهرية، وإضاءة جانبية ناعمة، وتباعد متوازن، وخلفية استوديو محايدة.", image: require('@/assets/images/seedream/021783495389730ffa263910bfaab0198f27d0234753c494fd2fa_0.webp') },
                    { name: "إخراج بدقة 2K و3K و4K", short: "اختر دقة الإخراج بناءً على التفاصيل والأبعاد التي يحتاجها مشروعك.", desc: "يدعم برنامج Seedream AI مخرجات بدقة 2K و3K و4K قابلة للتحديد على منصة Miral، بالإضافة إلى أحجام صور مخصصة. اختر بناءً على الأبعاد ومستوى التفاصيل المطلوب للاستخدام النهائي.", prompt: "مشهد سينمائي واسع لمدينة ساحلية مستقبلية عند شروق الشمس، هندسة معمارية متعددة الطبقات، مياه عاكسة، عمق جوي، تفاصيل بناء معقدة، تكوين بانورامي.", image: require('@/assets/images/seedream/0217834956211361c17ef9c173e8babb4a0658490f0169e937059_0.webp') },
                    { name: "تحسين عرض النصوص", short: "يُنتج نصوصًا أكثر وضوحًا للملصقات، والتصاميم، والعلامات، ورسومات العروض التقديمية.", desc: "يجمع برنامج Seedream AI بين التفكير البصري وإنشاء النصوص المحسّن، مما يجعله مفيدًا للملصقات ورسومات العروض التقديمية والإعلانات ومفاهيم التغليف وغيرها من التخطيطات التي يكون فيها النص المقروء جزءًا من الصورة.", demo: { type: 'table', rows: [
                        { prompt: "ملصق فعالية بسيط يحمل عنوان \"تصميم للمستقبل\"، بخط هندسي جريء، وخلفية بيضاء، وشبكة خضراء مميزة.", image: require('@/assets/images/seedream/0217834957232579f663fff68d336b1dca042ed755c42d2babd5a_0.webp') },
                        { prompt: "عبوة قهوة فاخرة تحمل علامة \"ميرال روست\"، ملاحظات تذوق موجزة، ملمس ورق دافئ، صور فوتوغرافية للمنتج في الاستوديو.", image: require('@/assets/images/seedream/021783495813482572fdc12977fa128088f145c73a50ff1524591_0.webp') }
                    ] } },
                    { name: "تفاصيل دقيقة وواقعية", short: "يُنتج إضاءةً وموادًا وعمقًا وعرضًا مُقنعًا للمنتج.", desc: "يقوم برنامج Seedream AI بإنشاء نسيج متقن وإضاءة متناسقة لتصوير المنتجات والصور الشخصية والصور التحريرية والمفاهيم السينمائية حيث يكون الوضوح والبنية المقنعة مهمين.", prompt: "صورة منتج تحريرية أنيقة لزجاجة عطر خضراء شفافة على حجر جيري، ضوء صباحي ناعم، ظلال خفيفة، جمالية حملة إعلانية فاخرة.", image: require('@/assets/images/seedream/021783495894855ad8f78454eef31552c89ebf2f2559e7d2d47a0_0.webp') }
                ],
                showcaseKicker: "أمثلة توضيحية",
                showcaseTitle: "أمثلة على تعليمات Seedream لتحسين صور الذكاء الاصطناعي",
                showcaseIntro: "استخدم أمثلة مطالبات الذكاء الاصطناعي هذه من Seedream كنقطة انطلاق. صف المواضيع والعلاقات المكانية والنص والإضاءة والتصميم بوضوح، ثم أرسل المطالبة مباشرة إلى المُولِّد.",
                variantsKicker: "دليل الدقة",
                variantsTitle: "دليل دقة الذكاء الاصطناعي من Seedream: 2K مقابل 3K مقابل 4K",
                variantsIntro: "اختر دقة إخراج Seedream AI بناءً على مدى سرعة التكرار التي تريدها ومقدار التفاصيل التي يتطلبها الأصل النهائي.",
                variants: [
                    { name: "2K", tag: "إخراج قياسي", desc: "حل عملي لمحتوى مواقع التواصل الاجتماعي، والأعمال الإبداعية اليومية، والتصاميم الرقمية القياسية.", bestFor: "الأفضل للمحتوى الرقمي العادي" },
                    { name: "3K", tag: "المزيد تفاصيل", desc: "يُضيف المزيد من تفاصيل الصور ويدعم تصميمات أكبر لأغراض التسويق والعروض التقديمية.", bestFor: "الأفضل لأصول التسويق والعروض التقديمية" },
                    { name: "4K", tag: "أقصى قدر من التفاصيل", desc: "استخدم أعلى إعداد مسبق عندما تكون القوام الدقيقة أو التصميمات التي تحتوي على نصوص كثيرة أو جودة التسليم الممتازة مهمة.", bestFor: "الأفضل للحملات النهائية والمخرجات عالية الدقة" }
                ],
                useCasesKicker: "مصمم للاستخدام العملي",
                useCasesTitle: "أمثلة شائعة لاستخدامات الذكاء الاصطناعي في سيدريم",
                useCases: [
                    { name: "الذكاء الاصطناعي من Seedream لتصوير المنتجات", desc: "ابتكر صورًا احترافية للمنتجات، ومشاهد من نمط الحياة، ومفاهيم صور للتجارة الإلكترونية." },
                    { name: "Seedream AI للتسويق", desc: "حوّل أفكار حملاتك التسويقية المنظمة إلى إعلانات على مواقع التواصل الاجتماعي، وبنرات إعلانية، وصور متناسقة لعلامتك التجارية." },
                    { name: "Seedream AI للملصقات والنصوص", desc: "ابتكر أفكارًا للملصقات، ورسومات للعروض التقديمية، وملصقات تعريفية، وتصميمات نصية." },
                    { name: "سيدريم للذكاء الاصطناعي في التركيبات المعقدة", desc: "رتب عدة عناصر وسمات مطلوبة في بنية بصرية متناسقة." },
                    { name: "الذكاء الاصطناعي من Seedream للرسومات المفاهيمية", desc: "استكشف البيئات السينمائية والشخصيات والتوجيهات البصرية التفصيلية." },
                    { name: "Seedream AI للصور التحريرية", desc: "أنشئ أغلفة، ورسومًا توضيحية، ورسومًا بيانية، وصورًا جاهزة للعرض التقديمي." }
                ],
                howToKicker: "ثلاثة بسيطة الخطوات",
                howToTitle: "كيفية استخدام مُولِّد الصور Seedream AI عبر الإنترنت مجانًا",
                howToIntro: "سجل للحصول على رصيد مجاني واستخدم مولد الصور Seedream AI عبر الإنترنت مع توجيه واضح والدقة المطلوبة لمشروعك.",
                howToSteps: [
                    { title: "أدخل فكرتك الإبداعية", desc: "صف المواضيع والعلاقات المكانية والتكوين والإضاءة والأسلوب والنص المطلوب بأوضح صورة ممكنة." },
                    { title: "اختر الدقة والحجم", desc: "افتح المولد وحدد 2K أو 3K أو 4K أو حجمًا مخصصًا مدعومًا بناءً على استخدامك النهائي." },
                    { title: "إنشاء ومراجعة", desc: "ابدأ عملية الإنشاء، راجع التركيب والتفاصيل، ثم قم بتنزيل النتيجة أو عدّل التعليمات الخاصة بك." }
                ],
                howToCta: "استخدم مولد الصور Seedream AI مجانًا",
                faqTitle: "الأسئلة الشائعة حول Seedream AI",
                faqs: [
                    { q: "ما هو مولد الصور Seedream AI؟", a: "Seedream AI هو نموذج ذكي لإنشاء الصور من فريق Seed التابع لشركة ByteDance. على منصة Miral، يقوم بتحويل النصوص التفصيلية إلى صور عالية الدقة لأغراض التصميم والتسويق ومفاهيم المنتجات والملصقات والمحتوى التحريري." },
                    { q: "ما هي الأداة التي يمكنني استخدامها لإنشاء ملصقات عالية الدقة بنصوص واضحة؟", a: "يجمع برنامج Seedream AI بين فهم أعمق للنوايا، وتكوين دقيق، وإنشاء نصوص محسّن، وإخراج عالي الدقة قابل للتحديد للملصقات وغيرها من التصميمات الغنية بالنصوص." },
                    { q: "هل يُمكنني استخدام مُولِّد الصور Seedream AI مجانًا؟", a: "نعم. سجّل الآن لتحصل على رصيد مجاني وابدأ فوراً بإنشاء صور عالية الجودة باستخدام مولد الصور Seedream AI. يتم استخدام الرصيد المخصص لإنشاء الصور." },
                    { q: "كيف يُمكنني استخدام مُولِّد الصور Seedream AI عبر الإنترنت؟", a: "أدخل نصًا تفصيليًا، واختر دقة عرض 2K أو 3K أو 4K، ويمكنك اختيار حجم مخصص، ثم انقر على \"إنشاء\". وللحصول على نتائج أفضل، صف العناصر والعلاقات المكانية والخصائص والإضاءة والنص والتصميم بوضوح." },
                    { q: "هل يدعم برنامج Seedream AI الصور بدقة 2K و 3K و 4K؟", a: "نعم. يوفر Miral إعدادات مسبقة بدقة 2K و 3K و 4K لـ Seedream AI، بالإضافة إلى أبعاد مخصصة مدعومة لنسب العرض المختلفة واحتياجات التسليم." },
                    { q: "كيفية إصلاح صور Seedream التي تحتوي على نصوص أو تكوينات غير صحيحة؟", a: "صف الموضوع، والعلاقات بين العناصر، والتكوين، والإضاءة، والألوان، والأسلوب، والنص المطلوب بمزيد من التفصيل. استخدم أمثلة Seedream الموجودة في هذه الصفحة كنقطة انطلاق، واذكر كل متطلب بصري بوضوح." },
                    { q: "ما هي دقة Seedream AI التي يجب أن أختارها؟", a: "اختر دقة 2K للمحتوى الرقمي القياسي، ودقة 3K عندما تحتاج تصميمات التسويق أو العروض التقديمية إلى مزيد من التفاصيل، ودقة 4K عندما تكون التفاصيل القصوى مهمة للحملات النهائية الكبيرة أو الملصقات أو أصول التصميم المتميزة." },
                    { q: "Seedream AI مقابل Midjourney: أيهما يجب أن أستخدم؟", a: "يُعدّ برنامج Seedream AI خيارًا مثاليًا للمطالبات المنظمة، والتركيبات المعقدة، والتخطيطات الغنية بالنصوص، وإمكانية اختيار مخرجات عالية الدقة في برنامج Miral. أما برنامج Midjourney فقد يناسب المبدعين الذين يفضلون أسلوب عمله الفني المميز وأدواته المجتمعية." }
                ],
                ctaTitle: "استخدم برنامج Seedream AI مجاناً على موقع Miral!",
                ctaDesc: "سجّل للحصول على رصيد مجاني. صف فكرتك، واختر الدقة المناسبة، واستخدم مولد الصور بتقنية الذكاء الاصطناعي من Seedream لإنشاء صور دقيقة وعالية الدقة."
            },
            gptImage: {
                title: "مولد صور الذكاء الاصطناعي GPT مجاني عبر الإنترنت | ميرال",
                description: "أنشئ صورًا عالية الجودة بتقنية الذكاء الاصطناعي عبر الإنترنت باستخدام GPT Image و GPT-Image-1.5 على منصة Miral AI. اختر أحجامًا ومستويات جودة عملية للملصقات والمنتجات والصور الشخصية.",
                heroHeadline: "مولد صور بتقنية الذكاء الاصطناعي باستخدام GPT Image",
                heroIntro: "استخدم مولد الصور GPT Image AI مجانًا على منصة Miral AI. سجّل الآن لتحصل على رصيد مجاني، وابدأ فورًا بإنشاء صور منتجات عالية الجودة، وملصقات، وصور شخصية، ومواد تسويقية مرئية باستخدام GPT-Image-1.5.",
                eyebrow: "OpenAI · GPT-Image-1.5",
                sectionKicker: "صورة GPT",
                ctaTag: "صورة GPT · ميرال",
                badges: ["تحويل النص إلى صورة", "جودة قابلة للتحديد", "أفقي / عمودي / مربع", "فهم دقيق للطلبات"],
                previewLabel: "GPT-Image-1.5",
                previewMeta: ["1024 × 1024", "1536 × 1024", "1024 × 1536"],
                previewTitle: "من فكرة مكتوبة إلى صورة ذكاء اصطناعي مصقولة وعملية",
                previewDesc: "استخدم توجيهات واضحة وجودة قابلة للتحديد لإنشاء صور المنتجات والملصقات والصور الشخصية ومحتوى العلامة التجارية.",
                keyFeaturesTitle: "أنشئ صورًا عالية الجودة باستخدام مولد الصور بالذكاء الاصطناعي GPT Image",
                keyFeaturesIntro: "استكشف ميزات GPT-Image-1.5 لفهم سريع، ومراقبة الجودة، وأحجام صور عملية، وإنشاء مرئي احترافي.",
                features: [
                    { name: "مطالبات اللغة الطبيعية ومتعددة المواضيع", short: "صف المواضيع والتكوين والإضاءة والأسلوب والعلاقات البصرية بلغة طبيعية.", desc: "يدعم مولد الصور بتقنية الذكاء الاصطناعي GPT Image إدخال عبارات بلغة طبيعية تتضمن مواضيع وخصائص ومتطلبات تكوين متعددة. ابدأ بعبارة بسيطة أو حدد موضع كل موضوع ولونه وعلاقته بالآخرين لإنشاء صور أكثر تماسكًا تضم ​​عدة مواضيع.", demo: { type: 'table', rows: [
                        { prompt: "صورة فوتوغرافية لمنتج تحريري لزجاجة عطر شفافة على قاعدة حجرية باهتة اللون، ضوء صباحي ناعم من اليسار، خلفية نظيفة، عمق مجال ضحل، جمالية علامة تجارية فاخرة.", image: require('@/assets/images/gptImage/perfume-editorial.webp') },
                        { prompt: "شارع ممطر في المدينة ليلاً، ثلاثة مشاة في المقدمة يحملون مظلات بألوان مختلفة، ترام يمر في المسافة، انعكاس أضواء النيون على الرصيف المبلل، تكوين سينمائي واسع.", image: require('@/assets/images/gptImage/rainy-city-tram.webp') }
                    ] } },
                    { name: "مراقبة جودة GPT-Image-1.5", short: "اختر الوضع التلقائي، أو المنخفض، أو المتوسط، أو العالي بناءً على احتياجات السرعة والتفاصيل.", desc: "يوفر برنامج GPT-Image-1.5 إعدادات للجودة التلقائية، والمنخفضة، والمتوسطة، والعالية. استخدم الجودة المنخفضة للاستكشاف السريع، والجودة العالية لصور المنتج النهائية، والملصقات، أو المواد التسويقية.", prompt: "إعلان طعام عالي الجودة لكعكة الفراولة على خلفية سوداء، بقوام كريمي مقرمش، وإضاءة حواف ناعمة، وتصوير طعام مفصل، وتكوين تجاري.", image: require('@/assets/images/gptImage/strawberry-cake.webp') },
                    { name: "ثلاثة أحجام صور عملية", short: "إنشاء مخرجات مربعة، أفقية، وعمودية.", desc: "اختر 1024×1024 أو 1536×1024 أو 1024×1536 للمنشورات الاجتماعية واللافتات والعروض التقديمية المرئية، أو ملصقات الصور العمودية ومحتوى الهاتف المحمول.", prompt: "ملصق سفر عمودي بحجم 1024×1536 بكسل، يظهر فيه جرف ساحلي ومنارة في ضباب الصباح، مع مساحة لعنوان رئيسي في الأعلى، وتصميم تحريري حديث.", image: require('@/assets/images/gptImage/lighthouse-travel-poster.webp') },
                    { name: "إنشاء نصوص وتخطيطات واضحة", short: "أنشئ ملصقات، وعلامات تجارية، وأفكارًا للعلامات التجارية تتضمن نصوصًا.", desc: "من خلال تحديد النص المطلوب، والموضع، والأسلوب الطباعي، وعلاقات التخطيط بوضوح، يمكن لـ GPT Image المساعدة في استكشاف الملصقات والتغليف ورسومات الأحداث والصور التسويقية مع العناوين الرئيسية.", demo: { type: 'table', rows: [
                        { prompt: "ملصق بسيط لفعالية تكنولوجية بعنوان \"اصنع المستقبل\"، بخط عريض بدون زوائد، وخلفية زرقاء داكنة، وشبكة هندسية خضراء، وعنوان واضح في المنتصف.", image: require('@/assets/images/gptImage/create-the-future.webp') },
                        { prompt: "تصميم عبوة قهوة فاخرة تحمل عبارة \"MIRAL ROAST\" على واجهتها، ملمس ورق بني دافئ، ملصق أنيق، تصوير المنتج في الاستوديو.", image: require('@/assets/images/gptImage/miral-roast-package.webp') }
                    ] } },
                    { name: "تفاصيل وواقعية", short: "اعرض موادًا وإضاءة وأشخاصًا وتفاصيل منتجات واقعية.", desc: "يُعد برنامج GPT Image مناسبًا لتصوير المنتجات، والصور الشخصية، والتصميمات الداخلية، والصور التحريرية عندما يصف التوجيه بوضوح المواد، وخيارات الكاميرا، والإضاءة، وعمق المجال.", prompt: "صورة مقربة لفنانة خزفية في ضوء نافذة طبيعي، ملمس بشرة واقعي، غبار طيني على يديها، خلفية ورشة عمل، عمق مجال ضحل، تصوير فوتوغرافي دافئ.", image: require('@/assets/images/gptImage/ceramic-artist.webp') }
                ],
                showcaseKicker: "أمثلة توضيحية",
                showcaseTitle: "أمثلة على مطالبات صور GPT للحصول على صور ذكاء اصطناعي أفضل",
                showcaseIntro: "استخدم هذه التوجيهات الخاصة بصور جوجل بلاي كنقطة انطلاق. صف بوضوح الموضوع، والتكوين، والإضاءة، والأسلوب، والمواد، وأي نص مطلوب.",
                variantsKicker: "دليل الإصدار",
                variantsTitle: "مقارنة بين GPT-Image-1.5 و GPT-Image-1",
                variantsIntro: "اختر إصدار صورة GPT بناءً على ما إذا كنت بحاجة إلى مراقبة الجودة. يدعم كلا الإصدارين أحجامًا عملية مربعة وأفقية وعمودية.",
                variants: [
                    { name: "GPT-Image-1.5", tag: "موصى به", desc: "يدعم دقة 1024×1024 و 1536×1024 و 1024×1536 مع خيارات الجودة التلقائية والمنخفضة والمتوسطة والعالية.", bestFor: "الأفضل للاستخدام اليومي والمهني الذي يتطلب مراقبة الجودة" },
                    { name: "GPT-Image-1", tag: "كلاسيكي", desc: "يدعم نفس أحجام الصور العملية الثلاثة مع مجموعة أبسط من عناصر التحكم.", bestFor: "الأفضل لإنشاء صور نصية بسيطة وعامة الأغراض" }
                ],
                useCasesKicker: "مصمم للاستخدام العملي",
                useCasesTitle: "أمثلة شائعة لاستخدامات GPT Image",
                useCases: [
                    { name: "صورة GPT لتصوير المنتجات ونماذجها", desc: "إنشاء صور رئيسية للمنتجات، ومشاهد نمط الحياة، ونماذج أولية للمنتجات، ومفاهيم بصرية للتجارة الإلكترونية." },
                    { name: "صورة GPT لصور قوائم التجارة الإلكترونية", desc: "استكشف صور قوائم المنتجات، والرسومات المميزة، وعروض التغليف، وأفكار الإعلانات." },
                    { name: "صورة GPT للتسويق وإعلانات وسائل التواصل الاجتماعي", desc: "قم بإنشاء إعلانات على وسائل التواصل الاجتماعي، وبنرات الحملات الإعلانية، وبنرات البريد الإلكتروني، ومواد تسويقية تحمل العلامة التجارية." },
                    { name: "صورة GPT لتصميم واجهات المستخدم وتجربة المستخدم ومواقع الويب", desc: "قم بإنشاء مفاهيم بصرية لواجهات التطبيقات، وتصميمات مواقع الويب، والصفحات المقصودة، وصفحات عرض المنتجات." },
                    { name: "صورة GPT للرسوم البيانية والتقارير المرئية", desc: "استكشف مفاهيم التصميم للرسوم البيانية والتقارير المرئية ورسومات العرض التقديمي؛ وتحقق من جميع النصوص والبيانات قبل الاستخدام النهائي." },
                    { name: "صورة GPT للملصقات وتغليف المنتجات", desc: "استكشف تصميمات الملصقات، وعلامات المنتجات، والتغليف مع متطلبات العناوين والتخطيط." },
                    { name: "صورة GPT لأغلفة الكتب والمدونات صور", desc: "أنشئ أغلفة كتب، ورسومات توضيحية للمقالات، وعناوين مدونات، ومفاهيم بصرية للنشر." },
                    { name: "صورة GPT للصور الشخصية", desc: "أنشئ صورًا احترافية بإضاءة وخلفيات وأسلوب مُتحكم به." },
                    { name: "صورة GPT لتصميم شخصيات الألعاب", desc: "استكشف بسرعة شخصيات اللعبة والأزياء والدعائم والاتجاهات الفنية المختلفة." },
                    { name: "GPT Image لبيئات الألعاب", desc: "قم بإنشاء بيئات اللعبة والمشاهد السينمائية ومفاهيم بناء العالم للاستكشاف الإبداعي المبكر." },
                    { name: "صورة GPT لمحتوى وسائل التواصل الاجتماعي", desc: "أنشئ صورًا مربعة، وأفقية، وعمودية لمنصات مختلفة." }
                ],
                howToKicker: "ثلاثة بسيطة الخطوات",
                howToTitle: "كيفية استخدام مولد الصور بالذكاء الاصطناعي GPT عبر الإنترنت مجاناً",
                howToIntro: "سجل للحصول على رصيد مجاني واستخدم مولد الصور GPT Image AI عبر الإنترنت على موقع Miral.",
                howToSteps: [
                    { title: "أدخل نصًا تفصيليًا", desc: "صف الموضوع، والمكان، والتكوين، والإضاءة، والأسلوب، والمواد، وأي نص مطلوب." },
                    { title: "اختر الحجم والجودة", desc: "اختر حجمًا مربعًا أو أفقيًا أو رأسيًا، واضبط جودة GPT-Image-1.5 بناءً على احتياجاتك." },
                    { title: "إنشاء ومراجعة", desc: "ابدأ عملية الإنشاء، ثم راجع الصورة وقم بتنزيلها، أو عدّل الموجه وقم بإنشاء نسخة أخرى." }
                ],
                howToCta: "استخدم مولد صور الذكاء الاصطناعي GPT مجانًا",
                faqTitle: "الأسئلة الشائعة حول صورة GPT",
                faqs: [
                    { q: "ما هو مُولِّد الصور بالذكاء الاصطناعي GPT Image؟", a: "GPT Image هي عائلة نماذج OpenAI متعددة الأغراض لتحويل النصوص إلى صور. على منصة Miral، يقوم مولد الصور GPT Image AI بتحويل النصوص المكتوبة إلى صور عالية الجودة لأغراض التصميم والتسويق ومفاهيم المنتجات والملصقات ومحتوى وسائل التواصل الاجتماعي." },
                    { q: "هل يمكنني استخدام مولد الصور GPT Image AI مجاناً؟", a: "نعم. سجّل الآن لتحصل على رصيد مجاني وابدأ بإنشاء صور عالية الجودة باستخدام مولد الصور GPT Image AI فورًا. يتم استخدام الرصيد المخصص لإنشاء الصور." },
                    { q: "كيف أستخدم مولد الصور GPT Image AI عبر الإنترنت؟", a: "أدخل نصًا تفصيليًا واختر 1024×1024 أو 1536×1024 أو 1024×1536. باستخدام GPT-Image-1.5، يمكنك أيضًا تحديد الجودة التلقائية أو المنخفضة أو المتوسطة أو العالية قبل النقر فوق \"إنشاء\"." },
                    { q: "ما الفرق بين GPT-Image-1.5 و GPT-Image-1؟", a: "يدعم كلا الإصدارين نفس أحجام الصور العملية الثلاثة. يوفر GPT-Image-1.5 على Miral أيضًا تحكمًا تلقائيًا في الجودة (منخفضة، متوسطة، وعالية)، بينما يتميز GPT-Image-1 بمجموعة أبسط من المعلمات." },
                    { q: "ما هي أحجام الصور التي يدعمها GPT Image؟", a: "على منصة Miral، يدعم كل من GPT-Image-1 و GPT-Image-1.5 الصور المربعة بحجم 1024×1024، والصور الأفقية بحجم 1536×1024، والصور الرأسية بحجم 1024×1536." },
                    { q: "ما هي جودة صورة GPT التي يجب أن أختارها؟", a: "اختر الجودة المنخفضة أو المتوسطة عند اختبار المطالبات بسرعة، والجودة العالية لصور المنتج النهائية أو الملصقات أو المواد التسويقية، والجودة التلقائية عند عدم التأكد. تنطبق خيارات الجودة على GPT-Image-1.5." },
                    { q: "كيف يمكنني إصلاح نتائج صور GPT التي لا تتطابق مع ما أبحث عنه؟", a: "صف الموضوع، والإعداد، والتكوين، والإضاءة، والكاميرا، والمواد، والأسلوب، وأي نص مطلوب بمزيد من التفصيل. استخدم أمثلة صور جوجل بلاي الموجودة في هذه الصفحة كنقطة انطلاق، وقم بتكييفها مع مشروعك." },
                    { q: "هل أحتاج إلى خبرة هندسية متقدمة لاستخدام GPT Image؟", a: "لا. ابدأ بوصف بسيط بلغة طبيعية، ثم أضف مواقع العناصر، والتكوين، والإضاءة، والألوان، والمواد، ومتطلبات النص حسب الحاجة. تساعد الأوصاف الأكثر وضوحًا عمومًا في جعل النتيجة تتطابق بشكل أدق مع رؤيتك الإبداعية." },
                    { q: "ما هي الأداة التي يمكنني استخدامها لإنشاء صور منتجات التجارة الإلكترونية والملصقات ومفاهيم واجهة المستخدم؟", a: "يُمكن لبرنامج GPT Image إنشاء صور لقوائم التجارة الإلكترونية، ونماذج المنتجات، والملصقات، ومفاهيم واجهة المستخدم/تجربة المستخدم، وتصميمات مواقع الويب، وتصميمات الرسوم البيانية، وأغلفة الكتب، وصور المدونات، وشعارات البريد الإلكتروني، ومفاهيم الألعاب. يُرجى التحقق من النصوص والبيانات وعناصر العلامة التجارية والتفاصيل الهيكلية قبل الاستخدام النهائي." },
                    { q: "صورة GPT مقابل Midjourney: أيهما يجب أن أستخدم؟", a: "يُعدّ برنامج GPT Image خيارًا مثاليًا للتحكم الواضح في الإعدادات، وأحجام الصور العملية، وإنشاء الصور مباشرةً من المتصفح. أما برنامج Midjourney، فقد يُناسب المستخدمين الذين يُفضلون أساليبه الفنية، وسير العمل القائم على الصور المرجعية، والعملية الإبداعية." }
                ],
                ctaTitle: "استخدم صور GPT مجاناً على ميرال!",
                ctaDesc: "سجّل للحصول على رصيد مجاني. صف فكرتك، واختر الحجم والجودة، واستخدم مولد الصور بتقنية الذكاء الاصطناعي من GPT Image لإنشاء صور عالية الجودة."
            },
            qwenImage2Pro: {
                title: "مولد الصور Qwen Image 2.0 Pro AI المجاني عبر الإنترنت | ميرال",
                description: "أنشئ صورًا بتقنية الذكاء الاصطناعي عبر الإنترنت باستخدام Qwen Image 2.0 Pro. استخدم المطالبات السلبية، وتحسين المطالبات، ونسب العرض إلى الارتفاع المرنة، وقم بإنشاء ما يصل إلى أربع صور في كل تشغيل.",
                heroHeadline: "مولد الصور بالذكاء الاصطناعي Qwen Image 2.0 Pro",
                heroIntro: "استخدم مولد الصور Qwen Image 2.0 Pro AI مجانًا على منصة Miral AI. سجّل الآن لتحصل على رصيد مجاني، وأنشئ صورًا عالية الجودة بسرعة باستخدام خيارات التحسين التلقائي للصور، وتحسينها، ونسب العرض إلى الارتفاع المرنة.",
                eyebrow: "Alibaba Tongyi Qwen · Qwen-Image-2.0-Pro",
                sectionKicker: "Qwen Image 2.0 Pro",
                ctaTag: "Qwen Image 2.0 Pro · Miral",
                badges: ["تحويل النص إلى صورة", "مطالبة سلبية", "تحسين المطالبة", "1-4 صور / تشغيل", "نسب أبعاد مرنة"],
                previewLabel: "Qwen Image 2.0 Pro",
                previewMeta: ["1:1", "2048 × ٢٠٤٨", "حتى ١-٤ صور"],
                previewTitle: "من تحديد دقيق مع استثناءات إلى صور مصقولة.",
                previewDesc: "قم بدمج المطالبات الإيجابية مع المطالبات السلبية وتحسين المطالبات لإنشاء صور متعددة على الهدف في عملية واحدة.",
                keyFeaturesTitle: "أنشئ صورًا دقيقة باستخدام مولد الصور النصية Qwen Image 2.0 Pro",
                keyFeaturesIntro: "استكشف الميزات الرئيسية لمولد الصور Qwen Image 2.0 Pro AI للتحكم الدقيق، والمطالبات السلبية، وتحسين المطالبات، والإخراج المجمع، ونسب العرض إلى الارتفاع المرنة.",
                mainFeaturesTitle: "الميزات الرئيسية لبرنامج Qwen Image 2.0 Pro",
                promptLabel: "مطالبة إيجابية",
                negativePromptLabel: "مطالبة سلبية",
                shortPromptLabel: "مطالبة قصيرة",
                negativePromptFallback: "وضوح منخفض، تفاصيل مشوهة، تصميم مزدحم",
                features: [
                    { name: "التحكم في مطالبة النسخ السلبي", short: "حدد ما يجب استبعاده للحصول على نتائج أنظف وأكثر دقة.", desc: "يدعم مولد الصور Qwen Image 2.0 Pro AI خاصية التنبيه السلبي المخصصة، مما يتيح لك تحديد ما يجب تجنبه في الصورة، مثل انخفاض الوضوح، أو تشوه اليدين، أو ازدحام الصورة. يمنحك هذا تحكمًا أدق في الصورة النهائية ويقلل الحاجة إلى إعادة التصوير بشكل متكرر.", demo: { type: 'table', rows: [
                        { prompt: "صورة عالية الجودة لمنتج عبارة عن زجاجة عناية بالبشرة موضوعة على حجر مبلل، في ضوء الصباح الخافت، على خلفية نظيفة. (السلبيات: خلفية مزدحمة، دقة منخفضة، انعكاسات مشوهة).", image: require('@/assets/images/qwenImage2Pro/32ccbe94-155c-4873-9e85-602969ecb6e4.webp') },
                        { prompt: "صورة لامرأة شابة في ضوء الخريف، ببشرة ذات ملمس طبيعي، وعمق مجال ضحل. (السلبيات: بشرة ناعمة بشكل مفرط، مظهر شمعي، ألوان مشبعة بشكل مفرط.)", image: require('@/assets/images/qwenImage2Pro/b4c88e78-6c88-4db5-9ea2-a6041609a380.webp') }
                    ] } },
                    { name: "تحسين المطالبة", short: "إمكانية توسيع نص قصير إلى تفاصيل أكثر.", desc: "فعّل خاصية تحسين النص، وسيقوم برنامج Qwen Image 2.0 Pro تلقائيًا بإثراء النص الموجز بتفاصيل إضافية قبل إنشائه. يساعد هذا غير المتخصصين على إنتاج صور أكثر اكتمالًا ووضوحًا دون الحاجة إلى إعادة كتابتها يدويًا.", demo: { type: 'table', rows: [
                        { prompt: "ركن قراءة مريح بجوار نافذة ممطرة. زاوية قراءة هادئة بجوار نافذة ممطرة.", image: require('@/assets/images/qwenImage2Pro/f9f87426-60d9-4f97-a372-7cb55b5bf7de.webp') },
                        { prompt: "طاولة قراءة خشبية بجانب نافذة مغطاة بالمطر ليلاً، ومصباح عمل دافئ يضيء كتاباً مفتوحاً وكوباً من الشاي الساخن، وديكور داخلي هادئ ومريح.", image: require('@/assets/images/qwenImage2Pro/qwen-enhance-rainy-desk.webp') }
                    ] } },
                    { name: "إنشاء من ١ إلى ٤ صور في آن واحد", short: "إنتاج نسخ متعددة في عملية واحدة.", desc: "يُمكن لبرنامج Qwen Image 2.0 Pro إنشاء ما يصل إلى أربع صور لكل طلب، مما يُتيح لك مقارنة تنويعات المفهوم أو الزاوية أو الأسلوب جنبًا إلى جنب واختيار الأفضل. هذا يُسرّع عملية البحث الإبداعي للتسويق والصور المرئية للمنتجات.", prompt: "مصباح طاولة خزفي بتصميم بسيط على طاولة جانبية من خشب الجوز، ديكور داخلي دافئ في المساء، جدار كريمي اللون، ظلال ناعمة، تصوير منتجات إسكندنافية.", image: require('@/assets/images/qwenImage2Pro/c4581d5b-f28a-4ae5-8bb2-b110c30d954c.webp') },
                    { name: "نسب أبعاد مرنة", short: "اختر أحجامًا أفقية، أو عمودية، أو مربعة، أو أحجامًا مخصصة.", desc: "اختر من بين نسب العرض إلى الارتفاع الجاهزة مثل 2688×1536 أفقي، و1536×2688 عمودي، و2048×2048 مربع، و2368×1728 / 1728×2368، أو أدخل حجمًا مخصصًا من 512×512 إلى 2048×2048. هذا يجعل مولد النصوص إلى الصور Qwen Image 2.0 Pro مناسبًا للبنرات والملصقات ومنشورات وسائل التواصل الاجتماعي والصور المصغرة المربعة على حد سواء.", prompt: "لقطة سينمائية واسعة لمنظر طبيعي لجرف ساحلي في وقت الغروب، مع سحب درامية وتفاصيل صخرية دقيقة، 2688×1536.", image: require('@/assets/images/qwenImage2Pro/e2bd1179-48db-4ce6-a713-2a0a62dd5dd5.webp') },
                    { name: "تفاصيل دقيقة وواقعية", short: "احصل على صور واقعية من حيث الملمس والإضاءة والعمق.", desc: "ينتج برنامج Qwen Image 2.0 Pro نسيجًا دقيقًا وإضاءة واقعية وعمقًا طبيعيًا، مما يجعله مناسبًا تمامًا لتصوير المنتجات والصور الشخصية والصور التحريرية حيث تكون المصداقية مهمة.", prompt: "صورة مقربة لفنانة خزفية مسنة في ورشة عمل مضاءة بأشعة الشمس، ملمس طبيعي للبشرة، غبار الطين على اليدين، ضوء نافذة دافئ، عمق مجال ضحل.", image: require('@/assets/images/qwenImage2Pro/3204b3e8-c5ca-40b4-afa9-a65f6dd806e2.webp') }
                ],
                showcaseKicker: "أمثلة توضيحية",
                showcaseTitle: "أمثلة على مُدخلات Qwen Image 2.0 Pro لتحسين صور الذكاء الاصطناعي",
                showcaseIntro: "استخدم أمثلة مطالبات Qwen Image 2.0 Pro هذه كنقطة انطلاق. قم بربط كل مطالبة إيجابية بمطالبة سلبية لإزالة العناصر غير المرغوب فيها، ثم أرسلها مباشرة إلى المُولِّد.",
                useCasesKicker: "مصمم للاستخدام العملي",
                useCasesTitle: "أمثلة شائعة لاستخدام Qwen Image 2.0 Pro",
                useCases: [
                    { name: "برنامج Qwen Image 2.0 Pro لتصوير المنتجات", desc: "قم بإنشاء صور منتجات نظيفة بخلفيات مضبوطة باستخدام عبارات سلبية لإزالة الفوضى." },
                    { name: "Qwen Image 2.0 Pro للتسويق", desc: "قم بإنشاء مفاهيم الحملات الإعلانية، والإعلانات على وسائل التواصل الاجتماعي، واللافتات الإعلانية عبر نسب أبعاد متعددة." },
                    { name: "Qwen Image 2.0 Pro للملصقات والطباعة", desc: "صمم ملصقات وتصاميم غنية بالنصوص مع عناوين وعلامات واضحة." },
                    { name: "برنامج Qwen Image 2.0 Pro للصور الشخصية", desc: "قم بإنشاء صور شخصية مفصلة بنسيج بشرة طبيعي باستخدام محفزات سلبية لتجنب التشوهات." },
                    { name: "برنامج Qwen Image 2.0 Pro للرسومات المفاهيمية", desc: "استكشف الشخصيات والبيئات والاتجاهات البصرية مع 1-4 اختلافات لكل تشغيل." },
                    { name: "Qwen Image 2.0 Pro للتجارة الإلكترونية", desc: "أنتج نسخًا متعددة من الصور للإعلانات والقوائم في عملية إنشاء واحدة." }
                ],
                howToKicker: "ثلاثة بسيطة الخطوات",
                howToTitle: "كيفية استخدام مولد الصور Qwen Image 2.0 Pro AI عبر الإنترنت",
                howToIntro: "استخدم مولد الصور Qwen Image 2.0 Pro AI عبر الإنترنت على Miral مع مطالبات إيجابية ومطالبات سلبية وعناصر تحكم مرنة في الإخراج.",
                howToSteps: [
                    { title: "أدخل مطالبتك الرئيسية", desc: "صف الموضوع المطلوب، والمشهد، والتكوين، والإضاءة، والأسلوب، والتفاصيل البصرية." },
                    { title: "ضبط عناصر التحكم في الإنشاء", desc: "أضف رسالة تحذير سلبية إذا لزم الأمر، وقم بتمكين تحسين الرسالة، واختر الحجم، وحدد من صورة واحدة إلى أربع صور." },
                    { title: "إنشاء ومقارنة", desc: "ابدأ عملية الإنشاء، وقارن بين الاختلافات التي تم إرجاعها، وقم بتنزيل الصورة التي تتناسب بشكل أفضل مع هدفك." }
                ],
                howToCta: "جرّب برنامج Qwen Image 2.0 Pro لإنشاء الصور بالذكاء الاصطناعي",
                faqTitle: "الأسئلة الشائعة حول Qwen Image 2.0 Pro",
                faqs: [
                    { q: "ما هو مولد الصور Qwen Image 2.0 Pro المدعوم بالذكاء الاصطناعي؟", a: "Qwen Image 2.0 Pro هو نموذج Tongyi Qwen لتحويل النصوص إلى صور من شركة Alibaba. يقوم مولد الصور Qwen Image 2.0 Pro المدعوم بالذكاء الاصطناعي بتحويل النصوص المكتوبة إلى صور عالية الجودة ودقيقة التفاصيل، وهو متوفر على منصة Miral للاستخدام في مجالات الفن والتصميم والتسويق وإنشاء الصور المرئية للمنتجات مباشرةً من متصفحك." },
                    { q: "ما الأداة التي يمكنني استخدامها لإنشاء صور منتجات متعددة مع توجيهات سلبية؟", a: "يوفر برنامج Qwen Image 2.0 Pro موجهًا سلبيًا مخصصًا، وتحسينًا اختياريًا للموجه، و1-4 صور لكل تشغيل، ونسب عرض إلى ارتفاع مرنة لتصوير المنتجات والتسويق والاختلافات المرئية للتجارة الإلكترونية." },
                    { q: "هل يمكنني استخدام برنامج Qwen Image 2.0 Pro لتوليد الصور بالذكاء الاصطناعي مجاناً؟", a: "نعم. سجّل الآن لتحصل على رصيد مجاني وابدأ فوراً بإنشاء صور عالية الجودة باستخدام مولد الصور Qwen Image 2.0 Pro AI. يتم استخدام الرصيد المخصص لإنشاء الصور." },
                    { q: "كيف أستخدم مولد الصور Qwen Image 2.0 Pro AI عبر الإنترنت؟", a: "أدخل نصًا تفصيليًا، ويمكنك إضافة نص سلبي يصف ما يجب تجنبه، وفعّل تحسين النص إذا لزم الأمر، واختر نسبة العرض إلى الارتفاع أو حجمًا مخصصًا، وحدد عدد الصور المراد إنشاؤها (من 1 إلى 4)، ثم انقر على \"إنشاء\". يُعدّ برنامج Qwen Image 2.0 Pro مثاليًا للمواد التسويقية، وتصوير المنتجات، والصور الشخصية، وتصميم الملصقات." },
                    { q: "كيفية إصلاح العناصر غير المرغوب فيها في نتائج Qwen Image 2.0 Pro؟", a: "أضف تنبيهًا سلبيًا يصف العناصر التي لا ترغب بها، مثل انخفاض الوضوح، أو تشوه اليدين، أو الخلفية المزدحمة. يستخدم برنامج Qwen Image 2.0 Pro هذه الميزة لتوجيه عملية إنشاء الصور بعيدًا عن هذه النتائج." },
                    { q: "كم عدد الصور التي يمكن لـ Qwen Image 2.0 Pro توليدها في وقت واحد؟", a: "يمكن لبرنامج Qwen Image 2.0 Pro إنشاء ما يصل إلى 4 صور في طلب واحد (n = 1 إلى 4)، بحيث يمكنك مقارنة الاختلافات في المفهوم أو الزاوية أو الأسلوب واختيار الأفضل." },
                    { q: "ما الأحجام ونسب العرض إلى الارتفاع التي يدعمها برنامج Qwen Image 2.0 Pro؟", a: "يوفر برنامج Qwen Image 2.0 Pro على منصة Miral نسب أبعاد جاهزة مثل 2688×1536 و1536×2688 و2048×2048 و2368×1728 و1728×2368، بالإضافة إلى حجم مخصص من 512×512 إلى 2048×2048. وهذا يشمل مخرجات أفقية وعمودية ومربعة للبنرات والملصقات ومنشورات وسائل التواصل الاجتماعي والصور المصغرة." },
                    { q: "ما هي أفضل أمثلة مُدخلات Qwen Image 2.0 Pro؟", a: "تُقدّم إرشادات Qwen Image 2.0 Pro الفعّالة وصفًا واضحًا للموضوع، والإعداد، والتكوين، والإضاءة، والأسلوب، ثمّ تُقرن بإرشاد إيجابي وآخر سلبي لإزالة التفاصيل غير المرغوب فيها. استخدم أمثلة إرشادات Qwen Image 2.0 Pro الموجودة في هذه الصفحة كنقطة انطلاق، وقم بتخصيصها لمشروعك." },
                    { q: "Qwen Image 2.0 Pro مقابل Midjourney: أيهما يجب أن أستخدم؟", a: "اختر بناءً على سير العمل بدلاً من البحث عن خيار مثالي. يُعدّ Qwen Image 2.0 Pro خيارًا ممتازًا عندما تحتاج إلى توجيهات سلبية واضحة، وتحسين التوجيهات، وإمكانية استخدام من صورة إلى أربع صور في كل عملية، ونسب عرض إلى ارتفاع مرنة في مُولّد صور يعمل عبر المتصفح على منصة Miral. أما Midjourney فقد يُناسب المبدعين الذين يُفضّلون سير العمل الفني المُميّز وأدوات التواصل المجتمعي." }
                ],
                ctaTitle: "جرّب برنامج Qwen Image 2.0 Pro مجاناً على موقع Miral!",
                ctaDesc: "أدخل فكرتك أعلاه واستخدم مولد الصور Qwen Image 2.0 Pro AI مع عناصر تحكم اختيارية لإنشاء اختلافات دقيقة في الصور."
            },
            stableDiffusion: {
                title: "مولد صور الذكاء الاصطناعي Stable Diffusion 3.5 مجاني عبر الإنترنت | ميرال",
                description: "قم بإنشاء صور الذكاء الاصطناعي عبر الإنترنت باستخدام Stable Diffusion 3.5. استخدم المطالبات السلبية ونسب العرض إلى الارتفاع المحددة مسبقًا والأحجام المخصصة من 512 إلى 2048 بكسل على Miral.",
                heroHeadline: "مولد صور الذكاء الاصطناعي Stable Diffusion 3.5",
                heroIntro: "استخدم مولد الصور Stable Diffusion 3.5 AI مجانًا على منصة Miral AI. سجّل الآن لتحصل على رصيد مجاني، وأنشئ صورًا عالية الجودة بسرعة باستخدام توجيهات مفصلة، ​​وتوجيهات سلبية، وأحجام مرنة.",
                eyebrow: "الذكاء الاصطناعي للاستقرار · الانتشار المستقر 3.5",
                sectionKicker: "انتشار مستقر ٣.٥",
                ctaTag: "الانتشار المستقر 3.5 · ميرال",
                badges: ["تحويل النص إلى صورة", "مطالبة سلبية", "نسب أبعاد مرنة", "حجم مخصص"],
                previewLabel: "انتشار مستقر ٣.٥",
                previewMeta: ["1:1", "٥١٢ – ٢٠٤٨", "مضاعفات 64"],
                previewTitle: "من تعليمات مفصلة إلى صورة مصقولة ومتقنة",
                previewDesc: "قم بربط المطالبات الإيجابية بالمطالبات السلبية واختر نسبة العرض إلى الارتفاع المناسبة لتوجيه Stable Diffusion 3.5 نحو صور واضحة ودقيقة.",
                keyFeaturesTitle: "أنشئ صورًا مُتحكَّمًا بها باستخدام مُولِّد تحويل النص إلى صورة Stable Diffusion 3.5",
                keyFeaturesIntro: "استكشف الميزات الرئيسية لمولد الصور بالذكاء الاصطناعي Stable Diffusion 3.5 للحصول على مطالبات سلبية، ونسب عرض إلى ارتفاع مرنة، وأحجام مخصصة، وفهم مفصل للمطالبات.",
                exploreTitle: "استكشف المزيد من نماذج الصور المدعومة بالذكاء الاصطناعي",
                mainFeaturesTitle: "الميزات الرئيسية لتقنية Stable Diffusion 3.5",
                generatedImageLabel: "صورة مُولّدة",
                versionLabel: "تحكم",
                featureLabel: "ما الذي يتغير؟",
                useCaseLabel: "الأفضل لـ",
                variantsTitle: "إعدادات الإخراج: انتشار ثابت 3.5",
                variantsIntro: "قم بدمج نموذج Stable Diffusion 3.5 مع نسب العرض إلى الارتفاع المحددة مسبقًا أو الأبعاد المخصصة الدقيقة بناءً على التصميم النهائي الذي تحتاجه.",
                variants: [
                    { name: "انتشار مستقر ٣.٥", desc: "توليد صور نصية بتفاصيل دقيقة مع إمكانية التحكم في التوجيهات الإيجابية والسلبية.", bestFor: "صور المنتجات، والصور الشخصية، والرسومات التصورية، وصور التسويق." },
                    { name: "نسبة العرض إلى الارتفاع المُسبقة نسب العرض", desc: "أبعاد إخراج جاهزة أفقية، وعمودية، ومربعة.", bestFor: "منشورات وسائل التواصل الاجتماعي، واللافتات، والملصقات، والصور المصغرة." },
                    { name: "حجم صورة مخصص", desc: "العرض والارتفاع الدقيقان من 512 إلى 2048 بمضاعفات العدد 64.", bestFor: "فتحات تخطيط ومشاريع تتطلب أبعاد بكسل دقيقة." }
                ],
                controlsTitle: "اختر عناصر التحكم المناسبة وحجم الصورة",
                controlsIntro: "استخدم موجهًا سلبيًا لتقليل التفاصيل غير المرغوب فيها، ثم حدد نسبة عرض إلى ارتفاع محددة مسبقًا أو أدخل أبعادًا مخصصة للقناة المقصودة.",
                galleryTitle: "المزيد من أمثلة صور Stable Diffusion 3.5",
                discussionTitle: "أسئلة شائعة حول تقنية Stable Diffusion 3.5",
                communityTitle: "طرق شائعة للإنشاء باستخدام Stable Diffusion 3.5",
                tutorialPrompt: "صورة فوتوغرافية لمنتج تحريري عبارة عن مكبر صوت خزفي منحوت على حجر فاتح اللون، بإضاءة نافذة صباحية ناعمة، وملمس واقعي، وتكوين متوازن، وظلال خفيفة، وخلفية نظيفة.",
                qualityBenefits: [
                    "استخدم التوجيهات السلبية لتقليل الفوضى والتفاصيل المشوهة والأنماط البصرية غير المرغوب فيها.",
                    "اتبع الأوصاف المتدرجة للموضوع، والتكوين، والإضاءة، والمواد، والحالة المزاجية.",
                    "أنشئ صورًا أفقية وعمودية ومربعة باستخدام إعدادات مسبقة أو أبعاد مخصصة دقيقة."
                ],
                features: [
                    { name: "التحكم في مطالبة النسخ السلبي", short: "حدد ما يجب استبعاده للحصول على نتائج أنظف وأكثر دقة.", desc: "يدعم مُولِّد الصور بتقنية الذكاء الاصطناعي Stable Diffusion 3.5 خاصية التنبيه السلبي المُخصصة، مما يُتيح لك تحديد ما يجب على النموذج تجنبه، مثل انخفاض الوضوح، أو تشوه اليدين، أو الخلفية المزدحمة. يمنحك هذا تحكمًا أدق في الصورة النهائية ويُقلل الحاجة إلى إعادة المعالجة بشكل متكرر.", demo: { type: 'table', rows: [
                        { prompt: "صورة منتج فاخرة لمزهرية خزفية سوداء غير لامعة موضوعة على قاعدة رخامية، بإضاءة استوديو ناعمة وخلفية نظيفة. (السلبيات: خلفية مزدحمة، دقة منخفضة، انعكاسات مشوهة).", image: require('@/assets/images/stableDiffusion/1783501013638.webp') },
                        { prompt: "صورة لشاب في ضوء نافذة ناعم، ببشرة ذات ملمس طبيعي، وعمق مجال ضحل. (السلبيات: بشرة ناعمة بشكل مفرط، مظهر شمعي، ألوان مشبعة بشكل مفرط.)", image: require('@/assets/images/stableDiffusion/1783501332038.webp') }
                    ] } },
                    { name: "نسب أبعاد مرنة", short: "اختر حجمًا أفقيًا أو رأسيًا أو مربعًا أو حجمًا مخصصًا.", desc: "اختر من بين نسب العرض إلى الارتفاع الجاهزة مثل 1024×1024، و1280×1280، و896×1536، و1536×896، و768×1344، و1344×768، و1024×1536، و1536×1536، أو أدخل حجمًا مخصصًا من 512×512 إلى 2048×2048. هذا يجعل مولد النصوص إلى الصور Stable Diffusion 3.5 مناسبًا للبنرات والملصقات ومنشورات وسائل التواصل الاجتماعي والصور المصغرة المربعة على حد سواء.", prompt: "لقطة سينمائية واسعة لمنظر طبيعي لجرف ساحلي في وقت الغروب، مع سحب درامية وتفاصيل صخرية دقيقة، 1536×896.", image: require('@/assets/images/stableDiffusion/1783501396803.webp') },
                    { name: "أحجام صور مخصصة", short: "ضبط أبعاد البكسل بدقة للحصول على مخرجات دقيقة. تحديد أبعاد البكسل بدقة للحصول على مخرجات دقيقة.", desc: "عندما لا يتناسب الإعداد المسبق، قم بالتبديل إلى حجم مخصص وأدخل أي عرض وارتفاع من 512 إلى 2048 بمضاعفات 64. يتيح لك هذا مطابقة تخطيط معين أو فتحة لافتة أو نسبة عرض إلى ارتفاع الطباعة دون الحاجة إلى قص يدوي.", prompt: "خلفية ملصق بسيطة بتصميم هندسي مركزي، وتدرج لوني أزرق داكن، وحبيبات دقيقة، 1280×1280.", image: require('@/assets/images/stableDiffusion/0217835023294345bd2f0b9e6315ce45b86fb4e22ec7496156d5f_0.webp') },
                    { name: "فهم تفصيلي للمطالبة", short: "يتبع وصفًا مُفصَّلًا للموضوع والإضاءة والأسلوب.", desc: "يقرأ برنامج Stable Diffusion 3.5 تعليمات النصوص المتراكبة ويُجسّد الموضوع والإعداد والإضاءة والمزاج الذي تصفه. اجمع بين توجيه إيجابي واضح وتوجيه سلبي لتحقيق نتيجة أقرب إلى هدفك بأقل عدد من المحاولات.", demo: { type: 'table', rows: [
                        { prompt: "صورة منتج تحريرية لساعة يد بجانب قطعة قماش كتان مطوية وكوب خزفي، تكوين مثلث متوازن، ضوء صباحي ناعم.", image: require('@/assets/images/stableDiffusion/1783501741652.webp') },
                        { prompt: "ركن قراءة مريح بجوار نافذة ممطرة، ضوء مصباح دافئ، كتب مكدسة، بطانية ذات ملمس مميز، أجواء سينمائية.", image: require('@/assets/images/stableDiffusion/1783501817217.webp') }
                    ] } },
                    { name: "تفاصيل دقيقة وواقعية", short: "إنشاء إضاءة ومواد وعمق واقعي.", desc: "ينتج برنامج Stable Diffusion 3.5 نسيجًا دقيقًا وإضاءة واقعية وعمقًا طبيعيًا، مما يجعل مولد الصور بالذكاء الاصطناعي Stable Diffusion 3.5 مناسبًا تمامًا لتصوير المنتجات والصور الشخصية والفن المفاهيمي والصور التحريرية حيث تكون المصداقية مهمة.", prompt: "صورة مقربة لفنانة خزفية مسنة في ورشة عمل مضاءة بأشعة الشمس، ملمس طبيعي للبشرة، غبار الطين على اليدين، ضوء نافذة دافئ، عمق مجال ضحل.", image: require('@/assets/images/stableDiffusion/021783502374347ebd7c24e3cae4a4b683f52566c3e30e2cb26b5_0.webp') }
                ],
                showcaseKicker: "أمثلة توضيحية",
                showcaseTitle: "أمثلة على مُوجِّهات الانتشار المستقر 3.5 لتحسين صور الذكاء الاصطناعي",
                showcaseIntro: "استخدم أمثلة التوجيهات هذه من برنامج Stable Diffusion 3.5 كنقطة انطلاق. صف الموضوع والتكوين والإضاءة والأسلوب بوضوح، واربط كل توجيه بتوجيه سلبي، ثم أرسله مباشرة إلى المُولِّد.",
                useCasesKicker: "مصمم للاستخدام العملي",
                useCasesTitle: "أمثلة شائعة لاستخدام Stable Diffusion 3.5",
                useCases: [
                    { name: "Stable Diffusion 3.5 لتصوير المنتجات", desc: "قم بإنشاء صور منتجات نظيفة بخلفيات مضبوطة باستخدام عبارات سلبية لإزالة الفوضى." },
                    { name: "Stable Diffusion 3.5 للتسويق", desc: "قم بإنشاء مفاهيم الحملات الإعلانية، والإعلانات على وسائل التواصل الاجتماعي، واللافتات الإعلانية عبر نسب أبعاد متعددة." },
                    { name: "Stable Diffusion 3.5 للملصقات والتصاميم", desc: "إنتاج خلفيات ملصقات وصور جاهزة للتصميم بأبعاد بكسل مخصصة." },
                    { name: "Stable Diffusion 3.5 للصور الشخصية", desc: "قم بإنشاء صور شخصية مفصلة بنسيج بشرة طبيعي، باستخدام محفزات سلبية لتجنب التشوهات." },
                    { name: "Stable Diffusion 3.5 للرسومات المفاهيمية", desc: "استكشف الشخصيات والبيئات والاتجاهات البصرية باستخدام عناصر توجيهية متعددة الطبقات." },
                    { name: "Stable Diffusion 3.5 لمحتوى وسائل التواصل الاجتماعي", desc: "أنشئ صورًا مربعة وعمودية وأفقية بأحجام مناسبة لمنصات التواصل الاجتماعي المختلفة." }
                ],
                howToKicker: "ثلاثة بسيطة الخطوات",
                howToTitle: "كيفية استخدام مولد الصور Stable Diffusion 3.5 AI عبر الإنترنت",
                howToIntro: "استخدم مولد الصور بالذكاء الاصطناعي Stable Diffusion 3.5 عبر الإنترنت على Miral مع موجه واضح، وموجه سلبي، ونسبة العرض إلى الارتفاع التي يحتاجها مشروعك.",
                howToSteps: [
                    { title: "أدخل مطالبتك الرئيسية", desc: "صف الموضوع المطلوب، والمشهد، والتكوين، والإضاءة، والأسلوب، والتفاصيل البصرية." },
                    { title: "ضبط عناصر التحكم في الإنشاء", desc: "أضف مطالبة سلبية إذا لزم الأمر، ثم اختر نسبة عرض إلى ارتفاع جاهزة أو أدخل حجمًا مخصصًا." },
                    { title: "إنشاء ومراجعة", desc: "ابدأ عملية الإنشاء، راجع النتيجة، وقم بتنزيل الصورة أو اضبط موجه الأوامر لإجراء عملية أخرى." }
                ],
                howToCta: "جرّب مُولّد الصور المدعوم بالذكاء الاصطناعي Stable Diffusion 3.5",
                faqTitle: "الأسئلة الشائعة حول Stable Diffusion 3.5",
                faqs: [
                    { q: "ما هو مولد الصور Stable Diffusion 3.5 المدعوم بالذكاء الاصطناعي؟", a: "Stable Diffusion 3.5 هو نموذج لتحويل النصوص إلى صور من شركة Stability AI. يقوم مولد الصور Stable Diffusion 3.5 بتقنية الذكاء الاصطناعي بتحويل النصوص المكتوبة إلى صور مفصلة، ​​وهو متوفر على منصة Miral للاستخدام في مجالات الفن والتصميم والتسويق وإنشاء الصور المرئية للمنتجات مباشرةً من متصفحك." },
                    { q: "ما الأداة التي يمكنني استخدامها لإنشاء صور بأحجام مخصصة مع توجيهات سلبية؟", a: "يوفر برنامج Stable Diffusion 3.5 موجهًا سلبيًا مخصصًا، ونسب عرض إلى ارتفاع جاهزة، وأحجامًا مخصصة من 512 إلى 2048 لتصوير المنتجات، والصور التسويقية، والصور الشخصية، والفن المفاهيمي." },
                    { q: "هل يمكنني استخدام مولد الصور بالذكاء الاصطناعي Stable Diffusion 3.5 مجاناً؟", a: "نعم. سجّل الآن لتحصل على رصيد مجاني وابدأ فوراً بإنشاء صور عالية الجودة باستخدام مولد الصور الذكي Stable Diffusion 3.5. يتم استخدام الرصيد المخصص لإنشاء الصور." },
                    { q: "كيف أستخدم مولد الصور بالذكاء الاصطناعي Stable Diffusion 3.5 عبر الإنترنت؟", a: "أدخل نصًا تفصيليًا، ويمكنك إضافة ملاحظة سلبية تصف ما يجب تجنبه، ثم اختر نسبة عرض إلى ارتفاع جاهزة أو أدخل حجمًا مخصصًا، وانقر على \"إنشاء\". يُعدّ برنامج Stable Diffusion 3.5 مثاليًا للمواد التسويقية، وتصوير المنتجات، والصور الشخصية، وتصميمات الملصقات." },
                    { q: "كيفية إصلاح التفاصيل غير المرغوب فيها أو المشوهة في صور Stable Diffusion 3.5؟", a: "أضف تنبيهًا سلبيًا يصف العناصر التي لا ترغب بها، مثل انخفاض الوضوح، أو تشوه اليدين، أو الخلفية المزدحمة. يستخدم برنامج Stable Diffusion 3.5 هذا التنبيه لتوجيه عملية التوليد بعيدًا عن هذه النتائج." },
                    { q: "ما الأحجام ونسب العرض إلى الارتفاع التي يدعمها برنامج Stable Diffusion 3.5؟", a: "يوفر برنامج Stable Diffusion 3.5 على منصة Miral نسب عرض جاهزة مثل 1024×1024، و1280×1280، و896×1536، و1536×896، و768×1344، و1344×768، و1024×1536، و1536×1536، بالإضافة إلى حجم مخصص من 512×512 إلى 2048×2048 بمضاعفات العدد 64. ويشمل ذلك مخرجات أفقية وعمودية ومربعة للبنرات والملصقات ومنشورات وسائل التواصل الاجتماعي والصور المصغرة." },
                    { q: "ما هي أفضل أمثلة مُوجِّهات الانتشار المستقر 3.5؟", a: "تُقدّم إرشادات برنامج Stable Diffusion 3.5 الفعّالة وصفًا واضحًا للموضوع، والإعداد، والتكوين، والإضاءة، والأسلوب، ثمّ تُقرن بإرشاد إيجابي بإرشاد سلبي لإزالة التفاصيل غير المرغوب فيها. استخدم أمثلة إرشادات Stable Diffusion 3.5 الموجودة في هذه الصفحة كنقطة انطلاق، وقم بتخصيصها لمشروعك." },
                    { q: "Stable Diffusion 3.5 vs Midjourney: أيهما يجب أن أستخدم؟", a: "اختر بناءً على سير العمل بدلاً من اختيار الأفضل للجميع. يُعدّ Stable Diffusion 3.5 خيارًا مثاليًا عندما تحتاج إلى توجيهات سلبية واضحة، ونسب عرض إلى ارتفاع جاهزة، وأحجام بكسل مخصصة في مُولّد قائم على المتصفح على منصة Miral. أما Midjourney فقد يُناسب المبدعين الذين يُفضّلون سير العمل الفني المُميّز وأدوات التواصل المجتمعي." }
                ],
                ctaTitle: "جرّب برنامج Stable Diffusion 3.5 مجاناً على موقع Miral!",
                ctaDesc: "أدخل فكرتك أعلاه واستخدم مولد الصور بالذكاء الاصطناعي Stable Diffusion 3.5 مع مطالبات سلبية وأحجام مرنة لإنشاء صور مرئية يتم التحكم فيها."
            },
            zImageTurbo: {
                title: "مولد صور Z Image Turbo AI مجاني عبر الإنترنت | ميرال",
                description: "أنشئ صورًا عالية الجودة بتقنية الذكاء الاصطناعي عبر الإنترنت باستخدام Z Image Turbo. قم بتوسيع نطاق التوجيهات، واختر نسب العرض إلى الارتفاع المرنة، وحدد أبعادًا مخصصة، وتحكم في البذور على Miral.",
                heroHeadline: "مولد صور الذكاء الاصطناعي Z Image Turbo",
                heroIntro: "استخدم مولد الصور Z Image Turbo AI مجانًا على منصة Miral AI. سجّل الآن لتحصل على رصيد مجاني، وأنشئ صورًا عالية الجودة بسرعة مع إمكانية التمديد الفوري، ونسب العرض إلى الارتفاع المرنة، والتحكم في حجم الصور.",
                eyebrow: "تسريع الصورة Z",
                sectionKicker: "تسريع الصورة Z",
                ctaTag: "Z Image Turbo · Miral",
                badges: ["تحويل النص إلى صورة", "توسيع المطالبة", "نسب أبعاد مرنة", "حجم مخصص", "التحكم في البذور"],
                previewLabel: "تسريع الصورة Z",
                previewMeta: ["1:1", "٥١٢ – ٢٠٤٨", "التحكم في البذور"],
                previewTitle: "من مُطالبة قصيرة إلى صورة مصقولة وعالية الدقة",
                previewDesc: "دع التوسع السريع يثري فكرة موجزة، واختر نسبة العرض إلى الارتفاع المناسبة، وأعد استخدام عنصر أساسي للحفاظ على أسلوب متسق عبر الصور.",
                keyFeaturesTitle: "أنشئ صورًا مصقولة باستخدام مولد تحويل النص إلى صورة Z Image Turbo",
                keyFeaturesIntro: "استكشف الميزات الرئيسية لمولد الصور Z Image Turbo AI من أجل التمديد السريع، ونسب العرض إلى الارتفاع المرنة، والأحجام المخصصة، والاتساق القائم على البذور.",
                exploreTitle: "استكشف المزيد من نماذج الصور المدعومة بالذكاء الاصطناعي",
                mainFeaturesTitle: "الميزات الرئيسية لـ Z Image Turbo",
                generatedImageLabel: "صورة مُولّدة",
                versionLabel: "تحكم",
                featureLabel: "ما الذي يتغير؟",
                useCaseLabel: "الأفضل لـ",
                variantsTitle: "عناصر تحكم Z Image Turbo لإنشاء الصور",
                variantsIntro: "اجمع بين التمديد السريع والأبعاد المرنة والتحكم في البذور وفقًا لمقدار التفاصيل والاتساق البصري الذي يحتاجه مشروعك.",
                variants: [
                    { name: "تسريع الصورة Z", desc: "تحويل سريع للنصوص إلى صور مع إخراج عالي الدقة بتفاصيل دقيقة.", bestFor: "صور المنتجات، والصور الشخصية، والرسومات التصورية، وصور التسويق." },
                    { name: "توسيع المطالبة", desc: "إثراء تلقائي للعبارات القصيرة بتفاصيل بصرية إضافية.", bestFor: "تحويل الأفكار السريعة إلى تعليمات إنشاء أكثر اكتمالاً. تحويل الأفكار السريعة إلى تعليمات إنشاء أكثر شمولاً." },
                    { name: "التحكم في البذور", desc: "يُعيد استخدام نفس البذرة الأولية أثناء تحسين الإعدادات الأخرى.", bestFor: "الحفاظ على نمط متناسق عبر مختلف الصور أو الحملات." }
                ],
                controlsTitle: "اختر الإعدادات المناسبة من حيث الموجه والحجم والقيمة الأولية",
                controlsIntro: "قم بتمكين التمديد الفوري عندما تحتاج الفكرة إلى مزيد من التفاصيل، واختر أبعاد الإخراج المقصودة، وأعد استخدام بذرة عندما يكون التناسق البصري مهمًا.",
                galleryTitle: "المزيد من أمثلة Z Image Turbo",
                discussionTitle: "أسئلة شائعة حول Z Image Turbo",
                communityTitle: "طرق شائعة للإنشاء باستخدام Z Image Turbo",
                tutorialPrompt: "دراجة كهربائية صغيرة الحجم معروضة في استوديو معماري مضاء، أرضية خرسانية فاتحة اللون، فتحة سقف ناعمة، تصوير منتج متقن، تكوين متوازن، مواد واقعية.",
                qualityBenefits: [
                    "حوّل الأفكار القصيرة إلى عناصر توجيهية أكثر ثراءً دون الحاجة إلى إعادة كتابة كل تفاصيلها البصرية يدويًا.",
                    "اختر أبعادًا أفقية أو عمودية أو مربعة أو أبعادًا مخصصة دقيقة للقناة النهائية.",
                    "أعد استخدام عنصر أساسي للحفاظ على اتساق الإضاءة والألوان والتكوين عبر التكرارات."
                ],
                features: [
                    { name: "توسيع المطالبة", short: "إمكانية توسيع نص قصير إلى تفاصيل أكثر.", desc: "قم بتفعيل خاصية إضافة التفاصيل إلى الموجه، وسيقوم برنامج Z Image Turbo تلقائيًا بإثراء الموجه القصير بتفاصيل إضافية قبل إنشائه. يساعد هذا في إنتاج صور أكثر اكتمالًا ووضوحًا للموجهات القصيرة أو البسيطة دون الحاجة إلى إعادة كتابتها يدويًا.", demo: { type: 'table', rows: [
                        { prompt: "بيت زجاجي مليء بالنباتات الاستوائية على سطح المريخ.", image: require('@/assets/images/zImageTurbo/b1057f7b-3e0e-9687-aa55-56cfed42147a0.webp') },
                        { prompt: "مخبز حرفي صغير مبني داخل عربة قطار عتيقة.", image: require('@/assets/images/zImageTurbo/a8dbab92-cfb4-928b-bd20-4f01835aa0ac0.webp') }
                    ] } },
                    { name: "نسب أبعاد مرنة", short: "اختر حجمًا أفقيًا أو رأسيًا أو مربعًا أو حجمًا مخصصًا.", desc: "اختر من بين نسب العرض إلى الارتفاع الجاهزة مثل 1024×1024، و1280×1280، و864×1536، و1536×864، و720×1280، و1280×720، و1024×1536، و1536×1536، أو أدخل حجمًا مخصصًا من 512×512 إلى 2048×2048. هذا يجعل مولد تحويل النصوص إلى صور Z Image Turbo مناسبًا للبنرات والملصقات ومنشورات وسائل التواصل الاجتماعي والصور المصغرة المربعة على حد سواء.", prompt: "صورة جوية فائقة الاتساع لسوق ليلي في طوكيو تحت المطر، فوانيس ورقية متوهجة، أكشاك طعام مزدحمة، شوارع عاكسة، أجواء سينمائية، 1536×864.", image: require('@/assets/images/zImageTurbo/b2964bd5-066f-90b6-8c86-91dad79e44120.webp') },
                    { name: "أحجام صور مخصصة", short: "ضبط أبعاد البكسل بدقة للحصول على مخرجات دقيقة. تحديد أبعاد البكسل بدقة للحصول على مخرجات دقيقة.", desc: "عندما لا يتناسب الإعداد المسبق، قم بالتبديل إلى حجم مخصص وأدخل أي عرض وارتفاع من 512 إلى 2048. يتيح لك هذا مطابقة تخطيط معين أو خانة لافتة أو نسبة عرض إلى ارتفاع الطباعة دون الحاجة إلى قص يدوي.", prompt: "ملصق عمودي لمعرض نباتي، طباعة برتقالية كبيرة الحجم، أوراق استوائية نادرة، نسيج ورقي دافئ بلون أبيض مائل للصفرة، شبكة تحريرية دقيقة، 1152×1728.", image: require('@/assets/images/zImageTurbo/2d5a0c7e-3ef6-9433-be0d-606be80f99e80.webp') },
                    { name: "التحكم في البذور لضمان الاتساق", short: "أعد استخدام عنصر أساسي للحفاظ على نمط ثابت في جميع الصور.", desc: "حدد قيمة ثابتة للبذرة (من 0 إلى 2147483647)، وسيعتمد مولد الصور Z Image Turbo AI على نفس نقطة البداية في كل مرة، مما يُسهّل الحفاظ على مظهر متناسق أثناء تحسين التعليمات. اترك البذرة عند 0 للحصول على نتيجة عشوائية جديدة في كل مرة.", prompt: "حملة منسقة للعناية بالبشرة تتميز بثلاث زجاجات زجاجية مصنفرة على حجر أخضر باهت، وإضاءة ناعمة منتشرة، ولمسات من الأوكالبتوس - إعادة استخدام نفس البذرة للحفاظ على الإضاءة واللوحة والتركيبة عبر سلسلة المنتجات.", image: require('@/assets/images/zImageTurbo/f688ab6d-a723-969d-8df1-fbac721e66350.webp') },
                    { name: "تفاصيل دقيقة وواقعية", short: "إنشاء إضاءة ومواد وعمق واقعي.", desc: "ينتج برنامج Z Image Turbo نسيجًا دقيقًا وإضاءة واقعية وعمقًا طبيعيًا، مما يجعله مناسبًا تمامًا لتصوير المنتجات والصور الشخصية والفن المفاهيمي والصور التحريرية حيث تكون المصداقية مهمة.", prompt: "لقطة مقرّبة من فيلم وثائقي لصانع كمان ينحت جسراً من خشب القيقب في ورشة عمل هادئة، نشارة خشب ناعمة، أدوات يدوية بالية، ملمس جلد طبيعي، ضوء نافذة شمالية ناعم، عمق مجال ضحل.", image: require('@/assets/images/zImageTurbo/715e19f5-fea4-9361-a1e3-0f04d595db660.webp') }
                ],
                showcaseKicker: "أمثلة توضيحية",
                showcaseTitle: "أمثلة على مُطالبات Z Image Turbo للحصول على صور ذكاء اصطناعي أفضل",
                showcaseIntro: "استخدم أمثلة Z Image Turbo هذه كنقطة انطلاق. صف الموضوع والتكوين والإضاءة والأسلوب بوضوح، ويمكنك تفعيل خاصية توسيع التعليمات، ثم أرسلها مباشرةً إلى المُولِّد.",
                useCasesKicker: "مصمم للاستخدام العملي",
                useCasesTitle: "أمثلة شائعة لاستخدام Z Image Turbo",
                useCases: [
                    { name: "Z Image Turbo لتصوير المنتجات", desc: "قم بإنشاء صور منتجات نظيفة بخلفيات مضبوطة ونقطة بداية ثابتة للحصول على مظهر متناسق." },
                    { name: "Z Image Turbo للتسويق", desc: "قم بإنشاء مفاهيم الحملات الإعلانية، والإعلانات على وسائل التواصل الاجتماعي، واللافتات الإعلانية عبر نسب أبعاد متعددة." },
                    { name: "Z Image Turbo للملصقات والتصاميم", desc: "إنتاج خلفيات ملصقات وصور جاهزة للتصميم بأبعاد بكسل مخصصة." },
                    { name: "Z Image Turbo للصور الشخصية", desc: "أنشئ صورًا شخصية مفصلة بتفاصيل دقيقة، مع ملمس بشرة طبيعي وإضاءة واقعية." },
                    { name: "Z Image Turbo للرسومات المفاهيمية", desc: "استكشف الشخصيات والبيئات والاتجاهات البصرية باستخدام عناصر توجيهية متعددة الطبقات." },
                    { name: "Z Image Turbo للمحتوى الاجتماعي", desc: "أنشئ صورًا مربعة وعمودية وأفقية بأحجام مناسبة لمنصات التواصل الاجتماعي المختلفة." }
                ],
                howToKicker: "ثلاثة بسيطة الخطوات",
                howToTitle: "كيفية استخدام مولد الصور Z Image Turbo AI عبر الإنترنت",
                howToIntro: "استخدم مولد الصور Z Image Turbo AI عبر الإنترنت على Miral مع موجه واضح، وامتداد موجه اختياري، ونسبة العرض إلى الارتفاع التي يحتاجها مشروعك.",
                howToSteps: [
                    { title: "أدخل مطالبتك الرئيسية", desc: "صف الموضوع المطلوب، والمشهد، والتكوين، والإضاءة، والأسلوب، والتفاصيل البصرية." },
                    { title: "ضبط عناصر التحكم في الإنشاء", desc: "يمكنك اختيارياً تفعيل خاصية تمديد الموجه، واختيار نسبة عرض إلى ارتفاع جاهزة أو إدخال حجم مخصص، وتعيين قيمة أولية إذا كنت تريد التناسق." },
                    { title: "إنشاء ومراجعة", desc: "ابدأ عملية الإنشاء، راجع النتيجة، وقم بتنزيل الصورة أو اضبط موجه الأوامر لإجراء عملية أخرى." }
                ],
                howToCta: "جرّب مولد الصور بالذكاء الاصطناعي Z Image Turbo",
                faqTitle: "الأسئلة الشائعة حول Z Image Turbo",
                faqs: [
                    { q: "ما هو مولد الصور Z Image Turbo AI؟", a: "Z Image Turbo هو نموذج لتحويل النصوص إلى صور عالية الدقة. يقوم مولد الصور Z Image Turbo المدعوم بالذكاء الاصطناعي بتحويل النصوص المكتوبة إلى صور مفصلة، ​​وهو متوفر على منصة Miral للاستخدام في مجالات الفن والتصميم والتسويق وإنشاء الصور المرئية للمنتجات مباشرةً من متصفحك." },
                    { q: "ما الأداة التي يمكنني استخدامها لإنشاء سلسلة متناسقة من صور المنتجات؟", a: "يجمع برنامج Z Image Turbo بين التمديد السريع وأحجام الصور المرنة والتحكم في البذور للمساعدة في إنشاء سلسلة متسقة من صور المنتجات أو الصور التسويقية المرئية." },
                    { q: "هل يمكنني استخدام مولد الصور Z Image Turbo AI مجاناً؟", a: "نعم. سجّل الآن لتحصل على رصيد مجاني وابدأ بإنشاء صور عالية الجودة باستخدام مولد الصور Z Image Turbo AI فورًا. يتم استخدام الرصيد المخصص لإنشاء الصور." },
                    { q: "كيف أستخدم مولد الصور Z Image Turbo AI عبر الإنترنت؟", a: "أدخل نصًا تفصيليًا، ويمكنك تفعيل خاصية توسيع النص، واختيار نسبة عرض إلى ارتفاع جاهزة أو إدخال حجم مخصص، وتحديد حجم أساسي إذا كنت ترغب في مظهر متناسق، ثم انقر على \"إنشاء\". يُعدّ برنامج Z Image Turbo مثاليًا للمواد التسويقية، وتصوير المنتجات، والصور الشخصية، وتصميمات الملصقات." },
                    { q: "ما هي ميزة \"امتداد الموجه\" في Z Image Turbo؟", a: "يُعدّ خيار \"توسيع المطالبات\" مفتاحًا اختياريًا يسمح لبرنامج Z Image Turbo بإثراء المطالبات القصيرة أو البسيطة تلقائيًا بتفاصيل إضافية قبل إنشائها. يساعد هذا الخيار المستخدمين غير المتخصصين على إنتاج صور أكثر اكتمالًا ووضوحًا دون الحاجة إلى إعادة كتابتها يدويًا." },
                    { q: "كيفية إصلاح النتائج غير المتناسقة في Z Image Turbo؟", a: "استخدم نفس البذرة مع تحسين المعايير الأخرى للمساعدة في الحفاظ على نمط متسق عبر الصور. اترك البذرة عند 0 فقط عندما تريد نتيجة جديدة وعشوائية في كل مرة." },
                    { q: "ما هي الأحجام ونسب العرض إلى الارتفاع التي يدعمها برنامج Z Image Turbo؟", a: "يوفر برنامج Z Image Turbo على منصة Miral نسب عرض جاهزة مثل 1024×1024، و1280×1280، و864×1536، و1536×864، و720×1280، و1280×720، و1024×1536، و1536×1536، بالإضافة إلى حجم مخصص من 512×512 إلى 2048×2048. ويشمل ذلك مخرجات أفقية وعمودية ومربعة للبنرات والملصقات ومنشورات وسائل التواصل الاجتماعي والصور المصغرة." },
                    { q: "ما هي أفضل أمثلة مُطالبات Z Image Turbo؟", a: "تُقدّم مُطالبات Z Image Turbo الفعّالة وصفًا واضحًا للموضوع، والإعداد، والتكوين، والإضاءة، والأسلوب. وللحصول على أفكار مختصرة، فعّل خاصية توسيع المُطالبات ليُثري النموذج المُطالبات تلقائيًا. استخدم أمثلة مُطالبات Z Image Turbo الموجودة في هذه الصفحة كنقطة انطلاق، وقم بتخصيصها لمشروعك." }
                ],
                ctaTitle: "جرّب برنامج Z Image Turbo مجاناً على موقع Miral!",
                ctaDesc: "أدخل فكرتك أعلاه واستخدم مولد الصور Z Image Turbo AI مع خاصية التمديد الفوري، والأحجام المرنة، والتحكم في البذور لإنشاء صور مصقولة."
            },
            midjourney: {
                title: "مولد صور الذكاء الاصطناعي Midjourney مجاني عبر الإنترنت | ميرال",
                description: "أنشئ فنًا باستخدام الذكاء الاصطناعي عبر الإنترنت مع Midjourney على منصة Miral AI. اختر بين الأساليب الواقعية أو أسلوب الأنمي، واستعن بالصور المرجعية لتوجيه النتائج، وحوّل النصوص إلى صور مرئية نابضة بالحياة.",
                heroHeadline: "مولد صور الذكاء الاصطناعي Midjourney",
                heroIntro: "استخدم مولد الصور Midjourney AI مجانًا على منصة Miral AI. سجّل الآن لتحصل على رصيد مجاني، وابدأ فورًا بإنشاء صور عالية الجودة بأسلوب واقعي أو مستوحى من الأنمي، مع إمكانية الاستعانة بصور مرجعية.",
                eyebrow: "رحلة متوسطة",
                sectionKicker: "رحلة متوسطة",
                ctaTag: "رحلة منتصف الطريق · ميرال",
                badges: ["تحويل النص إلى صورة", "أنماط واقعية وأنماط أنمي", "إرشادات الصورة المرجعية", "التوجيه الفني"],
                previewLabel: "رحلة متوسطة",
                previewMeta: ["واقعي", "أنمي", "حتى 5 مراجع"],
                previewTitle: "من فكرة واضحة إلى صورة سينمائية ذات إخراج فني.",
                previewDesc: "اختر أسلوبًا، وصف الحالة المزاجية والإضاءة، ودع Midjourney تشكل المظهر الفني لمفهومك أو ملصقك أو شخصيتك.",
                keyFeaturesTitle: "أنشئ صورًا فنية موجهة باستخدام مولد النصوص إلى الصور من Midjourney",
                keyFeaturesIntro: "استكشف الميزات الرئيسية لمولد الصور بتقنية الذكاء الاصطناعي Midjourney لتغيير الأنماط، والتوجيه بالصور المرجعية، والتوجيه الفني الغني.",
                features: [
                    { name: "أنماط واقعية وأنماط أنمي", short: "بدّل النمط المرئي بنقرة واحدة.", desc: "يُتيح مُولّد الصور بتقنية الذكاء الاصطناعي Midjourney على منصة Miral نمطين جاهزين: الواقعي والأنمي. اختر النمط الواقعي للحصول على تفاصيل فوتوغرافية وإضاءة طبيعية وقوام واقعي، أو اختر نمط الأنمي للحصول على خطوط أنيقة وألوان جريئة ولمسة فنية تُحاكي الرسم اليدوي. يتم اختيار النمط من اللوحة، مما يسمح لك بالتركيز على المشهد نفسه.", demo: { type: 'table', rows: [
                        { prompt: "مسافر وحيد يقف على حافة سلسلة جبال ضبابية عند شروق الشمس، ضوء ثلاثي الأبعاد، لقطة سينمائية واسعة، تفاصيل دقيقة للنسيج والصخور.", image: require('@/assets/images/midjourney/1783505533006329.webp') },
                        { prompt: "مبارزة شابة مصممة على سطح أحد المباني عند الغسق، شعرها منسدل، وفوانيسها متوهجة، وخطوطها معبرة بأسلوب الأنمي، وتظليلها نابض بالحياة.", image: require('@/assets/images/midjourney/45f1eae9-39b9-4cc9-8a4e-e597aa4d344b.webp') }
                    ] } },
                    { name: "إرشادات الصورة المرجعية", short: "حمّل ما يصل إلى خمس صور لتحديد المظهر.", desc: "قم بتوجيه مولد الصور بتقنية الذكاء الاصطناعي Midjourney باستخدام ما يصل إلى خمس صور مرجعية (PNG أو JPG أو JPEG أو WebP). استخدمها لنقل لوحة الألوان، أو مظهر الشخصية، أو شكل المنتج، أو المظهر الجمالي العام، بحيث تبقى النتيجة أقرب إلى التوجيه المرجعي بدلاً من الاعتماد على النص فقط.", prompt: "صورة منتج فاخرة لمزهرية خزفية سوداء غير لامعة على قاعدة رخامية، بإضاءة استوديو ناعمة، وخلفية نظيفة، تتناسب مع الحالة المزاجية ولوحة الألوان للمراجع التي تم تحميلها.", image: require('@/assets/images/midjourney/1783506116812275.webp') },
                    { name: "إضاءة وأجواء سينمائية", short: "أضف لمسةً دراميةً من الإضاءة والجو والعمق. ابتكر إضاءةً وأجواءً وعمقاً درامياً.", desc: "تشتهر شركة ميدجورني بإضاءتها الفنية المميزة وأجوائها الساحرة. فعند وصف ساعة الغروب الذهبية، أو توهج النيون، أو الضباب، أو الإضاءة الخافتة، أو ضوء الشموع، يميل النموذج إلى مظهر سينمائي يناسب الملصقات، والرسومات الرئيسية، والتصاميم المفاهيمية.", demo: { type: 'table', rows: [
                        { prompt: "زقاق مضاء بأضواء النيون غارق بالمطر ليلاً، برك ماء عاكسة، تأثير بوكيه ناعم من لافتات بعيدة، جو سينمائي كئيب، وشخصية واحدة تحمل مظلة.", image: require('@/assets/images/midjourney/1783506281563151.webp') },
                        { prompt: "صورة فوتوغرافية لموسيقي على سطح مبنى في وقت الغروب، بإضاءة خلفية دافئة، وتوهج عدسة، وعمق مجال ضحل، وحبيبات فيلم.", image: require('@/assets/images/midjourney/1783506420066100.webp') }
                    ] } },
                    { name: "رسومات الشخصيات والمفاهيم الفنية", short: "أنشئ شخصيات وعوالم معبرة.", desc: "يُعدّ مولد النصوص إلى الصور من Midjourney خيارًا مثاليًا لتصميم الشخصيات، ومشاهد الخيال، والرسومات التصورية. صف وضعية الشخصية، وملابسها، وتعبير وجهها، ومكانها، ثم اختر أسلوبًا، وكرر العملية حتى تحصل على المظهر المطلوب.", prompt: "خيميائي متجول يرتدي عباءة سفر متعددة الطبقات، يحمل فانوسًا نحاسيًا وقوارير متوهجة، مسار غابة قديم، ضوء مرقط، تفاصيل زي معقدة.", image: require('@/assets/images/midjourney/1783506547640511.webp') },
                    { name: "ملصقات وفنون تحريرية", short: "ابتكر تصميمات جذابة ورسومات رئيسية مميزة. أنتج تصميمات جذابة ورسومات رئيسية مميزة.", desc: "من الصور الرئيسية للحملات الإعلانية إلى الرسوم التوضيحية التحريرية، تُبدع ميدجورني تركيبات جريئة وجمالية راقية. اربط موضوعًا محوريًا واضحًا بجوٍّ مُحدد، ودع العارضة تُقدم صورًا فنية مُوجهة للاستخدام التسويقي والتحريري.", prompt: "صورة رئيسية جريئة للحملة تُظهر طائرًا طنانًا يحوم فوق زهرة استوائية متوهجة، وألوانًا جوهرية مشبعة، ومساحة سلبية نظيفة، وإضاءة استوديو عالية التباين.", image: require('@/assets/images/midjourney/55889f96-30d2-4032-9340-2d27090394e6.webp') }
                ],
                showcaseKicker: "أمثلة توضيحية",
                showcaseTitle: "أمثلة على مطالبات رحلة منتصف الطريق لتحسين صور الذكاء الاصطناعي",
                showcaseIntro: "استخدم أمثلة منتصف الرحلة هذه كنقطة انطلاق. صف موضوع المشهد، وحالته المزاجية، وإضاءته، وأسلوبه، ثم اختر \"واقعي\" أو \"أنيمي\" من اللوحة وأرسله إلى المُولِّد.",
                useCasesKicker: "مصمم للاستخدام العملي",
                useCasesTitle: "حالات استخدام شائعة في منتصف الرحلة",
                useCases: [
                    { name: "ميدجورني للرسومات المفاهيمية", desc: "قم ببناء الشخصيات، وعوالم الخيال، والتوجهات البصرية باستخدام الإضاءة والأجواء الموجهة فنياً." },
                    { name: "ميدجورني لتصميمات الصور الرئيسية والملصقات", desc: "ابتكر صورًا رئيسية جريئة للحملات الإعلانية، وملصقات، ورسومات توضيحية تحريرية ذات مظهر مصقول." },
                    { name: "ميدجورني لتصميمات المنتجات والعلامات التجارية", desc: "صمّم مفاهيم منتجات مميزة وصورًا لعلامتك التجارية، مسترشدًا بصور مرجعية لضمان التناسق." },
                    { name: "ميدجورني للصور الشخصية", desc: "قم بإنشاء صور سينمائية باستخدام الإضاءة الطبيعية أو حبيبات الفيلم أو تظليل الأنمي المميز." },
                    { name: "رحلة منتصف الطريق للأنمي والرسوم التوضيحية", desc: "انتقل إلى أسلوب الأنمي للحصول على خطوط معبرة وألوان جريئة وشخصيات مرسومة يدويًا." },
                    { name: "ميدجورني لمحتوى وسائل التواصل الاجتماعي", desc: "قم بإنتاج صور جذابة وقابلة للمشاركة للصفحات الرئيسية والصور المصغرة والمنشورات الإبداعية على مواقع التواصل الاجتماعي." }
                ],
                howToKicker: "ثلاثة بسيطة الخطوات",
                howToTitle: "كيفية استخدام مولد الصور بتقنية الذكاء الاصطناعي من Midjourney عبر الإنترنت",
                howToIntro: "استخدم مولد الصور بتقنية الذكاء الاصطناعي Midjourney عبر الإنترنت على منصة Miral مع موجه واضح، ونمط مختار، وصور مرجعية اختيارية.",
                howToSteps: [
                    { title: "وصف المشهد", desc: "اكتب وصفًا حيويًا يغطي الموضوع، والمكان، والمزاج، والإضاءة، والمظهر الفني الذي تريده." },
                    { title: "اختر النمط والمراجع", desc: "اختر \"واقعي\" أو \"أنيمي\" من اللوحة، ويمكنك اختيارياً تحميل ما يصل إلى خمس صور مرجعية لتوجيه المظهر." },
                    { title: "إنشاء وتحسين", desc: "ابدأ عملية الإنشاء، راجع النتيجة، وقم بتنزيل الصورة أو عدّل التعليمات والمراجع لإجراء عملية أخرى." }
                ],
                howToCta: "جرّب مُولّد الصور بالذكاء الاصطناعي من ميدجورني",
                faqTitle: "الأسئلة الشائعة حول ميدجورني",
                faqs: [
                    { q: "ما هو مولد الصور Midjourney AI؟", a: "يُعدّ Midjourney نموذجًا شائع الاستخدام لتحويل النصوص إلى صور، ويشتهر برسوماته الفنية السينمائية. على منصة Miral، يقوم مولد الصور المدعوم بالذكاء الاصطناعي من Midjourney بتحويل النصوص المكتوبة إلى صور جذابة تُستخدم في تصميم الرسومات المفاهيمية، واللوحات الرئيسية، والملصقات، والمحتوى التحريري، مباشرةً في متصفحك." },
                    { q: "ما الأداة التي يمكنني استخدامها لإنشاء رسومات مفاهيمية سينمائية باستخدام صور مرجعية؟", a: "يجمع استوديو Midjourney بين التوجيه الفني الغني والإضاءة الدرامية والأساليب الواقعية وأسلوب الأنمي، بالإضافة إلى توجيه الصور المرجعية للفن المفاهيمي السينمائي والصور الرئيسية وصور العلامة التجارية." },
                    { q: "هل يمكنني استخدام مولد الصور بتقنية الذكاء الاصطناعي من Midjourney مجاناً؟", a: "نعم. سجّل الآن لتحصل على رصيد مجاني وابدأ فوراً بإنشاء صور عالية الجودة باستخدام مولد الصور Midjourney AI. يتم استخدام الرصيد المخصص لإنشاء الصور." },
                    { q: "كيف أستخدم مولد الصور بتقنية الذكاء الاصطناعي من Midjourney عبر الإنترنت؟", a: "أدخل نصًا حيويًا يصف الموضوع، والمزاج، والإضاءة، والأسلوب، ثم اختر \"واقعي\" أو \"أنيمي\" من اللوحة، ويمكنك تحميل ما يصل إلى خمس صور مرجعية، ثم انقر على \"إنشاء\". يُعدّ Midjourney خيارًا مثاليًا للرسومات التصورية، والصور الرئيسية، والملصقات، والصور الشخصية، والرسوم التوضيحية التحريرية." },
                    { q: "ما الفرق بين الأسلوب الواقعي وأسلوب الأنمي؟", a: "يميل الأسلوب الواقعي إلى التركيز على التفاصيل الفوتوغرافية والإضاءة الطبيعية والملمس النابض بالحياة، بينما يفضل أسلوب الأنمي الخطوط الأنيقة والألوان الجريئة والمظهر المرسوم يدويًا. اختر الأسلوب الذي يناسبك من اللوحة، حتى تتمكن من التركيز على المشهد نفسه." },
                    { q: "كيف يمكنني إصلاح صور منتصف الرحلة التي لا تتطابق مع مرجعي؟", a: "قم بتحميل ما يصل إلى خمس صور مرجعية واضحة (PNG أو JPG أو JPEG أو WebP) وصف لوحة الألوان أو مظهر الشخصية أو شكل المنتج أو الجمالية العامة التي يجب أن تتبعها النتيجة." },
                    { q: "ما هي أفضل أمثلة على مُحفزات منتصف الرحلة؟", a: "تُقدّم مُوجّهات منتصف الرحلة الفعّالة وصفًا مُفصّلاً للموضوع، والمكان، والجو العام، والإضاءة، والأسلوب الفني، ثمّ تُقرن هذه المُوجّهات بالأسلوب المُناسب على اللوحة. استخدم أمثلة مُوجّهات منتصف الرحلة في هذه الصفحة كنقطة انطلاق، وعدّلها لتناسب مشروعك." },
                    { q: "Midjourney vs Stable Diffusion 3.5: أيهما يجب أن أستخدم؟", a: "اختر بناءً على سير العمل وليس على خيار واحد يناسب الجميع. يُعدّ Midjourney خيارًا مثاليًا للمفاهيم الفنية الموجهة، والإضاءة السينمائية، والمؤثرات البصرية المرجعية، مع أنماط واقعية وأنمي جاهزة على منصة Miral. أما Stable Diffusion 3.5 فقد يناسب المبدعين الذين يحتاجون إلى توجيهات سلبية واضحة ونسب عرض إلى ارتفاع مرنة مع أحجام مخصصة." }
                ],
                ctaTitle: "جرّب تطبيق Midjourney مجاناً على منصة Miral!",
                ctaDesc: "أدخل فكرتك أعلاه واستخدم مولد الصور بتقنية الذكاء الاصطناعي Midjourney مع أنماط واقعية أو أنمي وإرشادات الصور المرجعية لإنشاء صور فنية موجهة."
            }
        }
    }
}
